/**
 * Subscription, Dashboard & Home page translation keys.
 * ======================================================
 * Kept in a separate file from the main 24 000-line lang/index.js
 * to make subscription-related i18n easier to maintain.
 *
 * Locale order (must match lang/index.js supportedLocales):
 *   0  en-GB
 *   1  en-US
 *   2  jp-JP
 *   3  zh-CN
 *   4  de-DE
 *   5  fr-FR
 *   6  it-IT
 *   7  pt-PT
 *   8  es-ES
 *   9  ru-RU
 *  10  pl-PL
 *  11  key name (used as fallback)
 */

const subscriptionTranslations = {
  /* ──────────────────────────────────────────────────────
     Moved from lang/index.js (dashboard + terms + general)
     ────────────────────────────────────────────────────── */
  dashboard_title: [
    "Dashboard",
    "Dashboard",
    "ダッシュボード",
    "仪表板",
    "Dashboard",
    "Tableau de bord",
    "Pannello di controllo",
    "Painel de controle",
    "Tablero",
    "Панель мониторинга",
    "Pulpit",
    "dashboard_title"
  ],
  total_organisations: [
    "Organisations",
    "Organisations",
    "組織",
    "组织",
    "Organisationen",
    "Organisations",
    "Organizzazioni",
    "Organizações",
    "Organizaciones",
    "Организации",
    "Organizacje",
    "total_organisations"
  ],
  total_subscriptions: [
    "Subscriptions",
    "Subscriptions",
    "サブスクリプション",
    "订阅",
    "Abonnements",
    "Abonnements",
    "Abbonamenti",
    "Assinaturas",
    "Suscripciones",
    "Подписки",
    "Subskrypcje",
    "total_subscriptions"
  ],
  active_subscriptions: [
    "Active Subscriptions",
    "Active Subscriptions",
    "有効なサブスクリプション",
    "有效订阅",
    "Aktive Abonnements",
    "Abonnements actifs",
    "Abbonamenti attivi",
    "Assinaturas ativas",
    "Suscripciones activas",
    "Активные подписки",
    "Aktywne subskrypcje",
    "active_subscriptions"
  ],
  active_subscription: [
    "Active Subscription",
    "Active Subscription",
    "有効なサブスクリプション",
    "有效订阅",
    "Aktives Abonnement",
    "Abonnement actif",
    "Abbonamento attivo",
    "Assinatura ativa",
    "Suscripción activa",
    "Активная подписка",
    "Aktywna subskrypcja",
    "active_subscription"
  ],
  total_devices: [
    "Total Devices",
    "Total Devices",
    "デバイスの総数",
    "设备总数",
    "Gesamtzahl der Geräte",
    "Total des appareils",
    "Totale dispositivi",
    "Total de dispositivos",
    "Dispositivos totales",
    "Всего устройств",
    "Wszystkie urządzenia",
    "total_devices"
  ],
  monthly_revenue: [
    "Monthly Revenue",
    "Monthly Revenue",
    "月間収益",
    "月收入",
    "Monatlicher Umsatz",
    "Revenu mensuel",
    "Entrate mensili",
    "Receita mensal",
    "Ingresos mensuales",
    "Ежемесячный доход",
    "Miesięczny przychód",
    "monthly_revenue"
  ],
  organisations: [
    "Organisations",
    "Organisations",
    "組織",
    "组织",
    "Organisationen",
    "Organisations",
    "Organizzazioni",
    "Organizações",
    "Organizaciones",
    "Организации",
    "Organizacje",
    "organisations"
  ],
  subscriptions: [
    "Subscriptions",
    "Subscriptions",
    "サブスクリプション",
    "订阅",
    "Abonnements",
    "Abonnements",
    "Abbonamenti",
    "Assinaturas",
    "Suscripciones",
    "Подписки",
    "Subskrypcje",
    "subscriptions"
  ],
  contact_email: [
    "Contact Email",
    "Contact Email",
    "連絡先メールアドレス",
    "联系电子邮件",
    "Kontakt-E-Mail",
    "Email de contact",
    "Email di contatto",
    "E-mail de contato",
    "Correo electrónico de contacto",
    "Контактный адрес электронной почты",
    "E-mail kontaktowy",
    "contact_email"
  ],
  pricing_tier: [
    "Pricing Tier",
    "Pricing Tier",
    "料金プラン",
    "定价层",
    "Preisstufe",
    "Niveau de prix",
    "Livello di prezzo",
    "Nível de preços",
    "Nivel de precios",
    "Ценовой уровень",
    "Poziom cenowy",
    "pricing_tier"
  ],
  monthly_price: [
    "Monthly Price",
    "Monthly Price",
    "月額料金",
    "月费",
    "Monatlicher Preis",
    "Prix mensuel",
    "Prezzo mensile",
    "Preço mensal",
    "Precio mensual",
    "Ежемесячная цена",
    "Cena miesięczna",
    "monthly_price"
  ],
  period_end: [
    "Period End",
    "Period End",
    "期間終了",
    "周期结束",
    "Periodenende",
    "Fin de période",
    "Fine periodo",
    "Fim do período",
    "Fin del período",
    "Конец периода",
    "Koniec okresu",
    "period_end"
  ],
  subscription_details: [
    "Subscription Details",
    "Subscription Details",
    "サブスクリプションの詳細",
    "订阅详情",
    "Abonnementdetails",
    "Détails de l'abonnement",
    "Dettagli dell'abbonamento",
    "Detalhes da assinatura",
    "Detalles de la suscripción",
    "Подробности подписки",
    "Szczegóły subskrypcji",
    "subscription_details"
  ],
  billing_information: [
    "Billing Information",
    "Billing Information",
    "請求情報",
    "账单信息",
    "Rechnungsinformationen",
    "Informations de facturation",
    "Informazioni di fatturazione",
    "Informações de faturamento",
    "Información de facturación",
    "Платежная информация",
    "Informacje o rozliczeniach",
    "billing_information"
  ],
  device_count: [
    "Device Count",
    "Device Count",
    "デバイス数",
    "设备数量",
    "Geräteanzahl",
    "Nombre d'appareils",
    "Conteggio dispositivi",
    "Contagem de dispositivos",
    "Recuento de dispositivos",
    "Количество устройств",
    "Liczba urządzeń",
    "device_count"
  ],
  total_price: [
    "Total Price",
    "Total Price",
    "合計金額",
    "总价",
    "Gesamtpreis",
    "Prix total",
    "Prezzo totale",
    "Preço total",
    "Precio total",
    "Итоговая цена",
    "Cena całkowita",
    "total_price"
  ],
  discount_code: [
    "Discount Code",
    "Discount Code",
    "割引コード",
    "折扣码",
    "Rabattcode",
    "Code de réduction",
    "Codice sconto",
    "Código de desconto",
    "Código de descuento",
    "Код скидки",
    "Kod rabatowy",
    "discount_code"
  ],
  discount_amount: [
    "Discount Amount",
    "Discount Amount",
    "割引額",
    "折扣金额",
    "Rabattbetrag",
    "Montant de la remise",
    "Importo dello sconto",
    "Valor do desconto",
    "Importe del descuento",
    "Сумма скидки",
    "Kwota rabatu",
    "discount_amount"
  ],
  currency: [
    "Currency",
    "Currency",
    "通貨",
    "货币",
    "Währung",
    "Devise",
    "Valuta",
    "Moeda",
    "Moneda",
    "Валюта",
    "Waluta",
    "currency"
  ],
  dates: [
    "Dates",
    "Dates",
    "日付",
    "日期",
    "Daten",
    "Dates",
    "Date",
    "Datas",
    "Fechas",
    "Даты",
    "Daty",
    "dates"
  ],
  current_period_start: [
    "Current Period Start",
    "Current Period Start",
    "現在の期間の開始",
    "当前周期开始",
    "Aktueller Periodenbeginn",
    "Début de la période actuelle",
    "Inizio del periodo corrente",
    "Início do período atual",
    "Inicio del periodo actual",
    "Начало текущего периода",
    "Początek bieżącego okresu",
    "current_period_start"
  ],
  current_period_end: [
    "Current Period End",
    "Current Period End",
    "現在の期間の終了",
    "当前周期结束",
    "Aktuelles Periodenende",
    "Fin de la période actuelle",
    "Fine del periodo corrente",
    "Fim do período atual",
    "Fin del periodo actual",
    "Конец текущего периода",
    "Koniec bieżącego okresu",
    "current_period_end"
  ],
  canceled_at: [
    "Canceled At",
    "Canceled At",
    "キャンセル日時",
    "取消于",
    "Abgebrochen am",
    "Annulé le",
    "Annullato il",
    "Cancelado em",
    "Cancelado el",
    "Отменено в",
    "Anulowano o",
    "canceled_at"
  ],
  stripe_information: [
    "Stripe Information",
    "Stripe Information",
    "Stripe情報",
    "Stripe 信息",
    "Stripe-Informationen",
    "Informations Stripe",
    "Informazioni Stripe",
    "Informações do Stripe",
    "Información de Stripe",
    "Информация Stripe",
    "Informacje Stripe",
    "stripe_information"
  ],
  stripe_subscription_id: [
    "Stripe Subscription ID",
    "Stripe Subscription ID",
    "StripeサブスクリプションID",
    "Stripe 订阅 ID",
    "Stripe-Abonnement-ID",
    "ID d'abonnement Stripe",
    "ID abbonamento Stripe",
    "ID da assinatura do Stripe",
    "ID de suscripción de Stripe",
    "ID подписки Stripe",
    "ID subskrypcji Stripe",
    "stripe_subscription_id"
  ],
  stripe_customer_id: [
    "Stripe Customer ID",
    "Stripe Customer ID",
    "Stripe顧客ID",
    "Stripe 客户 ID",
    "Stripe-Kunden-ID",
    "ID client Stripe",
    "ID cliente Stripe",
    "ID do cliente Stripe",
    "ID de cliente de Stripe",
    "ID клиента Stripe",
    "ID klienta Stripe",
    "stripe_customer_id"
  ],
  record_information: [
    "Record Information",
    "Record Information",
    "レコード情報",
    "记录信息",
    "Datensatzinformationen",
    "Informations sur l'enregistrement",
    "Informazioni sul record",
    "Informações do registro",
    "Información del registro",
    "Информация о записи",
    "Informacje o rekordzie",
    "record_information"
  ],
  subscription_id: [
    "Subscription ID",
    "Subscription ID",
    "サブスクリプションID",
    "订阅 ID",
    "Abonnement-ID",
    "ID d'abonnement",
    "ID abbonamento",
    "ID da assinatura",
    "ID de suscripción",
    "ID подписки",
    "ID subskrypcji",
    "subscription_id"
  ],
  organisation_id: [
    "Organisation ID",
    "Organisation ID",
    "組織ID",
    "组织 ID",
    "Organisations-ID",
    "ID de l'organisation",
    "ID organizzazione",
    "ID da organização",
    "ID de organización",
    "ID организации",
    "ID organizacji",
    "organisation_id"
  ],
  organisation_details: [
    "Organisation Details",
    "Organisation Details",
    "組織の詳細",
    "组织详情",
    "Organisationsdetails",
    "Détails de l'organisation",
    "Dettagli organizzazione",
    "Detalhes da organização",
    "Detalles de la organización",
    "Сведения об организации",
    "Szczegóły organizacji",
    "organisation_details"
  ],
  created_date: [
    "Created Date",
    "Created Date",
    "作成日",
    "创建日期",
    "Erstellungsdatum",
    "Date de création",
    "Data di creazione",
    "Data de criação",
    "Fecha de creación",
    "Дата создания",
    "Data utworzenia",
    "created_date"
  ],
  modified_date: [
    "Modified Date",
    "Modified Date",
    "更新日",
    "修改日期",
    "Änderungsdatum",
    "Date de modification",
    "Data di modifica",
    "Data de modificação",
    "Fecha de modificación",
    "Дата изменения",
    "Data modyfikacji",
    "modified_date"
  ],
  event_logs: [
    "Event Logs",
    "Event Logs",
    "イベントログ",
    "事件日志",
    "Ereignisprotokolle",
    "Journaux d'événements",
    "Log eventi",
    "Logs de eventos",
    "Registros de eventos",
    "Журналы событий",
    "Dzienniki zdarzeń",
    "event_logs"
  ],
  no_event_logs: [
    "No event logs available",
    "No event logs available",
    "利用可能なイベントログはありません",
    "没有可用的事件日志",
    "Keine Ereignisprotokolle verfügbar",
    "Aucun journal d'événements disponible",
    "Nessun log eventi disponibile",
    "Nenhum log de evento disponível",
    "No hay registros de eventos disponibles",
    "Журналы событий отсутствуют",
    "Brak dostępnych dzienników zdarzeń",
    "no_event_logs"
  ],
  general_actions: [
    "Actions",
    "Actions",
    "アクション",
    "操作",
    "Aktionen",
    "Actions",
    "Azioni",
    "Ações",
    "Acciones",
    "Действия",
    "Działania",
    "general_actions"
  ],
  general_date: [
    "Date",
    "Date",
    "日付",
    "日期",
    "Datum",
    "Date",
    "Data",
    "Data",
    "Fecha",
    "Дата",
    "Data",
    "general_date"
  ],
  general_information: [
    "General Information",
    "General Information",
    "一般情報",
    "一般信息",
    "Allgemeine Informationen",
    "Informations générales",
    "Informazioni generali",
    "Informações Gerais",
    "Información General",
    "Общая информация",
    "Informacje ogólne",
    "general_information"
  ],
  feature_flags: [
    "Feature Flags",
    "Feature Flags",
    "機能フラグ",
    "功能标志",
    "Feature-Flaggen",
    "Drapeaux de fonction",
    "Flag di funzione",
    "Sinalizadores de funcionalidade",
    "Banderas de funcionalidad",
    "Флаги функций",
    "Flagi funkcji",
    "feature_flags"
  ],
  general_event: [
    "Event",
    "Event",
    "イベント",
    "事件",
    "Ereignis",
    "Événement",
    "Evento",
    "Evento",
    "Evento",
    "Событие",
    "Zdarzenie",
    "general_event"
  ],
  general_start_date: [
    "Start Date",
    "Start Date",
    "開始日",
    "开始日期",
    "Startdatum",
    "Date de début",
    "Data di inizio",
    "Data de início",
    "Fecha de inicio",
    "Дата начала",
    "Data rozpoczęcia",
    "general_start_date"
  ],
  terms_acceptance_logs: [
    "Terms Acceptance Logs",
    "Terms Acceptance Logs",
    "利用規約受け入れログ",
    "条款接受日志",
    "Allgemeine Geschäftsbedingungen Annahmefrist",
    "Journaux d'acceptation des conditions",
    "Log di accettazione dei termini",
    "Registros de aceitação dos termos",
    "Registros de aceptación de términos",
    "Журналы принятия условий",
    "Dzienniki akceptacji warunków",
    "terms_acceptance_logs"
  ],
  accepted_by: [
    "Accepted By",
    "Accepted By",
    "以下で受け入れられました",
    "被接受",
    "Akzeptiert von",
    "Accepté par",
    "Accettato da",
    "Aceito por",
    "Aceptado por",
    "Принято",
    "Zaakceptował",
    "accepted_by"
  ],
  terms_version: [
    "Terms Version",
    "Terms Version",
    "利用規約バージョン",
    "条款版本",
    "Bedingungen Version",
    "Version des conditions",
    "Versione dei termini",
    "Versão dos termos",
    "Versión de términos",
    "Версия условий",
    "Wersja warunków",
    "terms_version"
  ],

  /* ──────────────────────────────────────────────────────
     Admin Dashboard — page-level
     ────────────────────────────────────────────────────── */
  admin_dashboard: [
    "Admin Dashboard", "Admin Dashboard", "管理ダッシュボード", "管理仪表板",
    "Admin-Dashboard", "Tableau de bord admin", "Pannello amministratore", "Painel do administrador",
    "Panel de administración", "Панель администратора", "Panel administratora", "admin_dashboard"
  ],
  quick_actions: [
    "Quick Actions", "Quick Actions", "クイックアクション", "快速操作",
    "Schnellaktionen", "Actions rapides", "Azioni rapide", "Ações rápidas",
    "Acciones rápidas", "Быстрые действия", "Szybkie akcje", "quick_actions"
  ],
  refresh: [
    "Refresh", "Refresh", "更新", "刷新",
    "Aktualisieren", "Actualiser", "Aggiorna", "Atualizar",
    "Actualizar", "Обновить", "Odśwież", "refresh"
  ],
  refreshing: [
    "Refreshing", "Refreshing", "更新中", "正在刷新",
    "Aktualisierung", "Actualisation", "Aggiornamento", "Atualizando",
    "Actualizando", "Обновление", "Odświeżanie", "refreshing"
  ],
  view_organisations: [
    "View Organisations", "View Organizations", "組織を表示", "查看组织",
    "Organisationen anzeigen", "Voir les organisations", "Visualizza organizzazioni", "Ver organizações",
    "Ver organizaciones", "Просмотр организаций", "Zobacz organizacje", "view_organisations"
  ],
  manage_all_organisations: [
    "Manage all organisations", "Manage all organizations", "すべての組織を管理", "管理所有组织",
    "Alle Organisationen verwalten", "Gérer toutes les organisations", "Gestisci tutte le organizzazioni", "Gerenciar todas as organizações",
    "Gestionar todas las organizaciones", "Управление всеми организациями", "Zarządzaj wszystkimi organizacjami", "manage_all_organisations"
  ],
  view_subscriptions: [
    "View Subscriptions", "View Subscriptions", "サブスクリプションを表示", "查看订阅",
    "Abonnements anzeigen", "Voir les abonnements", "Visualizza abbonamenti", "Ver assinaturas",
    "Ver suscripciones", "Просмотр подписок", "Zobacz subskrypcje", "view_subscriptions"
  ],
  manage_subscriptions: [
    "Manage subscriptions", "Manage subscriptions", "サブスクリプションを管理", "管理订阅",
    "Abonnements verwalten", "Gérer les abonnements", "Gestisci abbonamenti", "Gerenciar assinaturas",
    "Gestionar suscripciones", "Управление подписками", "Zarządzaj subskrypcjami", "manage_subscriptions"
  ],
  all_jobs: [
    "All Jobs", "All Jobs", "すべてのジョブ", "所有任务",
    "Alle Aufträge", "Tous les travaux", "Tutti i lavori", "Todos os trabalhos",
    "Todos los trabajos", "Все задания", "Wszystkie zadania", "all_jobs"
  ],
  view_manage_all_jobs: [
    "View and manage all jobs", "View and manage all jobs", "すべてのジョブを表示・管理", "查看和管理所有任务",
    "Alle Aufträge anzeigen und verwalten", "Voir et gérer tous les travaux", "Visualizza e gestisci tutti i lavori", "Ver e gerenciar todos os trabalhos",
    "Ver y gestionar todos los trabajos", "Просмотр и управление всеми заданиями", "Zobacz i zarządzaj wszystkimi zadaniami", "view_manage_all_jobs"
  ],
  all_devices: [
    "All Devices", "All Devices", "すべてのデバイス", "所有设备",
    "Alle Geräte", "Tous les appareils", "Tutti i dispositivi", "Todos os dispositivos",
    "Todos los dispositivos", "Все устройства", "Wszystkie urządzenia", "all_devices"
  ],
  view_manage_all_devices: [
    "View and manage all devices", "View and manage all devices", "すべてのデバイスを表示・管理", "查看和管理所有设备",
    "Alle Geräte anzeigen und verwalten", "Voir et gérer tous les appareils", "Visualizza e gestisci tutti i dispositivi", "Ver e gerenciar todos os dispositivos",
    "Ver y gestionar todos los dispositivos", "Просмотр и управление всеми устройствами", "Zobacz i zarządzaj wszystkimi urządzeniami", "view_manage_all_devices"
  ],
  manage_user_accounts: [
    "Manage user accounts", "Manage user accounts", "ユーザーアカウントを管理", "管理用户账户",
    "Benutzerkonten verwalten", "Gérer les comptes utilisateurs", "Gestisci account utente", "Gerenciar contas de utilizadores",
    "Gestionar cuentas de usuario", "Управление учётными записями", "Zarządzaj kontami użytkowników", "manage_user_accounts"
  ],
  organisation_metrics_label: [
    "Organisation Metrics", "Organization Metrics", "組織メトリクス", "组织指标",
    "Organisationsmetriken", "Métriques d'organisation", "Metriche organizzazione", "Métricas da organização",
    "Métricas de organización", "Метрики организации", "Metryki organizacji", "organisation_metrics_label"
  ],
  view_metrics_analytics: [
    "View metrics and analytics", "View metrics and analytics", "メトリクスと分析を表示", "查看指标和分析",
    "Metriken und Analysen anzeigen", "Voir les métriques et analyses", "Visualizza metriche e analisi", "Ver métricas e análises",
    "Ver métricas y análisis", "Просмотр метрик и аналитики", "Zobacz metryki i analizy", "view_metrics_analytics"
  ],
  smart_flags_label: [
    "Smart Flags", "Smart Flags", "スマートフラグ", "智能标记",
    "Smart Flags", "Smart Flags", "Smart Flags", "Smart Flags",
    "Smart Flags", "Умные флаги", "Smart Flagi", "smart_flags_label"
  ],
  manage_feature_flags: [
    "Manage feature flags", "Manage feature flags", "機能フラグを管理", "管理功能标记",
    "Feature-Flags verwalten", "Gérer les indicateurs de fonctionnalités", "Gestisci flag funzionalità", "Gerenciar flags de funcionalidades",
    "Gestionar indicadores de funciones", "Управление флагами функций", "Zarządzaj flagami funkcji", "manage_feature_flags"
  ],
  job_logs: [
    "Job Logs", "Job Logs", "ジョブログ", "任务日志",
    "Auftragsprotokoll", "Journaux des travaux", "Log dei lavori", "Logs de trabalhos",
    "Registros de trabajos", "Журналы заданий", "Logi zadań", "job_logs"
  ],
  background_job_history: [
    "Background job history", "Background job history", "バックグラウンドジョブ履歴", "后台任务历史",
    "Hintergrund-Auftragsverlauf", "Historique des travaux en arrière-plan", "Cronologia lavori in background", "Histórico de trabalhos em segundo plano",
    "Historial de trabajos en segundo plano", "История фоновых заданий", "Historia zadań w tle", "background_job_history"
  ],
  system_settings: [
    "System Settings", "System Settings", "システム設定", "系统设置",
    "Systemeinstellungen", "Paramètres du système", "Impostazioni di sistema", "Definições do sistema",
    "Configuración del sistema", "Системные настройки", "Ustawienia systemu", "system_settings"
  ],
  configure_system_settings: [
    "Configure system settings", "Configure system settings", "システム設定を構成", "配置系统设置",
    "Systemeinstellungen konfigurieren", "Configurer les paramètres du système", "Configura impostazioni di sistema", "Configurar definições do sistema",
    "Configurar ajustes del sistema", "Настройка параметров системы", "Konfiguruj ustawienia systemu", "configure_system_settings"
  ],
  settings: [
    "Settings", "Settings", "設定", "设置",
    "Einstellungen", "Paramètres", "Impostazioni", "Definições",
    "Configuración", "Настройки", "Ustawienia", "settings"
  ],
  total: [
    "Total", "Total", "合計", "总计",
    "Gesamt", "Total", "Totale", "Total",
    "Total", "Всего", "Razem", "total"
  ],
  active: [
    "Active", "Active", "有効", "有效",
    "Aktiv", "Actif", "Attivo", "Ativo",
    "Activo", "Активный", "Aktywny", "active"
  ],
  view: [
    "View", "View", "表示", "查看",
    "Anzeigen", "Voir", "Visualizza", "Ver",
    "Ver", "Просмотр", "Wyświetl", "view"
  ],
  revenue: [
    "Revenue", "Revenue", "収益", "收入",
    "Umsatz", "Revenu", "Entrate", "Receita",
    "Ingresos", "Доход", "Przychód", "revenue"
  ],
  this_month: [
    "This Month", "This Month", "今月", "本月",
    "Diesen Monat", "Ce mois-ci", "Questo mese", "Este mês",
    "Este mes", "Этот месяц", "Ten miesiąc", "this_month"
  ],
  /* ──────────────────────────────────────────────────────
     Home — page-level
     ────────────────────────────────────────────────────── */
  welcome_back: [
    "Welcome back", "Welcome back", "おかえりなさい", "欢迎回来",
    "Willkommen zurück", "Bienvenue", "Bentornato", "Bem-vindo de volta",
    "Bienvenido de nuevo", "С возвращением", "Witaj ponownie", "welcome_back"
  ],
  jobs_tests: [
    "Jobs", "Jobs", "ジョブ", "任务",
    "Aufträge", "Travaux", "Lavori", "Trabalhos",
    "Trabajos", "Задания", "Zadania", "jobs_tests"
  ],
  alerts: [
    "Alerts", "Alerts", "アラート", "警报",
    "Warnungen", "Alertes", "Avvisi", "Alertas",
    "Alertas", "Оповещения", "Alerty", "alerts"
  ],
  failed_tests: [
    "Failed Tests", "Failed Tests", "失敗テスト", "失败测试",
    "Fehlgeschlagene Tests", "Tests échoués", "Test falliti", "Testes falhados",
    "Pruebas fallidas", "Неудачные тесты", "Nieudane testy", "failed_tests"
  ],
  recent_jobs: [
    "Recent Jobs", "Recent Jobs", "最近のジョブ", "最近的任务",
    "Letzte Aufträge", "Travaux récents", "Lavori recenti", "Trabalhos recentes",
    "Trabajos recientes", "Недавние задания", "Ostatnie zadania", "recent_jobs"
  ],
  devices: [
    "Devices", "Devices", "デバイス", "设备",
    "Geräte", "Appareils", "Dispositivi", "Dispositivos",
    "Dispositivos", "Устройства", "Urządzenia", "devices"
  ],
  no_recent_jobs_found: [
    "No recent jobs found", "No recent jobs found", "最近のジョブが見つかりません", "未找到最近的任务",
    "Keine aktuellen Aufträge gefunden", "Aucun travail récent trouvé", "Nessun lavoro recente trovato", "Nenhum trabalho recente encontrado",
    "No se encontraron trabajos recientes", "Недавние задания не найдены", "Nie znaleziono ostatnich zadań", "no_recent_jobs_found"
  ],
  no_devices_found: [
    "No devices found", "No devices found", "デバイスが見つかりません", "未找到设备",
    "Keine Geräte gefunden", "Aucun appareil trouvé", "Nessun dispositivo trovato", "Nenhum dispositivo encontrado",
    "No se encontraron dispositivos", "Устройства не найдены", "Nie znaleziono urządzeń", "no_devices_found"
  ],
  loading_devices: [
    "Loading devices", "Loading devices", "デバイスを読み込み中", "正在加载设备",
    "Geräte werden geladen", "Chargement des appareils", "Caricamento dispositivi", "A carregar dispositivos",
    "Cargando dispositivos", "Загрузка устройств", "Ładowanie urządzeń", "loading_devices"
  ],
  view_by: [
    "View By", "View By", "表示方法", "查看方式",
    "Anzeigen nach", "Voir par", "Visualizza per", "Ver por",
    "Ver por", "Просмотр по", "Wyświetl wg", "view_by"
  ],
  search_filter_jobs: [
    "Search and filter jobs", "Search and filter jobs", "ジョブを検索・フィルタ", "搜索和筛选任务",
    "Aufträge suchen und filtern", "Rechercher et filtrer les travaux", "Cerca e filtra lavori", "Pesquisar e filtrar trabalhos",
    "Buscar y filtrar trabajos", "Поиск и фильтр заданий", "Wyszukaj i filtruj zadania", "search_filter_jobs"
  ],
  services: [
    "Services", "Services", "サービス", "服务",
    "Dienste", "Services", "Servizi", "Serviços",
    "Servicios", "Услуги", "Usługi", "services"
  ],
  browse_services: [
    "Browse available services", "Browse available services", "利用可能なサービスを参照", "浏览可用服务",
    "Verfügbare Dienste durchsuchen", "Parcourir les services disponibles", "Sfoglia i servizi disponibili", "Procurar serviços disponíveis",
    "Explorar servicios disponibles", "Обзор доступных услуг", "Przeglądaj dostępne usługi", "browse_services"
  ],
  shop: [
    "Shop", "Shop", "ショップ", "商店",
    "Shop", "Boutique", "Negozio", "Loja",
    "Tienda", "Магазин", "Sklep", "shop"
  ],
  browse_purchase: [
    "Browse and purchase items", "Browse and purchase items", "商品を閲覧・購入", "浏览和购买商品",
    "Artikel durchsuchen und kaufen", "Parcourir et acheter des articles", "Sfoglia e acquista articoli", "Procurar e comprar itens",
    "Explorar y comprar artículos", "Просмотр и покупка товаров", "Przeglądaj i kupuj przedmioty", "browse_purchase"
  ],
  help: [
    "Help", "Help", "ヘルプ", "帮助",
    "Hilfe", "Aide", "Aiuto", "Ajuda",
    "Ayuda", "Помощь", "Pomoc", "help"
  ],
  get_support_docs: [
    "Get support and documentation", "Get support and documentation", "サポートとドキュメントを入手", "获取支持和文档",
    "Support und Dokumentation", "Obtenir de l'aide et la documentation", "Ottieni supporto e documentazione", "Obter suporte e documentação",
    "Obtener soporte y documentación", "Получить поддержку и документацию", "Uzyskaj wsparcie i dokumentację", "get_support_docs"
  ],
  product_manuals: [
    "Product Manuals", "Product Manuals", "製品マニュアル", "产品手册",
    "Produkthandbücher", "Manuels produit", "Manuali prodotto", "Manuais do produto",
    "Manuales de producto", "Руководства по продуктам", "Instrukcje produktów", "product_manuals"
  ],
  download_product_manuals: [
    "Download product manuals", "Download product manuals", "製品マニュアルをダウンロード", "下载产品手册",
    "Produkthandbücher herunterladen", "Télécharger les manuels produit", "Scarica manuali prodotto", "Transferir manuais do produto",
    "Descargar manuales de producto", "Скачать руководства по продуктам", "Pobierz instrukcje produktów", "download_product_manuals"
  ],
  trend_academy: [
    "TREND Academy", "TREND Academy", "TREND Academy", "TREND Academy",
    "TREND Academy", "TREND Academy", "TREND Academy", "TREND Academy",
    "TREND Academy", "TREND Academy", "TREND Academy", "trend_academy"
  ],
  trend_academy_description: [
    "Training and learning portal", "Training and learning portal", "トレーニングと学習ポータル", "培训和学习门户",
    "Schulungs- und Lernportal", "Portail de formation", "Portale formazione", "Portal de formação",
    "Portal de formación", "Портал обучения", "Portal szkoleniowy", "trend_academy_description"
  ],

  /* ──────────────────────────────────────────────────────
     Subscription Management — page-level
     ────────────────────────────────────────────────────── */
  subscription_management: [
    "Subscription Management", "Subscription Management", "サブスクリプション管理", "订阅管理",
    "Abonnementverwaltung", "Gestion des abonnements", "Gestione abbonamenti", "Gestão de assinaturas",
    "Gestión de suscripciones", "Управление подписками", "Zarządzanie subskrypcjami", "subscription_management"
  ],
  subscription_management_desc: [
    "Configure subscription tiers, features, pricing, and checkout countries.",
    "Configure subscription tiers, features, pricing, and checkout countries.",
    "サブスクリプションのティア、機能、価格、チェックアウト国を設定します。",
    "配置订阅层级、功能、定价和结账国家。",
    "Konfigurieren Sie Abonnementstufen, Funktionen, Preise und Checkout-Länder.",
    "Configurez les niveaux d'abonnement, les fonctionnalités, les tarifs et les pays de paiement.",
    "Configura i livelli di abbonamento, le funzionalità, i prezzi e i paesi di checkout.",
    "Configure os níveis de assinatura, funcionalidades, preços e países de checkout.",
    "Configure los niveles de suscripción, funciones, precios y países de pago.",
    "Настройте уровни подписки, функции, цены и страны оформления.",
    "Skonfiguruj poziomy subskrypcji, funkcje, ceny i kraje kasowe.",
    "subscription_management_desc"
  ],
  subscription_tiers: [
    "Subscription Tiers", "Subscription Tiers", "サブスクリプションティア", "订阅层级",
    "Abonnementstufen", "Niveaux d'abonnement", "Livelli di abbonamento", "Níveis de assinatura",
    "Niveles de suscripción", "Уровни подписки", "Poziomy subskrypcji", "subscription_tiers"
  ],
  checkout_countries: [
    "Checkout Countries", "Checkout Countries", "チェックアウト国", "结账国家",
    "Checkout-Länder", "Pays de paiement", "Paesi di checkout", "Países de checkout",
    "Países de pago", "Страны оформления", "Kraje kasowe", "checkout_countries"
  ],
  countries_currencies: [
    "Countries & Currencies", "Countries & Currencies", "国と通貨", "国家和货币",
    "Länder & Währungen", "Pays et devises", "Paesi e valute", "Países e moedas",
    "Países y monedas", "Страны и валюты", "Kraje i waluty", "countries_currencies"
  ],
  tier_key: [
    "Tier Key", "Tier Key", "ティアキー", "层级键",
    "Stufenschlüssel", "Clé du niveau", "Chiave livello", "Chave do nível",
    "Clave de nivel", "Ключ уровня", "Klucz poziomu", "tier_key"
  ],
  stripe_product_name: [
    "Stripe Product Name", "Stripe Product Name", "Stripe製品名", "Stripe产品名称",
    "Stripe-Produktname", "Nom du produit Stripe", "Nome prodotto Stripe", "Nome do produto Stripe",
    "Nombre del producto Stripe", "Название продукта Stripe", "Nazwa produktu Stripe", "stripe_product_name"
  ],
  stripe_product_id: [
    "Stripe Product ID (read-only)", "Stripe Product ID (read-only)", "Stripe製品ID（読み取り専用）", "Stripe产品ID（只读）",
    "Stripe-Produkt-ID (schreibgeschützt)", "ID produit Stripe (lecture seule)", "ID prodotto Stripe (sola lettura)", "ID do produto Stripe (apenas leitura)",
    "ID de producto Stripe (solo lectura)", "ID продукта Stripe (только чтение)", "ID produktu Stripe (tylko do odczytu)", "stripe_product_id"
  ],
  sort_order: [
    "Sort Order", "Sort Order", "並び順", "排序",
    "Sortierreihenfolge", "Ordre de tri", "Ordine", "Ordem",
    "Orden", "Порядок сортировки", "Kolejność sortowania", "sort_order"
  ],
  new_tier: [
    "New Tier", "New Tier", "新しいティア", "新层级",
    "Neue Stufe", "Nouveau niveau", "Nuovo livello", "Novo nível",
    "Nuevo nivel", "Новый уровень", "Nowy poziom", "new_tier"
  ],
  new_country: [
    "New Country", "New Country", "新しい国", "新国家",
    "Neues Land", "Nouveau pays", "Nuovo paese", "Novo país",
    "Nuevo país", "Новая страна", "Nowy kraj", "new_country"
  ],
  add_currency: [
    "Add Currency", "Add Currency", "通貨を追加", "添加货币",
    "Währung hinzufügen", "Ajouter une devise", "Aggiungi valuta", "Adicionar moeda",
    "Añadir moneda", "Добавить валюту", "Dodaj walutę", "add_currency"
  ],
  edit: [
    "Edit", "Edit", "編集", "编辑",
    "Bearbeiten", "Modifier", "Modifica", "Editar",
    "Editar", "Редактировать", "Edytuj", "edit"
  ],
  features: [
    "Features", "Features", "機能", "功能",
    "Funktionen", "Fonctionnalités", "Funzionalità", "Funcionalidades",
    "Funciones", "Функции", "Funkcje", "features"
  ],
  pricing: [
    "Pricing", "Pricing", "価格設定", "定价",
    "Preise", "Tarification", "Prezzi", "Preços",
    "Precios", "Цены", "Ceny", "pricing"
  ],
  save: [
    "Save", "Save", "保存", "保存",
    "Speichern", "Enregistrer", "Salva", "Guardar",
    "Guardar", "Сохранить", "Zapisz", "save"
  ],
  cancel: [
    "Cancel", "Cancel", "キャンセル", "取消",
    "Abbrechen", "Annuler", "Annulla", "Cancelar",
    "Cancelar", "Отмена", "Anuluj", "cancel"
  ],
  remove: [
    "Remove", "Remove", "削除", "移除",
    "Entfernen", "Retirer", "Rimuovi", "Remover",
    "Eliminar", "Удалить", "Usuń", "remove"
  ],
  save_features: [
    "Save Features", "Save Features", "機能を保存", "保存功能",
    "Funktionen speichern", "Enregistrer les fonctionnalités", "Salva funzionalità", "Guardar funcionalidades",
    "Guardar funciones", "Сохранить функции", "Zapisz funkcje", "save_features"
  ],
  save_pricing: [
    "Save Pricing", "Save Pricing", "価格を保存", "保存定价",
    "Preise speichern", "Enregistrer les tarifs", "Salva prezzi", "Guardar preços",
    "Guardar precios", "Сохранить цены", "Zapisz ceny", "save_pricing"
  ],
  save_currencies: [
    "Save Currencies", "Save Currencies", "通貨を保存", "保存货币",
    "Währungen speichern", "Enregistrer les devises", "Salva valute", "Guardar moedas",
    "Guardar monedas", "Сохранить валюты", "Zapisz waluty", "save_currencies"
  ],
  saving: [
    "Saving", "Saving", "保存中", "正在保存",
    "Speichern", "Enregistrement", "Salvataggio", "A guardar",
    "Guardando", "Сохранение", "Zapisywanie", "saving"
  ],
  loading: [
    "Loading", "Loading", "読み込み中", "正在加载",
    "Laden", "Chargement", "Caricamento", "A carregar",
    "Cargando", "Загрузка", "Ładowanie", "loading"
  ],
  loading_tiers: [
    "Loading tiers", "Loading tiers", "ティアを読み込み中", "正在加载层级",
    "Stufen werden geladen", "Chargement des niveaux", "Caricamento livelli", "A carregar níveis",
    "Cargando niveles", "Загрузка уровней", "Ładowanie poziomów", "loading_tiers"
  ],
  loading_countries: [
    "Loading countries", "Loading countries", "国を読み込み中", "正在加载国家",
    "Länder werden geladen", "Chargement des pays", "Caricamento paesi", "A carregar países",
    "Cargando países", "Загрузка стран", "Ładowanie krajów", "loading_countries"
  ],
  not_created: [
    "Not created", "Not created", "未作成", "未创建",
    "Nicht erstellt", "Non créé", "Non creato", "Não criado",
    "No creado", "Не создано", "Nie utworzono", "not_created"
  ],
  no_tiers_configured: [
    "No tiers configured", "No tiers configured", "ティアが設定されていません", "未配置层级",
    "Keine Stufen konfiguriert", "Aucun niveau configuré", "Nessun livello configurato", "Nenhum nível configurado",
    "No hay niveles configurados", "Уровни не настроены", "Nie skonfigurowano poziomów", "no_tiers_configured"
  ],
  no_countries_configured: [
    "No countries configured", "No countries configured", "国が設定されていません", "未配置国家",
    "Keine Länder konfiguriert", "Aucun pays configuré", "Nessun paese configurato", "Nenhum país configurado",
    "No hay países configurados", "Страны не настроены", "Nie skonfigurowano krajów", "no_countries_configured"
  ],
  country_code_2_letter: [
    "Country Code (2-letter)", "Country Code (2-letter)", "国コード（2文字）", "国家代码（2位字母）",
    "Ländercode (2 Buchstaben)", "Code pays (2 lettres)", "Codice paese (2 lettere)", "Código do país (2 letras)",
    "Código de país (2 letras)", "Код страны (2 буквы)", "Kod kraju (2 litery)", "country_code_2_letter"
  ],
  country_name: [
    "Country Name", "Country Name", "国名", "国家名称",
    "Ländername", "Nom du pays", "Nome del paese", "Nome do país",
    "Nombre del país", "Название страны", "Nazwa kraju", "country_name"
  ],
  default_label: [
    "Default", "Default", "デフォルト", "默认",
    "Standard", "Par défaut", "Predefinito", "Padrão",
    "Predeterminado", "По умолчанию", "Domyślny", "default_label"
  ],
  preview: [
    "Preview", "Preview", "プレビュー", "预览",
    "Vorschau", "Aperçu", "Anteprima", "Pré-visualização",
    "Vista previa", "Предварительный просмотр", "Podgląd", "preview"
  ],
  key: [
    "Key", "Key", "キー", "键",
    "Schlüssel", "Clé", "Chiave", "Chave",
    "Clave", "Ключ", "Klucz", "key"
  ],
  code: [
    "Code", "Code", "コード", "代码",
    "Code", "Code", "Codice", "Código",
    "Código", "Код", "Kod", "code"
  ],
  sort: [
    "Sort", "Sort", "並べ替え", "排序",
    "Sortieren", "Trier", "Ordina", "Ordenar",
    "Ordenar", "Сортировка", "Sortuj", "sort"
  ],
  currencies: [
    "Currencies", "Currencies", "通貨", "货币",
    "Währungen", "Devises", "Valute", "Moedas",
    "Monedas", "Валюты", "Waluty", "currencies"
  ],
  actions: [
    "Actions", "Actions", "アクション", "操作",
    "Aktionen", "Actions", "Azioni", "Ações",
    "Acciones", "Действия", "Akcje", "actions"
  ],

  /* ── Validation / confirmation messages ── */
  tier_key_required: [
    "Tier key is required", "Tier key is required", "ティアキーは必須です", "层级键为必填项",
    "Stufenschlüssel ist erforderlich", "La clé du niveau est requise", "La chiave del livello è obbligatoria", "A chave do nível é obrigatória",
    "La clave de nivel es obligatoria", "Ключ уровня обязателен", "Klucz poziomu jest wymagany", "tier_key_required"
  ],
  tier_name_required: [
    "Name is required", "Name is required", "名前は必須です", "名称为必填项",
    "Name ist erforderlich", "Le nom est requis", "Il nome è obbligatorio", "O nome é obrigatório",
    "El nombre es obligatorio", "Название обязательно", "Nazwa jest wymagana", "tier_name_required"
  ],
  stripe_product_name_required: [
    "Stripe product name is required", "Stripe product name is required", "Stripe製品名は必須です", "Stripe产品名称为必填项",
    "Stripe-Produktname ist erforderlich", "Le nom du produit Stripe est requis", "Il nome del prodotto Stripe è obbligatorio", "O nome do produto Stripe é obrigatório",
    "El nombre del producto Stripe es obligatorio", "Название продукта Stripe обязательно", "Nazwa produktu Stripe jest wymagana", "stripe_product_name_required"
  ],
  confirm_delete_tier: [
    "Are you sure you want to delete this tier?",
    "Are you sure you want to delete this tier?",
    "このティアを削除してもよろしいですか？",
    "您确定要删除此层级吗？",
    "Möchten Sie diese Stufe wirklich löschen?",
    "Êtes-vous sûr de vouloir supprimer ce niveau ?",
    "Sei sicuro di voler eliminare questo livello?",
    "Tem certeza de que deseja eliminar este nível?",
    "¿Está seguro de que desea eliminar este nivel?",
    "Вы уверены, что хотите удалить этот уровень?",
    "Czy na pewno chcesz usunąć ten poziom?",
    "confirm_delete_tier"
  ],
  confirm_delete_country: [
    "Are you sure you want to delete this country?",
    "Are you sure you want to delete this country?",
    "この国を削除してもよろしいですか？",
    "您确定要删除此国家吗？",
    "Möchten Sie dieses Land wirklich löschen?",
    "Êtes-vous sûr de vouloir supprimer ce pays ?",
    "Sei sicuro di voler eliminare questo paese?",
    "Tem certeza de que deseja eliminar este país?",
    "¿Está seguro de que desea eliminar este país?",
    "Вы уверены, что хотите удалить эту страну?",
    "Czy na pewno chcesz usunąć ten kraj?",
    "confirm_delete_country"
  ],

  /* ── Device pricing categories (used in pricing tables) ── */
  one_device_yearly: [
    "1 Device (monthly)", "1 Device (monthly)", "1台（月額）", "1台设备（月度）",
    "1 Gerät (monatlich)", "1 appareil (mensuel)", "1 dispositivo (mensile)", "1 dispositivo (mensal)",
    "1 dispositivo (mensual)", "1 устройство (месяц)", "1 urządzenie (miesięcznie)", "one_device_yearly"
  ],
  two_to_five_devices_yearly: [
    "2-5 Devices (monthly each)", "2-5 Devices (monthly each)", "2-5台（月額/台）", "2-5台设备（每台/月）",
    "2-5 Geräte (monatlich je)", "2-5 appareils (mensuel ch.)", "2-5 dispositivi (mensile cad.)", "2-5 dispositivos (mensal cada)",
    "2-5 dispositivos (mensual c/u)", "2-5 устройств (месяц/шт.)", "2-5 urządzeń (miesięcznie/szt.)", "two_to_five_devices_yearly"
  ],
  six_plus_devices_yearly: [
    "6 or More Devices (monthly each)", "6 or More Devices (monthly each)", "6台以上（月額/台）", "6台或以上设备（每台/月）",
    "6 oder mehr Geräte (monatlich je)", "6 appareils ou plus (mensuel ch.)", "6 o più dispositivi (mensile cad.)", "6 ou mais dispositivos (mensal cada)",
    "6 o más dispositivos (mensual c/u)", "6 или более устройств (месяц/шт.)", "6 lub więcej urządzeń (miesięcznie/szt.)", "six_plus_devices_yearly"
  ],

  /* ── Subscription management success/error messages ── */
  tier_created: [
    "Tier created successfully", "Tier created successfully", "ティアが正常に作成されました", "层级创建成功",
    "Stufe erfolgreich erstellt", "Niveau créé avec succès", "Livello creato con successo", "Nível criado com sucesso",
    "Nivel creado con éxito", "Уровень успешно создан", "Poziom utworzony pomyślnie", "tier_created"
  ],
  tier_updated: [
    "Tier updated successfully", "Tier updated successfully", "ティアが正常に更新されました", "层级更新成功",
    "Stufe erfolgreich aktualisiert", "Niveau mis à jour avec succès", "Livello aggiornato con successo", "Nível atualizado com sucesso",
    "Nivel actualizado con éxito", "Уровень успешно обновлён", "Poziom zaktualizowany pomyślnie", "tier_updated"
  ],
  tier_deleted: [
    "Tier deleted successfully", "Tier deleted successfully", "ティアが正常に削除されました", "层级删除成功",
    "Stufe erfolgreich gelöscht", "Niveau supprimé avec succès", "Livello eliminato con successo", "Nível eliminado com sucesso",
    "Nivel eliminado con éxito", "Уровень успешно удалён", "Poziom usunięty pomyślnie", "tier_deleted"
  ],
  features_updated: [
    "Features updated successfully", "Features updated successfully", "機能が正常に更新されました", "功能更新成功",
    "Funktionen erfolgreich aktualisiert", "Fonctionnalités mises à jour avec succès", "Funzionalità aggiornate con successo", "Funcionalidades atualizadas com sucesso",
    "Funciones actualizadas con éxito", "Функции успешно обновлены", "Funkcje zaktualizowane pomyślnie", "features_updated"
  ],
  features_update_failed: [
    "Failed to update features", "Failed to update features", "機能を更新できませんでした", "更新功能失败",
    "Funktionen konnten nicht aktualisiert werden", "Échec de la mise à jour des fonctionnalités", "Impossibile aggiornare le funzionalità", "Falha ao atualizar as funcionalidades",
    "No se pudieron actualizar las funciones", "Не удалось обновить функции", "Nie udało się zaktualizować funkcji", "features_update_failed"
  ],
  pricing_updated: [
    "Pricing updated successfully", "Pricing updated successfully", "価格設定が正常に更新されました", "定价更新成功",
    "Preise erfolgreich aktualisiert", "Tarifs mis à jour avec succès", "Prezzi aggiornati con successo", "Preços atualizados com sucesso",
    "Precios actualizados con éxito", "Цены успешно обновлены", "Ceny zaktualizowane pomyślnie", "pricing_updated"
  ],
  country_created: [
    "Country created successfully", "Country created successfully", "国が正常に作成されました", "国家创建成功",
    "Land erfolgreich erstellt", "Pays créé avec succès", "Paese creato con successo", "País criado com sucesso",
    "País creado con éxito", "Страна успешно создана", "Kraj utworzony pomyślnie", "country_created"
  ],
  country_updated: [
    "Country updated successfully", "Country updated successfully", "国が正常に更新されました", "国家更新成功",
    "Land erfolgreich aktualisiert", "Pays mis à jour avec succès", "Paese aggiornato con successo", "País atualizado com sucesso",
    "País actualizado con éxito", "Страна успешно обновлена", "Kraj zaktualizowany pomyślnie", "country_updated"
  ],
  country_deleted: [
    "Country deleted successfully", "Country deleted successfully", "国が正常に削除されました", "国家删除成功",
    "Land erfolgreich gelöscht", "Pays supprimé avec succès", "Paese eliminato con successo", "País eliminado com sucesso",
    "País eliminado con éxito", "Страна успешно удалена", "Kraj usunięty pomyślnie", "country_deleted"
  ],
  currencies_updated: [
    "Currencies updated successfully", "Currencies updated successfully", "通貨が正常に更新されました", "货币更新成功",
    "Währungen erfolgreich aktualisiert", "Devises mises à jour avec succès", "Valute aggiornate con successo", "Moedas atualizadas com sucesso",
    "Monedas actualizadas con éxito", "Валюты успешно обновлены", "Waluty zaktualizowane pomyślnie", "currencies_updated"
  ],
  failed_load_tiers: [
    "Failed to load subscription tiers", "Failed to load subscription tiers", "サブスクリプションティアの読み込みに失敗しました", "加载订阅层级失败",
    "Laden der Abonnementstufen fehlgeschlagen", "Échec du chargement des niveaux d'abonnement", "Caricamento livelli di abbonamento fallito", "Falha ao carregar níveis de assinatura",
    "Error al cargar los niveles de suscripción", "Не удалось загрузить уровни подписки", "Nie udało się załadować poziomów subskrypcji", "failed_load_tiers"
  ],
  failed_load_countries: [
    "Failed to load checkout countries", "Failed to load checkout countries", "チェックアウト国の読み込みに失敗しました", "加载结账国家失败",
    "Laden der Checkout-Länder fehlgeschlagen", "Échec du chargement des pays de paiement", "Caricamento paesi di checkout fallito", "Falha ao carregar países de checkout",
    "Error al cargar los países de pago", "Не удалось загрузить страны оформления", "Nie udało się załadować krajów kasowych", "failed_load_countries"
  ],

  /* ──────────────────────────────────────────────────────
     Subscription Management — Form & Table UI
     ────────────────────────────────────────────────────── */
  configure_tiers_desc: [
    "Configure subscription tiers, features, pricing, and checkout countries.",
    "Configure subscription tiers, features, pricing, and checkout countries.",
    "サブスクリプションティア、機能、料金、チェックアウト国を設定します。",
    "配置订阅层级、功能、定价和结账国家。",
    "Konfigurieren Sie Abonnementstufen, Funktionen, Preise und Checkout-Länder.",
    "Configurez les niveaux d'abonnement, les fonctionnalités, les prix et les pays de paiement.",
    "Configura livelli di abbonamento, funzionalità, prezzi e paesi di checkout.",
    "Configure níveis de assinatura, funcionalidades, preços e países de checkout.",
    "Configure niveles de suscripción, características, precios y países de pago.",
    "Настройте уровни подписки, функции, цены и страны оформления.",
    "Skonfiguruj poziomy subskrypcji, funkcje, ceny i kraje kasowe.",
    "configure_tiers_desc"
  ],
  edit_tier: [
    "Edit Tier", "Edit Tier", "ティアを編集", "编辑层级",
    "Stufe bearbeiten", "Modifier le niveau", "Modifica livello", "Editar nível",
    "Editar nivel", "Редактировать уровень", "Edytuj poziom", "edit_tier"
  ],
  new_tier_label: [
    "New Tier", "New Tier", "新しいティア", "新层级",
    "Neue Stufe", "Nouveau niveau", "Nuovo livello", "Novo nível",
    "Nuevo nivel", "Новый уровень", "Nowy poziom", "new_tier_label"
  ],
  tier_key_label: [
    "Tier Key", "Tier Key", "ティアキー", "层级键",
    "Stufenschlüssel", "Clé du niveau", "Chiave livello", "Chave do nível",
    "Clave del nivel", "Ключ уровня", "Klucz poziomu", "tier_key_label"
  ],
  name_required: [
    "Name is required", "Name is required", "名前は必須です", "名称为必填",
    "Name ist erforderlich", "Le nom est requis", "Il nome è obbligatorio", "O nome é obrigatório",
    "El nombre es obligatorio", "Имя обязательно", "Nazwa jest wymagana", "name_required"
  ],
  stripe_product: [
    "Stripe Product", "Stripe Product", "Stripe製品", "Stripe产品",
    "Stripe-Produkt", "Produit Stripe", "Prodotto Stripe", "Produto Stripe",
    "Producto Stripe", "Продукт Stripe", "Produkt Stripe", "stripe_product"
  ],
  stripe_product_id_readonly: [
    "Stripe Product ID (read-only)", "Stripe Product ID (read-only)", "Stripe製品ID（読み取り専用）", "Stripe产品ID（只读）",
    "Stripe-Produkt-ID (schreibgeschützt)", "ID produit Stripe (lecture seule)", "ID prodotto Stripe (sola lettura)", "ID do produto Stripe (só leitura)",
    "ID de producto Stripe (solo lectura)", "ID продукта Stripe (только чтение)", "ID produktu Stripe (tylko odczyt)", "stripe_product_id_readonly"
  ],
  edit_country: [
    "Edit Country", "Edit Country", "国を編集", "编辑国家",
    "Land bearbeiten", "Modifier le pays", "Modifica paese", "Editar país",
    "Editar país", "Редактировать страну", "Edytuj kraj", "edit_country"
  ],
  country_code_label: [
    "Country Code (2-letter)", "Country Code (2-letter)", "国コード（2文字）", "国家代码（2位字母）",
    "Ländercode (2 Buchstaben)", "Code pays (2 lettres)", "Codice paese (2 lettere)", "Código do país (2 letras)",
    "Código de país (2 letras)", "Код страны (2 буквы)", "Kod kraju (2 litery)", "country_code_label"
  ],
  country_name_label: [
    "Country Name", "Country Name", "国名", "国家名称",
    "Ländername", "Nom du pays", "Nome del paese", "Nome do país",
    "Nombre del país", "Название страны", "Nazwa kraju", "country_name_label"
  ],
  currencies_for: [
    "Currencies for", "Currencies for", "の通貨", "的货币",
    "Währungen für", "Devises pour", "Valute per", "Moedas para",
    "Monedas para", "Валюты для", "Waluty dla", "currencies_for"
  ],
  features_label: [
    "Features", "Features", "機能", "功能",
    "Funktionen", "Fonctionnalités", "Funzionalità", "Funcionalidades",
    "Características", "Функции", "Funkcje", "features_label"
  ],
  pricing_label: [
    "Pricing", "Pricing", "料金", "定价",
    "Preise", "Prix", "Prezzi", "Preços",
    "Precios", "Цены", "Ceny", "pricing_label"
  ],
  edit_label: [
    "Edit", "Edit", "編集", "编辑",
    "Bearbeiten", "Modifier", "Modifica", "Editar",
    "Editar", "Редактировать", "Edytuj", "edit_label"
  ],
  remove_label: [
    "Remove", "Remove", "削除", "移除",
    "Entfernen", "Supprimer", "Rimuovi", "Remover",
    "Eliminar", "Удалить", "Usuń", "remove_label"
  ],
  code_label: [
    "Code", "Code", "コード", "代码",
    "Code", "Code", "Codice", "Código",
    "Código", "Код", "Kod", "code_label"
  ],
  country_label: [
    "Country", "Country", "国", "国家",
    "Land", "Pays", "Paese", "País",
    "País", "Страна", "Kraj", "country_label"
  ],
  sort_label: [
    "Sort", "Sort", "順序", "排序",
    "Sortierung", "Tri", "Ordinamento", "Ordem",
    "Orden", "Сортировка", "Kolejność", "sort_label"
  ],
  currency_label: [
    "Currency", "Currency", "通貨", "货币",
    "Währung", "Devise", "Valuta", "Moeda",
    "Moneda", "Валюта", "Waluta", "currency_label"
  ],
  device_1_yearly: [
    "1 Device (monthly)", "1 Device (monthly)", "1台（月額）", "1台设备（月度）",
    "1 Gerät (monatlich)", "1 appareil (mensuel)", "1 dispositivo (mensile)", "1 dispositivo (mensal)",
    "1 dispositivo (mensual)", "1 устройство (месяц)", "1 urządzenie (miesięcznie)", "device_1_yearly"
  ],
  device_2_5_yearly: [
    "2-5 Devices (monthly each)", "2-5 Devices (monthly each)", "2-5台（月額/台）", "2-5台设备（每台/月）",
    "2-5 Geräte (monatlich je)", "2-5 appareils (mensuel ch.)", "2-5 dispositivi (mensile cad.)", "2-5 dispositivos (mensal cada)",
    "2-5 dispositivos (mensual c/u)", "2-5 устройств (месяц/шт.)", "2-5 urządzeń (miesięcznie/szt.)", "device_2_5_yearly"
  ],
  device_6_plus_yearly: [
    "6 or More Devices (monthly each)", "6 or More Devices (monthly each)", "6台以上（月額/台）", "6台或以上设备（每台/月）",
    "6 oder mehr Geräte (monatlich je)", "6 appareils ou plus (mensuel ch.)", "6 o più dispositivi (mensile cad.)", "6 ou mais dispositivos (mensal cada)",
    "6 o más dispositivos (mensual c/u)", "6 или более устройств (месяц/шт.)", "6 lub więcej urządzeń (miesięcznie/szt.)", "device_6_plus_yearly"
  ],
  preview_label: [
    "Preview", "Preview", "プレビュー", "预览",
    "Vorschau", "Aperçu", "Anteprima", "Pré-visualização",
    "Vista previa", "Предпросмотр", "Podgląd", "preview_label"
  ],
  pricing_hint: [
    "Prices are in smallest currency unit (pence/cents). The preview shows the formatted value.",
    "Prices are in smallest currency unit (pence/cents). The preview shows the formatted value.",
    "価格は最小通貨単位（ペンス/セント）です。プレビューはフォーマットされた値を表示します。",
    "价格以最小货币单位（便士/分）表示。预览显示格式化的值。",
    "Preise sind in kleinster Währungseinheit (Pence/Cent). Die Vorschau zeigt den formatierten Wert.",
    "Les prix sont en plus petite unité monétaire (pence/centimes). L'aperçu affiche la valeur formatée.",
    "I prezzi sono nell'unità valutaria più piccola (pence/centesimi). L'anteprima mostra il valore formattato.",
    "Os preços estão na menor unidade monetária (cêntimos). A pré-visualização mostra o valor formatado.",
    "Los precios están en la unidad monetaria más pequeña (peniques/centavos). La vista previa muestra el valor formateado.",
    "Цены в минимальных единицах валюты (пенни/центы). Предпросмотр показывает отформатированное значение.",
    "Ceny podane w najmniejszej jednostce walutowej (pensy/centy). Podgląd pokazuje sformatowaną wartość.",
    "pricing_hint"
  ],
  select_currency: [
    "Select currency", "Select currency", "通貨を選択", "选择货币",
    "Währung auswählen", "Sélectionner la devise", "Seleziona valuta", "Selecionar moeda",
    "Seleccionar moneda", "Выберите валюту", "Wybierz walutę", "select_currency"
  ],

  /* ──────────────────────────────────────────────────────
     Admin — Terms & Conditions Management
     ────────────────────────────────────────────────────── */
  terms_and_conditions: [
    "Terms & Conditions", "Terms & Conditions", "利用規約", "条款和条件",
    "Allgemeine Geschäftsbedingungen", "Conditions générales", "Termini e condizioni", "Termos e condições",
    "Términos y condiciones", "Условия и положения", "Regulamin", "terms_and_conditions"
  ],
  validation_language_required: [
    "Language is required", "Language is required", "言語は必須です", "语言为必填项",
    "Sprache ist erforderlich", "La langue est requise", "La lingua è obbligatoria", "O idioma é obrigatório",
    "El idioma es obligatorio", "Язык обязателен", "Język jest wymagany", "validation_language_required"
  ],
  validation_version_required: [
    "Version is required", "Version is required", "バージョンは必須です", "版本为必填项",
    "Version ist erforderlich", "La version est requise", "La versione è obbligatoria", "A versão é obrigatória",
    "La versión es obligatoria", "Версия обязательна", "Wersja jest wymagana", "validation_version_required"
  ],
  validation_title_required: [
    "Title is required", "Title is required", "タイトルは必須です", "标题为必填项",
    "Titel ist erforderlich", "Le titre est requis", "Il titolo è obbligatorio", "O título é obrigatório",
    "El título es obligatorio", "Заголовок обязателен", "Tytuł jest wymagany", "validation_title_required"
  ],
  validation_content_required: [
    "Content is required", "Content is required", "内容は必須です", "内容为必填项",
    "Inhalt ist erforderlich", "Le contenu est requis", "Il contenuto è obbligatorio", "O conteúdo é obrigatório",
    "El contenido es obligatorio", "Содержание обязательно", "Treść jest wymagana", "validation_content_required"
  ],
  confirm_publish_terms: [
    "Are you sure you want to publish this version? Once published, it will be visible to all users and cannot be edited.",
    "Are you sure you want to publish this version? Once published, it will be visible to all users and cannot be edited.",
    "このバージョンを公開してもよろしいですか？公開すると、すべてのユーザーに表示され、編集できなくなります。",
    "您确定要发布此版本吗？发布后，所有用户都可以看到，且无法编辑。",
    "Möchten Sie diese Version wirklich veröffentlichen? Nach der Veröffentlichung ist sie für alle Benutzer sichtbar und kann nicht bearbeitet werden.",
    "Êtes-vous sûr de vouloir publier cette version ? Une fois publiée, elle sera visible par tous les utilisateurs et ne pourra pas être modifiée.",
    "Sei sicuro di voler pubblicare questa versione? Una volta pubblicata, sarà visibile a tutti gli utenti e non potrà essere modificata.",
    "Tem certeza de que deseja publicar esta versão? Uma vez publicada, será visível para todos os utilizadores e não poderá ser editada.",
    "¿Está seguro de que desea publicar esta versión? Una vez publicada, será visible para todos los usuarios y no se podrá editar.",
    "Вы уверены, что хотите опубликовать эту версию? После публикации она будет видна всем пользователям и не может быть отредактирована.",
    "Czy na pewno chcesz opublikować tę wersję? Po opublikowaniu będzie widoczna dla wszystkich użytkowników i nie będzie można jej edytować.",
    "confirm_publish_terms"
  ],
  confirm_delete_terms: [
    "Are you sure you want to delete this T&C version?",
    "Are you sure you want to delete this T&C version?",
    "この利用規約バージョンを削除してもよろしいですか？",
    "您确定要删除此条款版本吗？",
    "Möchten Sie diese AGB-Version wirklich löschen?",
    "Êtes-vous sûr de vouloir supprimer cette version des CGV ?",
    "Sei sicuro di voler eliminare questa versione dei T&C?",
    "Tem certeza de que deseja eliminar esta versão dos T&C?",
    "¿Está seguro de que desea eliminar esta versión de los T&C?",
    "Вы уверены, что хотите удалить эту версию условий?",
    "Czy na pewno chcesz usunąć tę wersję regulaminu?",
    "confirm_delete_terms"
  ],
  confirm_duplicate_terms: [
    "Duplicate as a new Draft?", "Duplicate as a new Draft?",
    "新しい下書きとして複製しますか？", "复制为新草稿？",
    "Als neuen Entwurf duplizieren?", "Dupliquer comme nouveau brouillon ?",
    "Duplicare come nuova bozza?", "Duplicar como novo rascunho?",
    "¿Duplicar como nuevo borrador?", "Дублировать как новый черновик?",
    "Zduplikować jako nowy szkic?", "confirm_duplicate_terms"
  ],
  terms_fetching_preview: [
    "Fetching content for preview. Please click Preview again once loaded.",
    "Fetching content for preview. Please click Preview again once loaded.",
    "プレビュー用のコンテンツを取得中。読み込み後にもう一度プレビューをクリックしてください。",
    "正在获取预览内容。加载完成后请再次点击预览。",
    "Inhalt für Vorschau wird geladen. Bitte klicken Sie nach dem Laden erneut auf Vorschau.",
    "Chargement du contenu pour l'aperçu. Veuillez cliquer à nouveau sur Aperçu une fois chargé.",
    "Caricamento del contenuto per l'anteprima. Fare clic di nuovo su Anteprima una volta caricato.",
    "A obter conteúdo para pré-visualização. Clique novamente em Pré-visualizar após o carregamento.",
    "Obteniendo contenido para vista previa. Haga clic en Vista previa de nuevo una vez cargado.",
    "Загрузка содержимого для предпросмотра. Нажмите Предпросмотр ещё раз после загрузки.",
    "Pobieranie treści do podglądu. Kliknij ponownie Podgląd po załadowaniu.",
    "terms_fetching_preview"
  ],
  preview_badge: [
    "PREVIEW", "PREVIEW", "プレビュー", "预览",
    "VORSCHAU", "APERÇU", "ANTEPRIMA", "PRÉ-VISUALIZAÇÃO",
    "VISTA PREVIA", "ПРЕДПРОСМОТР", "PODGLĄD", "preview_badge"
  ],
  terms_no_content: [
    "No content", "No content", "コンテンツなし", "无内容",
    "Kein Inhalt", "Pas de contenu", "Nessun contenuto", "Sem conteúdo",
    "Sin contenido", "Нет содержимого", "Brak treści", "terms_no_content"
  ],
  new_terms_version: [
    "New Version", "New Version", "新バージョン", "新版本",
    "Neue Version", "Nouvelle version", "Nuova versione", "Nova versão",
    "Nueva versión", "Новая версия", "Nowa wersja", "new_terms_version"
  ],
  terms_instructions: [
    "Manage Terms & Conditions content per language. Create versions, edit drafts, and publish when ready. Published versions are immutable.",
    "Manage Terms & Conditions content per language. Create versions, edit drafts, and publish when ready. Published versions are immutable.",
    "言語ごとの利用規約コンテンツを管理します。バージョンを作成し、下書きを編集し、準備ができたら公開します。公開されたバージョンは変更不可です。",
    "按语言管理条款和条件内容。创建版本、编辑草稿并在准备好后发布。已发布的版本不可更改。",
    "Verwalten Sie AGB-Inhalte pro Sprache. Erstellen Sie Versionen, bearbeiten Sie Entwürfe und veröffentlichen Sie, wenn Sie bereit sind.",
    "Gérez le contenu des CGV par langue. Créez des versions, modifiez les brouillons et publiez quand vous êtes prêt.",
    "Gestisci i contenuti dei T&C per lingua. Crea versioni, modifica bozze e pubblica quando sei pronto.",
    "Gerencie o conteúdo dos T&C por idioma. Crie versões, edite rascunhos e publique quando estiver pronto.",
    "Gestione el contenido de los T&C por idioma. Cree versiones, edite borradores y publique cuando esté listo.",
    "Управляйте содержимым условий по языкам. Создавайте версии, редактируйте черновики и публикуйте, когда будете готовы.",
    "Zarządzaj treścią regulaminu w poszczególnych językach. Twórz wersje, edytuj szkice i publikuj, gdy będą gotowe.",
    "terms_instructions"
  ],
  edit_terms_version: [
    "Edit Terms Version", "Edit Terms Version", "利用規約バージョンを編集", "编辑条款版本",
    "AGB-Version bearbeiten", "Modifier la version des CGV", "Modifica versione T&C", "Editar versão dos T&C",
    "Editar versión de T&C", "Редактировать версию условий", "Edytuj wersję regulaminu", "edit_terms_version"
  ],
  new_terms_version_label: [
    "New Terms Version", "New Terms Version", "新しい利用規約バージョン", "新条款版本",
    "Neue AGB-Version", "Nouvelle version des CGV", "Nuova versione T&C", "Nova versão dos T&C",
    "Nueva versión de T&C", "Новая версия условий", "Nowa wersja regulaminu", "new_terms_version_label"
  ],
  terms_published_readonly: [
    "Published — read only", "Published — read only", "公開済み — 読み取り専用", "已发布 — 只读",
    "Veröffentlicht — schreibgeschützt", "Publié — lecture seule", "Pubblicato — sola lettura", "Publicado — apenas leitura",
    "Publicado — solo lectura", "Опубликовано — только чтение", "Opublikowane — tylko do odczytu", "terms_published_readonly"
  ],
  save_draft: [
    "Save Draft", "Save Draft", "下書きを保存", "保存草稿",
    "Entwurf speichern", "Enregistrer le brouillon", "Salva bozza", "Guardar rascunho",
    "Guardar borrador", "Сохранить черновик", "Zapisz szkic", "save_draft"
  ],
  update: [
    "Update", "Update", "更新", "更新",
    "Aktualisieren", "Mettre à jour", "Aggiorna", "Atualizar",
    "Actualizar", "Обновить", "Aktualizuj", "update"
  ],
  close: [
    "Close", "Close", "閉じる", "关闭",
    "Schließen", "Fermer", "Chiudi", "Fechar",
    "Cerrar", "Закрыть", "Zamknij", "close"
  ],
  preview_in_new_tab: [
    "Preview in New Tab", "Preview in New Tab", "新しいタブでプレビュー", "在新标签页中预览",
    "Vorschau in neuem Tab", "Aperçu dans un nouvel onglet", "Anteprima in nuova scheda", "Pré-visualizar em nova aba",
    "Vista previa en nueva pestaña", "Предпросмотр в новой вкладке", "Podgląd w nowej karcie", "preview_in_new_tab"
  ],
  terms_language_label: [
    "Language", "Language", "言語", "语言",
    "Sprache", "Langue", "Lingua", "Idioma",
    "Idioma", "Язык", "Język", "terms_language_label"
  ],
  terms_version_label: [
    "Version", "Version", "バージョン", "版本",
    "Version", "Version", "Versione", "Versão",
    "Versión", "Версия", "Wersja", "terms_version_label"
  ],
  terms_title_label: [
    "Title", "Title", "タイトル", "标题",
    "Titel", "Titre", "Titolo", "Título",
    "Título", "Заголовок", "Tytuł", "terms_title_label"
  ],
  terms_content_label: [
    "Content (Rich Text)", "Content (Rich Text)", "コンテンツ（リッチテキスト）", "内容（富文本）",
    "Inhalt (Rich Text)", "Contenu (texte riche)", "Contenuto (testo formattato)", "Conteúdo (texto rico)",
    "Contenido (texto enriquecido)", "Содержание (форматированный текст)", "Treść (tekst sformatowany)", "terms_content_label"
  ],
  loading_content: [
    "Loading content", "Loading content", "コンテンツを読み込み中", "正在加载内容",
    "Inhalt wird geladen", "Chargement du contenu", "Caricamento del contenuto", "A carregar conteúdo",
    "Cargando contenido", "Загрузка содержимого", "Ładowanie treści", "loading_content"
  ],
  enter_link_url: [
    "Enter link URL", "Enter link URL", "リンクURLを入力", "输入链接URL",
    "Link-URL eingeben", "Saisissez l'URL du lien", "Inserisci l'URL del link", "Introduza o URL do link",
    "Introduzca la URL del enlace", "Введите URL ссылки", "Wprowadź adres URL linku", "enter_link_url"
  ],
  language_header: [
    "Language", "Language", "言語", "语言",
    "Sprache", "Langue", "Lingua", "Idioma",
    "Idioma", "Язык", "Język", "language_header"
  ],
  version_header: [
    "Version", "Version", "バージョン", "版本",
    "Version", "Version", "Versione", "Versão",
    "Versión", "Версия", "Wersja", "version_header"
  ],
  title_header: [
    "Title", "Title", "タイトル", "标题",
    "Titel", "Titre", "Titolo", "Título",
    "Título", "Заголовок", "Tytuł", "title_header"
  ],
  published_header: [
    "Published", "Published", "公開日", "发布日期",
    "Veröffentlicht", "Publié", "Pubblicato", "Publicado",
    "Publicado", "Опубликовано", "Opublikowane", "published_header"
  ],
  last_modified_header: [
    "Last Modified", "Last Modified", "最終更新", "最后修改",
    "Zuletzt geändert", "Dernière modification", "Ultima modifica", "Última modificação",
    "Última modificación", "Последнее изменение", "Ostatnia modyfikacja", "last_modified_header"
  ],
  publish: [
    "Publish", "Publish", "公開", "发布",
    "Veröffentlichen", "Publier", "Pubblica", "Publicar",
    "Publicar", "Опубликовать", "Opublikuj", "publish"
  ],
  duplicate: [
    "Duplicate", "Duplicate", "複製", "复制",
    "Duplizieren", "Dupliquer", "Duplica", "Duplicar",
    "Duplicar", "Дублировать", "Duplikuj", "duplicate"
  ],
  no_terms_configured: [
    "No Terms & Conditions versions configured. Click \"New Version\" to create one.",
    "No Terms & Conditions versions configured. Click \"New Version\" to create one.",
    "利用規約のバージョンが設定されていません。「新バージョン」をクリックして作成してください。",
    "未配置条款和条件版本。点击「新版本」创建一个。",
    "Keine AGB-Versionen konfiguriert. Klicken Sie auf \"Neue Version\", um eine zu erstellen.",
    "Aucune version des CGV configurée. Cliquez sur « Nouvelle version » pour en créer une.",
    "Nessuna versione dei T&C configurata. Fai clic su \"Nuova versione\" per crearne una.",
    "Nenhuma versão dos T&C configurada. Clique em \"Nova versão\" para criar uma.",
    "No hay versiones de T&C configuradas. Haga clic en \"Nueva versión\" para crear una.",
    "Версии условий не настроены. Нажмите «Новая версия», чтобы создать.",
    "Brak skonfigurowanych wersji regulaminu. Kliknij \"Nowa wersja\", aby utworzyć.",
    "no_terms_configured"
  ],

  /* ──────────────────────────────────────────────────────
     Customer — Home Page & Job Preview
     ────────────────────────────────────────────────────── */
  default_user_name: [
    "User", "User", "ユーザー", "用户",
    "Benutzer", "Utilisateur", "Utente", "Utilizador",
    "Usuario", "Пользователь", "Użytkownik", "default_user_name"
  ],
  job_name_header: [
    "Job Name", "Job Name", "ジョブ名", "作业名称",
    "Auftragsname", "Nom du travail", "Nome lavoro", "Nome do trabalho",
    "Nombre del trabajo", "Название задания", "Nazwa zadania", "job_name_header"
  ],
  test_results_header: [
    "Test Results", "Test Results", "テスト結果", "测试结果",
    "Testergebnisse", "Résultats des tests", "Risultati test", "Resultados dos testes",
    "Resultados de pruebas", "Результаты тестов", "Wyniki testów", "test_results_header"
  ],
  device_header: [
    "Device", "Device", "デバイス", "设备",
    "Gerät", "Appareil", "Dispositivo", "Dispositivo",
    "Dispositivo", "Устройство", "Urządzenie", "device_header"
  ],
  engineer_header: [
    "Engineer", "Engineer", "エンジニア", "工程师",
    "Techniker", "Ingénieur", "Tecnico", "Engenheiro",
    "Ingeniero", "Инженер", "Inżynier", "engineer_header"
  ],
  created_header: [
    "Created", "Created", "作成日", "创建日期",
    "Erstellt", "Créé", "Creato", "Criado",
    "Creado", "Создано", "Utworzono", "created_header"
  ],
  completed_header: [
    "Completed", "Completed", "完了日", "完成日期",
    "Abgeschlossen", "Terminé", "Completato", "Concluído",
    "Completado", "Завершено", "Ukończone", "completed_header"
  ],
  actions_header: [
    "Actions", "Actions", "アクション", "操作",
    "Aktionen", "Actions", "Azioni", "Ações",
    "Acciones", "Действия", "Akcje", "actions_header"
  ],
  not_available: [
    "N/A", "N/A", "該当なし", "不适用",
    "k. A.", "N/D", "N/D", "N/D",
    "N/D", "Н/Д", "Brak", "not_available"
  ],
  job_details_heading: [
    "Job Details", "Job Details", "ジョブ詳細", "作业详情",
    "Auftragsdetails", "Détails du travail", "Dettagli lavoro", "Detalhes do trabalho",
    "Detalles del trabajo", "Детали задания", "Szczegóły zadania", "job_details_heading"
  ],
  status_completed: [
    "Completed", "Completed", "完了", "已完成",
    "Abgeschlossen", "Terminé", "Completato", "Concluído",
    "Completado", "Завершено", "Ukończone", "status_completed"
  ],
  status_pending: [
    "Pending", "Pending", "保留中", "待处理",
    "Ausstehend", "En attente", "In attesa", "Pendente",
    "Pendiente", "В ожидании", "Oczekujące", "status_pending"
  ],
  open_job: [
    "Open Job", "Open Job", "ジョブを開く", "打开作业",
    "Auftrag öffnen", "Ouvrir le travail", "Apri lavoro", "Abrir trabalho",
    "Abrir trabajo", "Открыть задание", "Otwórz zadanie", "open_job"
  ],
  device_label: [
    "Device", "Device", "デバイス", "设备",
    "Gerät", "Appareil", "Dispositivo", "Dispositivo",
    "Dispositivo", "Устройство", "Urządzenie", "device_label"
  ],
  created_label: [
    "Created", "Created", "作成日", "创建日期",
    "Erstellt", "Créé", "Creato", "Criado",
    "Creado", "Создано", "Utworzono", "created_label"
  ],
  completed_label: [
    "Completed", "Completed", "完了日", "完成日期",
    "Abgeschlossen", "Terminé", "Completato", "Concluído",
    "Completado", "Завершено", "Ukończone", "completed_label"
  ],
  engineer_label: [
    "Engineer", "Engineer", "エンジニア", "工程师",
    "Techniker", "Ingénieur", "Tecnico", "Engenheiro",
    "Ingeniero", "Инженер", "Inżynier", "engineer_label"
  ],
  test_summary: [
    "Test Summary", "Test Summary", "テスト概要", "测试摘要",
    "Testzusammenfassung", "Résumé des tests", "Riepilogo test", "Resumo dos testes",
    "Resumen de pruebas", "Сводка тестов", "Podsumowanie testów", "test_summary"
  ],
  success_rate: [
    "Success Rate", "Success Rate", "成功率", "成功率",
    "Erfolgsrate", "Taux de réussite", "Tasso di successo", "Taxa de sucesso",
    "Tasa de éxito", "Показатель успеха", "Wskaźnik sukcesu", "success_rate"
  ],
  passed_label: [
    "Passed", "Passed", "合格", "通过",
    "Bestanden", "Réussi", "Superato", "Aprovado",
    "Aprobado", "Пройдено", "Zaliczone", "passed_label"
  ],
  failed_label: [
    "Failed", "Failed", "不合格", "失败",
    "Fehlgeschlagen", "Échoué", "Fallito", "Reprovado",
    "Fallido", "Не пройдено", "Niezaliczone", "failed_label"
  ],
  individual_tests: [
    "Individual Tests", "Individual Tests", "個別テスト", "单项测试",
    "Einzeltests", "Tests individuels", "Test individuali", "Testes individuais",
    "Pruebas individuales", "Отдельные тесты", "Testy indywidualne", "individual_tests"
  ],
  id_header: [
    "ID", "ID", "ID", "ID",
    "ID", "ID", "ID", "ID",
    "ID", "ID", "ID", "id_header"
  ],
  test_name_header: [
    "Test Name", "Test Name", "テスト名", "测试名称",
    "Testname", "Nom du test", "Nome test", "Nome do teste",
    "Nombre de prueba", "Название теста", "Nazwa testu", "test_name_header"
  ],
  timestamp_header: [
    "Timestamp", "Timestamp", "タイムスタンプ", "时间戳",
    "Zeitstempel", "Horodatage", "Timestamp", "Carimbo temporal",
    "Marca de tiempo", "Временная метка", "Znacznik czasu", "timestamp_header"
  ],
  result_header: [
    "Result", "Result", "結果", "结果",
    "Ergebnis", "Résultat", "Risultato", "Resultado",
    "Resultado", "Результат", "Wynik", "result_header"
  ],
  limits_header: [
    "Limits", "Limits", "制限", "限制",
    "Grenzwerte", "Limites", "Limiti", "Limites",
    "Límites", "Пределы", "Limity", "limits_header"
  ],
  date_time_header: [
    "Date/Time", "Date/Time", "日時", "日期/时间",
    "Datum/Zeit", "Date/Heure", "Data/Ora", "Data/Hora",
    "Fecha/Hora", "Дата/Время", "Data/Czas", "date_time_header"
  ],
  description_label: [
    "Description", "Description", "説明", "描述",
    "Beschreibung", "Description", "Descrizione", "Descrição",
    "Descripción", "Описание", "Opis", "description_label"
  ],
  notes_label: [
    "Notes", "Notes", "メモ", "备注",
    "Notizen", "Notes", "Note", "Notas",
    "Notas", "Заметки", "Notatki", "notes_label"
  ],
  failed_load_job_details: [
    "Failed to load job details", "Failed to load job details", "ジョブの詳細を読み込めませんでした", "加载作业详情失败",
    "Auftragsdetails konnten nicht geladen werden", "Échec du chargement des détails du travail", "Impossibile caricare i dettagli del lavoro", "Falha ao carregar detalhes do trabalho",
    "Error al cargar los detalles del trabajo", "Не удалось загрузить детали задания", "Nie udało się załadować szczegółów zadania", "failed_load_job_details"
  ],

  /* ──────────────────────────────────────────────────────
     Customer — Devices Table
     ────────────────────────────────────────────────────── */
  serial_number_header: [
    "Serial No.", "Serial No.", "シリアル番号", "序列号",
    "Seriennr.", "N° de série", "N. di serie", "N.º de série",
    "N.º de serie", "Серийный №", "Nr seryjny", "serial_number_header"
  ],
  type_header: [
    "Type", "Type", "タイプ", "类型",
    "Typ", "Type", "Tipo", "Tipo",
    "Tipo", "Тип", "Typ", "type_header"
  ],
  status_header: [
    "Status", "Status", "ステータス", "状态",
    "Status", "Statut", "Stato", "Estado",
    "Estado", "Статус", "Status", "status_header"
  ],
  calibration_due_header: [
    "Calibration Due", "Calibration Due", "校正期限", "校准到期",
    "Kalibrierung fällig", "Étalonnage dû", "Calibrazione in scadenza", "Calibração devida",
    "Calibración pendiente", "Калибровка просрочена", "Termin kalibracji", "calibration_due_header"
  ],
  last_seen_header: [
    "Last Seen", "Last Seen", "最終確認", "最后在线",
    "Zuletzt gesehen", "Dernière vue", "Ultimo accesso", "Visto pela última vez",
    "Visto por última vez", "Последний раз виден", "Ostatnio widziany", "last_seen_header"
  ],
  status_online: [
    "Online", "Online", "オンライン", "在线",
    "Online", "En ligne", "Online", "Online",
    "En línea", "Онлайн", "Online", "status_online"
  ],
  status_offline: [
    "Offline", "Offline", "オフライン", "离线",
    "Offline", "Hors ligne", "Offline", "Offline",
    "Sin conexión", "Оффлайн", "Offline", "status_offline"
  ],
  unassigned: [
    "Unassigned", "Unassigned", "未割り当て", "未分配",
    "Nicht zugewiesen", "Non attribué", "Non assegnato", "Não atribuído",
    "No asignado", "Не назначен", "Nieprzypisany", "unassigned"
  ],
  calibration_overdue_tooltip: [
    "Calibration overdue", "Calibration overdue", "校正期限超過", "校准已过期",
    "Kalibrierung überfällig", "Étalonnage en retard", "Calibrazione scaduta", "Calibração em atraso",
    "Calibración vencida", "Калибровка просрочена", "Kalibracja przeterminowana", "calibration_overdue_tooltip"
  ],
  calibration_due_soon_tooltip: [
    "Calibration due soon", "Calibration due soon", "校正期限が近づいています", "校准即将到期",
    "Kalibrierung bald fällig", "Étalonnage bientôt dû", "Calibrazione in scadenza", "Calibração a vencer em breve",
    "Calibración próxima a vencer", "Калибровка скоро", "Kalibracja wkrótce", "calibration_due_soon_tooltip"
  ],

  /* ──────────────────────────────────────────────────────
     Missing keys — Quick Actions & Forms
     ────────────────────────────────────────────────────── */
  reports: [
    "Reports", "Reports", "レポート", "报告",
    "Berichte", "Rapports", "Report", "Relatórios",
    "Informes", "Отчеты", "Raporty", "reports"
  ],
  location_tracking: [
    "Location Tracking", "Location Tracking", "位置追跡", "位置追踪",
    "Standortverfolgung", "Suivi de localisation", "Tracciamento posizione", "Rastreamento de localização",
    "Seguimiento de ubicación", "Отслеживание местоположения", "Śledzenie lokalizacji", "location_tracking"
  ],
  track_device_locations: [
    "Track device locations", "Track device locations", "デバイスの位置を追跡", "追踪设备位置",
    "Gerätestandorte verfolgen", "Suivre les emplacements des appareils", "Traccia le posizioni dei dispositivi", "Rastrear locais dos dispositivos",
    "Rastrear ubicaciones de dispositivos", "Отслеживать местоположения устройств", "Śledź lokalizacje urządzeń", "track_device_locations"
  ],
  profile: [
    "Profile", "Profile", "プロフィール", "个人资料",
    "Profil", "Profil", "Profilo", "Perfil",
    "Perfil", "Профиль", "Profil", "profile"
  ],
  manage_your_profile: [
    "Manage your profile", "Manage your profile", "プロフィールを管理", "管理您的个人资料",
    "Profil verwalten", "Gérer votre profil", "Gestisci il tuo profilo", "Gerir o seu perfil",
    "Gestionar tu perfil", "Управление профилем", "Zarządzaj swoim profilem", "manage_your_profile"
  ],
  manage_tiers_pricing: [
    "Manage tiers & pricing", "Manage tiers & pricing", "ティアと価格の管理", "管理等级和定价",
    "Stufen & Preise verwalten", "Gérer les niveaux et tarifs", "Gestisci livelli e prezzi", "Gerir níveis e preços",
    "Gestionar niveles y precios", "Управление уровнями и ценами", "Zarządzaj poziomami i cenami", "manage_tiers_pricing"
  ],
  user_home_page: [
    "User home page", "User home page", "ユーザーホームページ", "用户主页",
    "Benutzer-Startseite", "Page d'accueil utilisateur", "Pagina iniziale utente", "Página inicial do utilizador",
    "Página de inicio del usuario", "Домашняя страница пользователя", "Strona główna użytkownika", "user_home_page"
  ],
  view_download_reports: [
    "View & download reports", "View & download reports", "レポートの表示とダウンロード", "查看和下载报告",
    "Berichte anzeigen & herunterladen", "Afficher et télécharger les rapports", "Visualizza e scarica report", "Ver e descarregar relatórios",
    "Ver y descargar informes", "Просмотр и скачивание отчетов", "Przeglądaj i pobieraj raporty", "view_download_reports"
  ],
  description: [
    "Description", "Description", "説明", "描述",
    "Beschreibung", "Description", "Descrizione", "Descrição",
    "Descripción", "Описание", "Opis", "description"
  ],
  terms_missing_languages_warning: [
    "The following languages do not have a published Terms & Conditions version",
    "The following languages do not have a published Terms & Conditions version",
    "以下の言語には公開済みの利用規約バージョンがありません",
    "以下语言没有已发布的条款和条件版本",
    "Die folgenden Sprachen haben keine veröffentlichte AGB-Version",
    "Les langues suivantes n'ont pas de version publiée des CGV",
    "Le seguenti lingue non hanno una versione pubblicata dei T&C",
    "Os seguintes idiomas não possuem uma versão publicada dos T&C",
    "Los siguientes idiomas no tienen una versión publicada de los T&C",
    "Для следующих языков отсутствует опубликованная версия условий",
    "Następujące języki nie mają opublikowanej wersji regulaminu",
    "terms_missing_languages_warning"
  ],
  pricing_locked_message: [
    "Pricing is locked to prevent accidental changes. Unlock to edit.",
    "Pricing is locked to prevent accidental changes. Unlock to edit.",
    "価格は誤った変更を防ぐためにロックされています。編集するにはロックを解除してください。",
    "定价已锁定以防止意外更改。解锁以编辑。",
    "Preise sind gesperrt, um versehentliche Änderungen zu verhindern. Zum Bearbeiten entsperren.",
    "Les prix sont verrouillés pour éviter les modifications accidentelles. Déverrouillez pour modifier.",
    "I prezzi sono bloccati per evitare modifiche accidentali. Sblocca per modificare.",
    "Os preços estão bloqueados para evitar alterações acidentais. Desbloqueie para editar.",
    "Los precios están bloqueados para evitar cambios accidentales. Desbloquee para editar.",
    "Цены заблокированы для предотвращения случайных изменений. Разблокируйте для редактирования.",
    "Ceny są zablokowane, aby zapobiec przypadkowym zmianom. Odblokuj, aby edytować.",
    "pricing_locked_message"
  ],
  unlock_editing: [
    "Unlock Editing", "Unlock Editing", "編集のロック解除", "解锁编辑",
    "Bearbeitung entsperren", "Déverrouiller", "Sblocca modifica", "Desbloquear edição",
    "Desbloquear edición", "Разблокировать", "Odblokuj edycję", "unlock_editing"
  ],
  pricing_unlocked_warning: [
    "Editing unlocked — changes will affect all existing subscriptions. Be careful.",
    "Editing unlocked — changes will affect all existing subscriptions. Be careful.",
    "編集がロック解除されました — 変更はすべての既存サブスクリプションに影響します。注意してください。",
    "编辑已解锁 — 更改将影响所有现有订阅。请谨慎操作。",
    "Bearbeitung entsperrt — Änderungen betreffen alle bestehenden Abonnements. Seien Sie vorsichtig.",
    "Édition déverrouillée — les modifications affecteront tous les abonnements existants. Soyez prudent.",
    "Modifica sbloccata — le modifiche influenzeranno tutti gli abbonamenti esistenti. Fai attenzione.",
    "Edição desbloqueada — as alterações afetarão todas as assinaturas existentes. Tenha cuidado.",
    "Edición desbloqueada — los cambios afectarán a todas las suscripciones existentes. Tenga cuidado.",
    "Редактирование разблокировано — изменения затронут все существующие подписки. Будьте осторожны.",
    "Edycja odblokowana — zmiany wpłyną na wszystkie istniejące subskrypcje. Zachowaj ostrożność.",
    "pricing_unlocked_warning"
  ],
  confirm_price_change: [
    "Confirm Price Change", "Confirm Price Change", "価格変更の確認", "确认价格变更",
    "Preisänderung bestätigen", "Confirmer le changement de prix", "Conferma modifica prezzo", "Confirmar alteração de preço",
    "Confirmar cambio de precio", "Подтвердить изменение цен", "Potwierdź zmianę ceny", "confirm_price_change"
  ],
  pricing_change_warning: [
    "Warning. This price change will update all existing subscriptions. This action should only be performed during annual price reviews.",
    "Warning. This price change will update all existing subscriptions. This action should only be performed during annual price reviews.",
    "警告。この価格変更はすべての既存サブスクリプションを更新します。このアクションは年次価格見直し時にのみ実行してください。",
    "警告。此价格变更将更新所有现有订阅。此操作仅应在年度价格审查期间执行。",
    "Warnung. Diese Preisänderung aktualisiert alle bestehenden Abonnements. Diese Aktion sollte nur bei jährlichen Preisüberprüfungen durchgeführt werden.",
    "Avertissement. Ce changement de prix mettra à jour tous les abonnements existants. Cette action ne doit être effectuée que lors des révisions annuelles des prix.",
    "Attenzione. Questa modifica dei prezzi aggiornerà tutti gli abbonamenti esistenti. Questa azione deve essere eseguita solo durante le revisioni annuali dei prezzi.",
    "Aviso. Esta alteração de preço atualizará todas as assinaturas existentes. Esta ação só deve ser realizada durante revisões anuais de preços.",
    "Advertencia. Este cambio de precio actualizará todas las suscripciones existentes. Esta acción solo debe realizarse durante las revisiones anuales de precios.",
    "Предупреждение. Это изменение цен обновит все существующие подписки. Это действие следует выполнять только при ежегодном пересмотре цен.",
    "Ostrzeżenie. Ta zmiana ceny zaktualizuje wszystkie istniejące subskrypcje. Ta akcja powinna być wykonywana tylko podczas corocznych przeglądów cen.",
    "pricing_change_warning"
  ],
  pricing_changes_summary: [
    "Price Changes", "Price Changes", "価格変更", "价格变更",
    "Preisänderungen", "Changements de prix", "Modifiche prezzi", "Alterações de preço",
    "Cambios de precio", "Изменения цен", "Zmiany cen", "pricing_changes_summary"
  ],
  pricing_field: [
    "Price Band", "Price Band", "価格帯", "价格范围",
    "Preisstufe", "Tranche de prix", "Fascia di prezzo", "Faixa de preço",
    "Banda de precio", "Ценовая категория", "Przedział cenowy", "pricing_field"
  ],
  old_price: [
    "Old Price", "Old Price", "旧価格", "旧价格",
    "Alter Preis", "Ancien prix", "Vecchio prezzo", "Preço antigo",
    "Precio anterior", "Старая цена", "Stara cena", "old_price"
  ],
  new_price: [
    "New Price", "New Price", "新価格", "新价格",
    "Neuer Preis", "Nouveau prix", "Nuovo prezzo", "Novo preço",
    "Nuevo precio", "Новая цена", "Nowa cena", "new_price"
  ],
  device_category_label: [
    "Device Category", "Device Category", "デバイスカテゴリ", "设备类别",
    "Gerätekategorie", "Catégorie d'appareil", "Categoria dispositivo", "Categoria de dispositivo",
    "Categoría de dispositivo", "Категория устройства", "Kategoria urządzenia", "device_category_label"
  ],
  pricing_confirm_type_tier_name: [
    "To confirm, type the tier name \"{tierName}\" below",
    "To confirm, type the tier name \"{tierName}\" below",
    "確認するため、以下にティア名「{tierName}」を入力してください",
    "要确认，请在下方输入等级名称 {tierName}",
    "Zur Bestätigung geben Sie den Stufennamen \"{tierName}\" unten ein",
    "Pour confirmer, saisissez le nom du niveau \"{tierName}\" ci-dessous",
    "Per confermare, digita il nome del livello \"{tierName}\" qui sotto",
    "Para confirmar, digite o nome do nível \"{tierName}\" abaixo",
    "Para confirmar, escriba el nombre del nivel \"{tierName}\" a continuación",
    "Для подтверждения введите название уровня '{tierName}' ниже",
    "Aby potwierdzic, wpisz nazwe poziomu '{tierName}' ponizej",
    "pricing_confirm_type_tier_name"
  ],
  tier_name_label: [
    "Tier Name", "Tier Name", "ティア名", "等级名称",
    "Stufenname", "Nom du niveau", "Nome livello", "Nome do nível",
    "Nombre del nivel", "Название уровня", "Nazwa poziomu", "tier_name_label"
  ],
  confirm_update_prices: [
    "Confirm & Update Prices", "Confirm & Update Prices", "確認して価格を更新", "确认并更新价格",
    "Bestätigen & Preise aktualisieren", "Confirmer et mettre à jour les prix", "Conferma e aggiorna prezzi", "Confirmar e atualizar preços",
    "Confirmar y actualizar precios", "Подтвердить и обновить цены", "Potwierdź i zaktualizuj ceny", "confirm_update_prices"
  ],
  subscription_wizard_payment_system_unavailable: [
    "Payment system is not ready. Please try again.", "Payment system is not ready. Please try again.", "決済システムの準備ができていません。もう一度お試しください。", "支付系统尚未准备就绪。请重试。",
    "Das Zahlungssystem ist nicht bereit. Bitte versuchen Sie es erneut.", "Le système de paiement n'est pas prêt. Veuillez réessayer.", "Il sistema di pagamento non è pronto. Riprova.", "O sistema de pagamento não está pronto. Tente novamente.",
    "El sistema de pago no está listo. Inténtelo de nuevo.", "Платежная система не готова. Повторите попытку.", "System płatności nie jest gotowy. Spróbuj ponownie.", "subscription_wizard_payment_system_unavailable"
  ],
  subscription_wizard_accept_terms_error: [
    "Please accept the terms and conditions to proceed.", "Please accept the terms and conditions to proceed.", "続行するには利用規約に同意してください。", "请接受条款和条件以继续。",
    "Bitte akzeptieren Sie die Geschäftsbedingungen, um fortzufahren.", "Veuillez accepter les conditions générales pour continuer.", "Accetta i termini e le condizioni per procedere.", "Aceite os termos e condições para continuar.",
    "Acepte los términos y condiciones para continuar.", "Примите условия, чтобы продолжить.", "Zaakceptuj regulamin, aby kontynuować.", "subscription_wizard_accept_terms_error"
  ],
  subscription_wizard_payment_submit_failed: [
    "Failed to submit payment details", "Failed to submit payment details", "支払い情報を送信できませんでした", "无法提交付款详细信息",
    "Zahlungsdaten konnten nicht übermittelt werden", "Échec de l'envoi des informations de paiement", "Impossibile inviare i dati di pagamento", "Não foi possível enviar os dados de pagamento",
    "No se pudieron enviar los datos de pago", "Не удалось отправить платежные данные", "Nie udało się przesłać danych płatności", "subscription_wizard_payment_submit_failed"
  ],
  subscription_wizard_payment_failed: [
    "Payment failed", "Payment failed", "支払いに失敗しました", "付款失败", "Zahlung fehlgeschlagen", "Échec du paiement", "Pagamento non riuscito", "Falha no pagamento",
    "El pago ha fallado", "Платеж не выполнен", "Płatność nie powiodła się", "subscription_wizard_payment_failed"
  ],
  subscription_wizard_payment_status: [
    "Payment status ${status}", "Payment status ${status}", "支払い状況 ${status}", "付款状态 ${status}", "Zahlungsstatus ${status}", "Statut du paiement ${status}", "Stato del pagamento ${status}", "Estado do pagamento ${status}",
    "Estado del pago ${status}", "Статус платежа ${status}", "Status płatności ${status}", "subscription_wizard_payment_status"
  ],
  subscription_wizard_sold_by: [
    "Sold and invoiced by ${seller}", "Sold and invoiced by ${seller}", "販売・請求元: ${seller}", "销售和开票方：${seller}", "Verkauf und Rechnungsstellung durch ${seller}", "Vendu et facturé par ${seller}", "Venduto e fatturato da ${seller}", "Vendido e faturado por ${seller}",
    "Vendido y facturado por ${seller}", "Продавец и плательщик счёта: ${seller}", "Sprzedawca i wystawca faktury: ${seller}", "subscription_wizard_sold_by"
  ],
  subscription_wizard_country_seller_hint: [
    "Your billing country decides which Trend Networks company sells and invoices your subscription.", "Your billing country decides which Trend Networks company sells and invoices your subscription.", "請求先の国によって、サブスクリプションを販売・請求するTrend Networksの会社が決まります。", "您的账单所在国家/地区决定由哪家 Trend Networks 公司销售并开具订阅发票。", "Ihr Rechnungsland bestimmt, welches Trend Networks Unternehmen Ihr Abonnement verkauft und in Rechnung stellt.", "Votre pays de facturation détermine quelle société Trend Networks vend et facture votre abonnement.", "Il paese di fatturazione determina quale società Trend Networks vende e fattura il tuo abbonamento.", "O seu país de faturação determina qual empresa da Trend Networks vende e fatura a sua subscrição.",
    "Su país de facturación determina qué empresa de Trend Networks vende y factura su suscripción.", "Страна выставления счёта определяет, какая компания Trend Networks продаёт подписку и выставляет счета.", "Kraj rozliczeniowy decyduje o tym, która spółka Trend Networks sprzedaje subskrypcję i wystawia faktury.", "subscription_wizard_country_seller_hint"
  ],
  subscription_wizard_no_countries_available: [
    "Subscriptions are not currently available. Please try again later or contact support.", "Subscriptions are not currently available. Please try again later or contact support.", "現在サブスクリプションはご利用いただけません。後でもう一度お試しいただくか、サポートにお問い合わせください。", "订阅目前不可用。请稍后再试或联系支持人员。", "Abonnements sind derzeit nicht verfügbar. Bitte versuchen Sie es später erneut oder wenden Sie sich an den Support.", "Les abonnements ne sont pas disponibles pour le moment. Veuillez réessayer plus tard ou contacter l'assistance.", "Gli abbonamenti non sono al momento disponibili. Riprova più tardi o contatta l'assistenza.", "As subscrições não estão disponíveis neste momento. Tente novamente mais tarde ou contacte o suporte.",
    "Las suscripciones no están disponibles en este momento. Inténtelo de nuevo más tarde o póngase en contacto con el soporte.", "Подписки сейчас недоступны. Повторите попытку позже или обратитесь в службу поддержки.", "Subskrypcje są obecnie niedostępne. Spróbuj ponownie później lub skontaktuj się z pomocą techniczną.", "subscription_wizard_no_countries_available"
  ],
  stripe_seller_label: [
    "Stripe seller", "Stripe seller", "Stripe販売元", "Stripe 卖家", "Stripe-Verkäufer", "Vendeur Stripe", "Venditore Stripe", "Vendedor Stripe",
    "Vendedor de Stripe", "Продавец Stripe", "Sprzedawca Stripe", "stripe_seller_label"
  ],
  stripe_seller_description: [
    "Which company sells to this country. Existing subscriptions keep their original seller.", "Which company sells to this country. Existing subscriptions keep their original seller.", "この国に販売する会社です。既存のサブスクリプションは元の販売元のままです。", "向该国家/地区销售的公司。现有订阅保持原卖家不变。", "Welches Unternehmen in dieses Land verkauft. Bestehende Abonnements behalten ihren ursprünglichen Verkäufer.", "La société qui vend dans ce pays. Les abonnements existants conservent leur vendeur d'origine.", "La società che vende in questo paese. Gli abbonamenti esistenti mantengono il venditore originale.", "A empresa que vende neste país. As subscrições existentes mantêm o vendedor original.",
    "La empresa que vende en este país. Las suscripciones existentes conservan su vendedor original.", "Компания, которая продаёт в эту страну. Существующие подписки сохраняют прежнего продавца.", "Spółka sprzedająca w tym kraju. Istniejące subskrypcje zachowują pierwotnego sprzedawcę.", "stripe_seller_description"
  ],
  stripe_seller_none: [
    "Not assigned (checkout unavailable)", "Not assigned (checkout unavailable)", "未割り当て（購入不可）", "未分配（无法结账）", "Nicht zugewiesen (Kauf nicht möglich)", "Non attribué (paiement indisponible)", "Non assegnato (acquisto non disponibile)", "Não atribuído (compra indisponível)",
    "Sin asignar (compra no disponible)", "Не назначен (оформление недоступно)", "Nieprzypisany (zakup niedostępny)", "stripe_seller_none"
  ],
  stripe_account_id: [
    "Stripe account ID", "Stripe account ID", "StripeアカウントID", "Stripe 账户 ID", "Stripe-Konto-ID", "ID du compte Stripe", "ID account Stripe", "ID da conta Stripe",
    "ID de cuenta de Stripe", "ID учётной записи Stripe", "Identyfikator konta Stripe", "stripe_account_id"
  ],
  subscription_wizard_payment_summary: [
    "Payment Summary", "Payment Summary", "支払い概要", "付款摘要", "Zahlungsübersicht", "Récapitulatif du paiement", "Riepilogo pagamento", "Resumo do pagamento",
    "Resumen del pago", "Сводка платежа", "Podsumowanie płatności", "subscription_wizard_payment_summary"
  ],
  subscription_wizard_subtotal_excl_tax: [
    "Subtotal excluding tax", "Subtotal excluding tax", "税抜き小計", "未含税小计", "Zwischensumme ohne Steuern", "Sous total hors taxes", "Subtotale escluse le imposte", "Subtotal sem impostos",
    "Subtotal sin impuestos", "Промежуточный итог без налога", "Suma częściowa bez podatku", "subscription_wizard_subtotal_excl_tax"
  ],
  subscription_wizard_tax: [
    "Tax", "Tax", "税", "税", "Steuer", "Taxe", "Imposta", "Imposto", "Impuesto", "Налог", "Podatek", "subscription_wizard_tax"
  ],
  subscription_wizard_monthly_total: [
    "Monthly total", "Monthly total", "月額合計", "每月总计", "Monatlicher Gesamtbetrag", "Total mensuel", "Totale mensile", "Total mensal", "Total mensual", "Ежемесячная сумма", "Suma miesięczna", "subscription_wizard_monthly_total"
  ],
  subscription_wizard_payment_method: [
    "Payment Method", "Payment Method", "支払い方法", "付款方式", "Zahlungsmethode", "Mode de paiement", "Metodo di pagamento", "Método de pagamento", "Método de pago", "Способ оплаты", "Metoda płatności", "subscription_wizard_payment_method"
  ],
  subscription_wizard_terms_notice: [
    "By clicking Pay Now you agree to be charged ${amount} monthly for the Plus subscription. Your subscription renews monthly until cancelled.", "By clicking Pay Now you agree to be charged ${amount} monthly for the Plus subscription. Your subscription renews monthly until cancelled.", "今すぐ支払うをクリックすると、Plus サブスクリプションに毎月 ${amount} が請求されることに同意したことになります。サブスクリプションはキャンセルするまで毎月更新されます。", "点击立即付款即表示您同意每月为 Plus 订阅支付 ${amount}。您的订阅将每月续订，直至取消。",
    "Mit Klick auf Jetzt bezahlen stimmen Sie einer monatlichen Belastung von ${amount} für das Plus Abonnement zu. Ihr Abonnement verlängert sich monatlich bis zur Kündigung.", "En cliquant sur Payer maintenant, vous acceptez un prélèvement mensuel de ${amount} pour l'abonnement Plus. Votre abonnement se renouvelle chaque mois jusqu'à son annulation.", "Facendo clic su Paga ora accetti un addebito mensile di ${amount} per l'abbonamento Plus. L'abbonamento si rinnova mensilmente fino alla cancellazione.", "Ao clicar em Pagar agora, aceita uma cobrança mensal de ${amount} pela subscrição Plus. A subscrição é renovada mensalmente até ao cancelamento.",
    "Al hacer clic en Pagar ahora acepta un cargo mensual de ${amount} por la suscripción Plus. La suscripción se renueva mensualmente hasta que se cancele.", "Нажимая Оплатить сейчас, вы соглашаетесь на ежемесячное списание ${amount} за подписку Plus. Подписка продлевается ежемесячно до отмены.", "Klikając Zapłać teraz, akceptujesz miesięczną opłatę ${amount} za subskrypcję Plus. Subskrypcja odnawia się co miesiąc do anulowania.", "subscription_wizard_terms_notice"
  ],
  subscription_wizard_agree_to: [
    "I agree to the", "I agree to the", "次の内容に同意します", "我同意", "Ich stimme den folgenden zu", "J'accepte les", "Accetto i", "Concordo com os", "Acepto los", "Я соглашаюсь с", "Akceptuję", "subscription_wizard_agree_to"
  ],
  subscription_wizard_processing_payment: [
    "Processing payment", "Processing payment", "支払いを処理中", "正在处理付款", "Zahlung wird verarbeitet", "Paiement en cours", "Elaborazione del pagamento", "A processar pagamento", "Procesando el pago", "Обработка платежа", "Przetwarzanie płatności", "subscription_wizard_processing_payment"
  ],
  subscription_wizard_pay_amount: [
    "Pay ${amount}", "Pay ${amount}", "${amount} を支払う", "支付 ${amount}", "${amount} bezahlen", "Payer ${amount}", "Paga ${amount}", "Pagar ${amount}", "Pagar ${amount}", "Оплатить ${amount}", "Zapłać ${amount}", "subscription_wizard_pay_amount"
  ],
  subscription_wizard_loading_pricing: [
    "Loading pricing information", "Loading pricing information", "価格情報を読み込み中", "正在加载价格信息", "Preisinformationen werden geladen", "Chargement des informations tarifaires", "Caricamento delle informazioni sui prezzi", "A carregar informações de preços", "Cargando información de precios", "Загрузка информации о ценах", "Ładowanie informacji o cenach", "subscription_wizard_loading_pricing"
  ],
  subscription_wizard_payment_success: [
    "Payment Successful", "Payment Successful", "支払いが完了しました", "付款成功", "Zahlung erfolgreich", "Paiement réussi", "Pagamento riuscito", "Pagamento efetuado", "Pago realizado", "Платеж выполнен", "Płatność zakończona", "subscription_wizard_payment_success"
  ],
  subscription_wizard_success_description: [
    "Thank you for upgrading to Plus. Your subscription is now active.", "Thank you for upgrading to Plus. Your subscription is now active.", "Plus へのアップグレードありがとうございます。サブスクリプションが有効になりました。", "感谢您升级到 Plus。您的订阅现已激活。", "Vielen Dank für Ihr Upgrade auf Plus. Ihr Abonnement ist jetzt aktiv.", "Merci d'être passé à Plus. Votre abonnement est maintenant actif.", "Grazie per aver scelto Plus. Il tuo abbonamento è ora attivo.", "Obrigado por atualizar para Plus. A sua subscrição está agora ativa.", "Gracias por actualizar a Plus. Su suscripción ya está activa.", "Спасибо за переход на Plus. Ваша подписка активна.", "Dziękujemy za przejście na Plus. Twoja subskrypcja jest aktywna.", "subscription_wizard_success_description"
  ],
  subscription_wizard_closing_in_seconds: [
    "Closing in ${count} seconds", "Closing in ${count} seconds", "${count} 秒後に閉じます", "将在 ${count} 秒后关闭", "Wird in ${count} Sekunden geschlossen", "Fermeture dans ${count} secondes", "Chiusura tra ${count} secondi", "A fechar em ${count} segundos", "Se cerrará en ${count} segundos", "Закрытие через ${count} секунд", "Zamknięcie za ${count} sekund", "subscription_wizard_closing_in_seconds"
  ],
  subscription_wizard_close_now: [
    "Close Now", "Close Now", "今すぐ閉じる", "立即关闭", "Jetzt schließen", "Fermer maintenant", "Chiudi ora", "Fechar agora", "Cerrar ahora", "Закрыть сейчас", "Zamknij teraz", "subscription_wizard_close_now"
  ],
  subscription_wizard_upgrade_to_plus: [
    "Upgrade to Plus", "Upgrade to Plus", "Plus にアップグレード", "升级到 Plus", "Upgrade auf Plus", "Passer à Plus", "Passa a Plus", "Atualizar para Plus", "Actualizar a Plus", "Перейти на Plus", "Przejdź na Plus", "subscription_wizard_upgrade_to_plus"
  ],
  subscription_wizard_price_breakdown: [
    "Your Price Breakdown", "Your Price Breakdown", "料金の内訳", "您的价格明细", "Ihre Preisaufschlüsselung", "Détail de votre prix", "Dettaglio del prezzo", "Detalhe do preço", "Desglose de precio", "Расчет стоимости", "Podział ceny", "subscription_wizard_price_breakdown"
  ],
  subscription_wizard_billing_details: [
    "Billing Details", "Billing Details", "請求先の詳細", "账单详细信息", "Rechnungsdetails", "Détails de facturation", "Dati di fatturazione", "Dados de faturação", "Datos de facturación", "Платежные реквизиты", "Dane rozliczeniowe", "subscription_wizard_billing_details"
  ],
  subscription_wizard_complete_payment: [
    "Complete Payment", "Complete Payment", "支払いを完了", "完成付款", "Zahlung abschließen", "Finaliser le paiement", "Completa il pagamento", "Concluir pagamento", "Completar pago", "Завершить оплату", "Zakończ płatność", "subscription_wizard_complete_payment"
  ],
  subscription_wizard_error: [
    "Error", "Error", "エラー", "错误", "Fehler", "Erreur", "Errore", "Erro", "Error", "Ошибка", "Błąd", "subscription_wizard_error"
  ],
  subscription_wizard_step_of_total: [
    "Step ${step} of ${total}", "Step ${step} of ${total}", "ステップ ${step} / ${total}", "第 ${step} 步，共 ${total} 步", "Schritt ${step} von ${total}", "Étape ${step} sur ${total}", "Passaggio ${step} di ${total}", "Passo ${step} de ${total}", "Paso ${step} de ${total}", "Шаг ${step} из ${total}", "Krok ${step} z ${total}", "subscription_wizard_step_of_total"
  ],
  subscription_wizard_pricing_question: [
    "How is the ${plan} subscription priced?", "How is the ${plan} subscription priced?", "${plan} サブスクリプションの料金はどのように決まりますか", "${plan} 订阅如何定价", "Wie wird das ${plan} Abonnement berechnet?", "Comment est calculé le prix de l'abonnement ${plan} ?", "Come viene calcolato il prezzo dell'abbonamento ${plan}?", "Como é calculado o preço da subscrição ${plan}?", "¿Cómo se calcula el precio de la suscripción ${plan}?", "Как рассчитывается стоимость подписки ${plan}?", "Jak jest obliczana cena subskrypcji ${plan}?", "subscription_wizard_pricing_question"
  ],
  subscription_wizard_pricing_explanation: [
    "The ${plan} subscription cost depends on the number and type of devices registered to your organisation. Below are the monthly prices per device used to calculate your total.", "The ${plan} subscription cost depends on the number and type of devices registered to your organisation. Below are the monthly prices per device used to calculate your total.", "${plan} サブスクリプションの料金は、組織に登録されているデバイスの数と種類によって決まります。以下は合計の計算に使用されるデバイスごとの月額料金です。", "${plan} 订阅费用取决于注册到您组织的设备数量和类型。以下是用于计算总额的每台设备月费。", "Die Kosten für das ${plan} Abonnement richten sich nach Anzahl und Typ der für Ihre Organisation registrierten Geräte. Nachfolgend finden Sie die monatlichen Preise pro Gerät zur Berechnung Ihres Gesamtbetrags.", "Le coût de l'abonnement ${plan} dépend du nombre et du type d'appareils enregistrés pour votre organisation. Les prix mensuels par appareil ci-dessous servent à calculer votre total.", "Il costo dell'abbonamento ${plan} dipende dal numero e dal tipo di dispositivi registrati per la tua organizzazione. Di seguito sono riportati i prezzi mensili per dispositivo usati per calcolare il totale.", "O custo da subscrição ${plan} depende do número e tipo de dispositivos registados na sua organização. Abaixo estão os preços mensais por dispositivo usados para calcular o total.", "El coste de la suscripción ${plan} depende del número y tipo de dispositivos registrados en su organización. A continuación se muestran los precios mensuales por dispositivo usados para calcular el total.", "Стоимость подписки ${plan} зависит от количества и типа устройств, зарегистрированных в вашей организации. Ниже приведены ежемесячные цены за устройство для расчета общей суммы.", "Koszt subskrypcji ${plan} zależy od liczby i typu urządzeń zarejestrowanych w organizacji. Poniżej znajdują się miesięczne ceny za urządzenie używane do obliczenia sumy.", "subscription_wizard_pricing_explanation"
  ],
  subscription_wizard_tier_device: [
    "Tier and device", "Tier and device", "階層とデバイス", "套餐和设备", "Stufe und Gerät", "Niveau et appareil", "Livello e dispositivo", "Nível e dispositivo", "Nivel y dispositivo", "Уровень и устройство", "Poziom i urządzenie", "subscription_wizard_tier_device"
  ],
  subscription_wizard_one_device: [
    "1 device", "1 device", "1 台のデバイス", "1 台设备", "1 Gerät", "1 appareil", "1 dispositivo", "1 dispositivo", "1 dispositivo", "1 устройство", "1 urządzenie", "subscription_wizard_one_device"
  ],
  subscription_wizard_two_to_five_devices: [
    "2 to 5 devices", "2 to 5 devices", "2 から 5 台のデバイス", "2 到 5 台设备", "2 bis 5 Geräte", "2 à 5 appareils", "Da 2 a 5 dispositivi", "2 a 5 dispositivos", "De 2 a 5 dispositivos", "От 2 до 5 устройств", "Od 2 do 5 urządzeń", "subscription_wizard_two_to_five_devices"
  ],
  subscription_wizard_six_or_more_devices: [
    "6 or more devices", "6 or more devices", "6 台以上のデバイス", "6 台或更多设备", "6 oder mehr Geräte", "6 appareils ou plus", "6 o più dispositivi", "6 ou mais dispositivos", "6 o más dispositivos", "6 или более устройств", "6 lub więcej urządzeń", "subscription_wizard_six_or_more_devices"
  ],
  subscription_wizard_per_month: [
    "${amount} per month", "${amount} per month", "月額 ${amount}", "每月 ${amount}", "${amount} pro Monat", "${amount} par mois", "${amount} al mese", "${amount} por mês", "${amount} al mes", "${amount} в месяц", "${amount} miesięcznie", "subscription_wizard_per_month"
  ],
  subscription_wizard_per_month_each: [
    "${amount} per month each", "${amount} per month each", "1 台あたり月額 ${amount}", "每台每月 ${amount}", "${amount} pro Monat je Gerät", "${amount} par mois chacun", "${amount} al mese ciascuno", "${amount} por mês cada", "${amount} al mes cada uno", "${amount} в месяц за устройство", "${amount} miesięcznie za urządzenie", "subscription_wizard_per_month_each"
  ],
  subscription_wizard_prices_note: [
    "Prices shown in ${currency}. Tax is calculated at checkout based on your location.", "Prices shown in ${currency}. Tax is calculated at checkout based on your location.", "価格は ${currency} で表示されています。税額は所在地に基づいてチェックアウト時に計算されます。", "价格以 ${currency} 显示。税费将在结账时根据您的所在地计算。", "Die Preise werden in ${currency} angezeigt. Die Steuer wird beim Bezahlen anhand Ihres Standorts berechnet.", "Les prix sont affichés en ${currency}. La taxe est calculée au paiement selon votre emplacement.", "I prezzi sono indicati in ${currency}. L'imposta viene calcolata al pagamento in base alla tua posizione.", "Os preços são apresentados em ${currency}. O imposto é calculado no pagamento com base na sua localização.", "Los precios se muestran en ${currency}. El impuesto se calcula al pagar según su ubicación.", "Цены указаны в ${currency}. Налог рассчитывается при оплате на основе вашего местоположения.", "Ceny są podane w ${currency}. Podatek jest obliczany przy płatności na podstawie lokalizacji.", "subscription_wizard_prices_note"
  ],
  subscription_wizard_registered_devices: [
    "Your Registered Devices ${count} total", "Your Registered Devices ${count} total", "登録済みデバイス 合計 ${count}", "您的已注册设备 共 ${count} 台", "Ihre registrierten Geräte insgesamt ${count}", "Vos appareils enregistrés ${count} au total", "I tuoi dispositivi registrati ${count} in totale", "Os seus dispositivos registados ${count} no total", "Sus dispositivos registrados ${count} en total", "Ваши зарегистрированные устройства всего ${count}", "Zarejestrowane urządzenia łącznie ${count}", "subscription_wizard_registered_devices"
  ],
  subscription_wizard_device_count: [
    "${count} device", "${count} device", "${count} 台のデバイス", "${count} 台设备", "${count} Gerät", "${count} appareil", "${count} dispositivo", "${count} dispositivo", "${count} dispositivo", "${count} устройство", "${count} urządzenie", "subscription_wizard_device_count"
  ],
  subscription_wizard_monthly_breakdown: [
    "${price} per month for ${count} devices totals ${total} per month", "${price} per month for ${count} devices totals ${total} per month", "${count} 台のデバイスは月額 ${price} で合計月額 ${total}", "${count} 台设备每月 ${price}，合计每月 ${total}", "${price} pro Monat für ${count} Geräte ergibt ${total} pro Monat", "${price} par mois pour ${count} appareils fait un total de ${total} par mois", "${price} al mese per ${count} dispositivi per un totale di ${total} al mese", "${price} por mês para ${count} dispositivos totaliza ${total} por mês", "${price} al mes para ${count} dispositivos suma ${total} al mes", "${price} в месяц за ${count} устройств составляет ${total} в месяц", "${price} miesięcznie za ${count} urządzeń daje ${total} miesięcznie", "subscription_wizard_monthly_breakdown"
  ],
  subscription_wizard_total_before_tax: [
    "Total before tax", "Total before tax", "税抜き合計", "税前总计", "Gesamtbetrag vor Steuern", "Total hors taxes", "Totale prima delle imposte", "Total antes de impostos", "Total antes de impuestos", "Итого до налога", "Suma przed podatkiem", "subscription_wizard_total_before_tax"
  ],
  subscription_wizard_no_devices: [
    "No devices found. Please register at least one device before subscribing.", "No devices found. Please register at least one device before subscribing.", "デバイスが見つかりません。購読する前に少なくとも 1 台のデバイスを登録してください。", "未找到设备。订阅前请至少注册一台设备。", "Keine Geräte gefunden. Bitte registrieren Sie vor dem Abonnieren mindestens ein Gerät.", "Aucun appareil trouvé. Veuillez enregistrer au moins un appareil avant de vous abonner.", "Nessun dispositivo trovato. Registra almeno un dispositivo prima di abbonarti.", "Não foram encontrados dispositivos. Registe pelo menos um dispositivo antes de subscrever.", "No se encontraron dispositivos. Registre al menos un dispositivo antes de suscribirse.", "Устройства не найдены. Зарегистрируйте хотя бы одно устройство перед подпиской.", "Nie znaleziono urządzeń. Zarejestruj co najmniej jedno urządzenie przed subskrypcją.", "subscription_wizard_no_devices"
  ],
  subscription_wizard_billing_currency: [
    "Billing Currency", "Billing Currency", "請求通貨", "账单货币", "Abrechnungswährung", "Devise de facturation", "Valuta di fatturazione", "Moeda de faturação", "Moneda de facturación", "Валюта счета", "Waluta rozliczenia", "subscription_wizard_billing_currency"
  ],
  subscription_wizard_full_name: [
    "Full Name", "Full Name", "氏名", "姓名", "Vollständiger Name", "Nom complet", "Nome completo", "Nome completo", "Nombre completo", "Полное имя", "Imię i nazwisko", "subscription_wizard_full_name"
  ],
  subscription_wizard_company_name: [
    "Company Name", "Company Name", "会社名", "公司名称", "Firmenname", "Nom de l'entreprise", "Nome azienda", "Nome da empresa", "Nombre de la empresa", "Название компании", "Nazwa firmy", "subscription_wizard_company_name"
  ],
  subscription_wizard_address_line_one: [
    "Address Line 1", "Address Line 1", "住所 1", "地址行 1", "Adresszeile 1", "Adresse ligne 1", "Indirizzo riga 1", "Linha de endereço 1", "Línea de dirección 1", "Адресная строка 1", "Adres wiersz 1", "subscription_wizard_address_line_one"
  ],
  subscription_wizard_address_line_two: [
    "Address Line 2", "Address Line 2", "住所 2", "地址行 2", "Adresszeile 2", "Adresse ligne 2", "Indirizzo riga 2", "Linha de endereço 2", "Línea de dirección 2", "Адресная строка 2", "Adres wiersz 2", "subscription_wizard_address_line_two"
  ],
  subscription_wizard_state_province: [
    "State or Province", "State or Province", "州または県", "州或省", "Bundesland oder Provinz", "État ou province", "Stato o provincia", "Estado ou província", "Estado o provincia", "Штат или область", "Stan lub województwo", "subscription_wizard_state_province"
  ],
  subscription_wizard_postal_code: [
    "Postal Code", "Postal Code", "郵便番号", "邮政编码", "Postleitzahl", "Code postal", "Codice postale", "Código postal", "Código postal", "Почтовый индекс", "Kod pocztowy", "subscription_wizard_postal_code"
  ],
  subscription_wizard_vat_number: [
    "VAT Number optional", "VAT Number optional", "VAT 番号 任意", "增值税号 可选", "Umsatzsteuer ID optional", "Numéro de TVA facultatif", "Partita IVA facoltativa", "Número de IVA opcional", "Número de IVA opcional", "Номер НДС необязательно", "Numer VAT opcjonalnie", "subscription_wizard_vat_number"
  ],
  subscription_wizard_vat_description: [
    "For EU and UK businesses", "For EU and UK businesses", "EU と英国の事業者向け", "适用于欧盟和英国企业", "Für Unternehmen in der EU und im Vereinigten Königreich", "Pour les entreprises de l'UE et du Royaume Uni", "Per le aziende dell'UE e del Regno Unito", "Para empresas da UE e do Reino Unido", "Para empresas de la UE y del Reino Unido", "Для компаний из ЕС и Великобритании", "Dla firm z UE i Wielkiej Brytanii", "subscription_wizard_vat_description"
  ],
  subscription_wizard_estimated_price: [
    "Your estimated price", "Your estimated price", "見積もり価格", "您的预估价格", "Ihr geschätzter Preis", "Votre prix estimé", "Il tuo prezzo stimato", "O seu preço estimado", "Su precio estimado", "Ваша расчетная цена", "Szacowana cena", "subscription_wizard_estimated_price"
  ],
  subscription_wizard_applicable_taxes: [
    "applicable taxes", "applicable taxes", "該当する税金", "适用税费", "zuzüglich anfallender Steuern", "taxes applicables", "imposte applicabili", "impostos aplicáveis", "impuestos aplicables", "применимые налоги", "należne podatki", "subscription_wizard_applicable_taxes"
  ],
  subscription_wizard_preparing_checkout: [
    "Preparing checkout", "Preparing checkout", "チェックアウトを準備中", "正在准备结账", "Bezahlvorgang wird vorbereitet", "Préparation du paiement", "Preparazione del pagamento", "A preparar pagamento", "Preparando el pago", "Подготовка оплаты", "Przygotowywanie płatności", "subscription_wizard_preparing_checkout"
  ],
  subscription_wizard_checkout_initialization_failed: [
    "Failed to initialize checkout", "Failed to initialize checkout", "チェックアウトを初期化できませんでした", "无法初始化结账", "Bezahlvorgang konnte nicht initialisiert werden", "Impossible d'initialiser le paiement", "Impossibile inizializzare il pagamento", "Não foi possível inicializar o pagamento", "No se pudo inicializar el pago", "Не удалось инициализировать оплату", "Nie udało się zainicjować płatności", "subscription_wizard_checkout_initialization_failed"
  ],
  subscription_wizard_go_back: [
    "Go Back", "Go Back", "戻る", "返回", "Zurück", "Retour", "Indietro", "Voltar", "Volver", "Назад", "Wróć", "subscription_wizard_go_back"
  ],
  subscription_wizard_initializing_payment: [
    "Initializing payment", "Initializing payment", "支払いを初期化中", "正在初始化付款", "Zahlung wird initialisiert", "Initialisation du paiement", "Inizializzazione del pagamento", "A inicializar pagamento", "Inicializando el pago", "Инициализация платежа", "Inicjowanie płatności", "subscription_wizard_initializing_payment"
  ],
  subscription_wizard_back: [
    "Back", "Back", "戻る", "返回", "Zurück", "Retour", "Indietro", "Voltar", "Atrás", "Назад", "Wstecz", "subscription_wizard_back"
  ],
  subscription_wizard_proceed_to_payment: [
    "Proceed to Payment", "Proceed to Payment", "支払いに進む", "前往付款", "Weiter zur Zahlung", "Passer au paiement", "Procedi al pagamento", "Avançar para pagamento", "Proceder al pago", "Перейти к оплате", "Przejdź do płatności", "subscription_wizard_proceed_to_payment"
  ],
  subscription_wizard_next: [
    "Next", "Next", "次へ", "下一步", "Weiter", "Suivant", "Avanti", "Seguinte", "Siguiente", "Далее", "Dalej", "subscription_wizard_next"
  ],
  subscription_dialog_my_subscription: [
    "My Subscription", "My Subscription", "マイサブスクリプション", "我的订阅", "Mein Abonnement", "Mon abonnement", "Il mio abbonamento", "A minha subscrição", "Mi suscripción", "Моя подписка", "Moja subskrypcja", "subscription_dialog_my_subscription"
  ],
  subscription_dialog_plus_pending: [
    "Plus Subscription Pending", "Plus Subscription Pending", "Plus サブスクリプションは保留中", "Plus 订阅待处理", "Plus Abonnement ausstehend", "Abonnement Plus en attente", "Abbonamento Plus in attesa", "Subscrição Plus pendente", "Suscripción Plus pendiente", "Подписка Plus ожидает обработки", "Subskrypcja Plus oczekuje", "subscription_dialog_plus_pending"
  ],
  subscription_dialog_plus_plan: [
    "Plus Plan", "Plus Plan", "Plus プラン", "Plus 计划", "Plus Plan", "Forfait Plus", "Piano Plus", "Plano Plus", "Plan Plus", "Тариф Plus", "Plan Plus", "subscription_dialog_plus_plan"
  ],
  subscription_dialog_payment_overdue: [
    "Payment Overdue", "Payment Overdue", "支払い期限超過", "付款逾期", "Zahlung überfällig", "Paiement en retard", "Pagamento scaduto", "Pagamento em atraso",
    "Pago vencido", "Платёж просрочен", "Zaległa płatność", "subscription_dialog_payment_overdue"
  ],
  subscription_dialog_payment_overdue_description: [
    "Your latest payment did not go through. Use Manage Subscription to update your payment method and keep your Plus features.", "Your latest payment did not go through. Use Manage Subscription to update your payment method and keep your Plus features.", "最新の支払いが完了しませんでした。「サブスクリプションを管理」から支払い方法を更新して、Plus機能を維持してください。", "您最近的付款未成功。请使用“管理订阅”更新付款方式，以继续使用 Plus 功能。", "Ihre letzte Zahlung wurde nicht durchgeführt. Aktualisieren Sie Ihre Zahlungsmethode unter „Abonnement verwalten“, um Ihre Plus-Funktionen zu behalten.", "Votre dernier paiement n'a pas abouti. Utilisez « Gérer l'abonnement » pour mettre à jour votre moyen de paiement et conserver vos fonctionnalités Plus.", "L'ultimo pagamento non è andato a buon fine. Usa «Gestisci abbonamento» per aggiornare il metodo di pagamento e mantenere le funzionalità Plus.", "O seu último pagamento não foi concluído. Use «Gerir subscrição» para atualizar o método de pagamento e manter as funcionalidades Plus.",
    "Su último pago no se completó. Use «Administrar suscripción» para actualizar su método de pago y conservar las funciones Plus.", "Последний платёж не прошёл. Откройте «Управление подпиской», чтобы обновить способ оплаты и сохранить функции Plus.", "Ostatnia płatność nie została zrealizowana. Użyj opcji „Zarządzaj subskrypcją”, aby zaktualizować metodę płatności i zachować funkcje Plus.", "subscription_dialog_payment_overdue_description"
  ],
  subscription_dialog_payment_processing: [
    "Payment Processing", "Payment Processing", "支払い処理中", "正在处理付款", "Zahlung wird verarbeitet", "Paiement en cours", "Elaborazione del pagamento", "Pagamento em processamento", "Procesando el pago", "Обработка платежа", "Przetwarzanie płatności", "subscription_dialog_payment_processing"
  ],
  subscription_dialog_cancellation_pending: [
    "Cancellation Pending", "Cancellation Pending", "キャンセル保留中", "取消待处理", "Kündigung ausstehend", "Annulation en attente", "Annullamento in attesa", "Cancelamento pendente", "Cancelación pendiente", "Отмена ожидает обработки", "Anulowanie oczekuje", "subscription_dialog_cancellation_pending"
  ],
  subscription_dialog_pending_description: [
    "Your subscription payment is being processed. This page will update automatically once confirmed. Please refresh in a minute.", "Your subscription payment is being processed. This page will update automatically once confirmed. Please refresh in a minute.", "サブスクリプションの支払いを処理中です。確認されるとこのページは自動的に更新されます。1 分後に更新してください。", "您的订阅付款正在处理。确认后此页面将自动更新。请在一分钟后刷新。", "Ihre Abonnementzahlung wird verarbeitet. Diese Seite wird nach der Bestätigung automatisch aktualisiert. Bitte aktualisieren Sie sie in einer Minute.", "Le paiement de votre abonnement est en cours. Cette page sera mise à jour automatiquement après confirmation. Veuillez actualiser dans une minute.", "Il pagamento dell'abbonamento è in elaborazione. Questa pagina si aggiornerà automaticamente dopo la conferma. Aggiorna tra un minuto.", "O pagamento da subscrição está a ser processado. Esta página será atualizada automaticamente após confirmação. Atualize dentro de um minuto.", "El pago de su suscripción se está procesando. Esta página se actualizará automáticamente una vez confirmado. Actualice en un minuto.", "Платеж за подписку обрабатывается. Страница обновится автоматически после подтверждения. Обновите ее через минуту.", "Płatność za subskrypcję jest przetwarzana. Strona zaktualizuje się automatycznie po potwierdzeniu. Odśwież ją za minutę.", "subscription_dialog_pending_description"
  ],
  subscription_dialog_per_month: [
    "per month", "per month", "月額", "每月", "pro Monat", "par mois", "al mese", "por mês", "al mes", "в месяц", "miesięcznie", "subscription_dialog_per_month"
  ],
  subscription_dialog_contact_sales: [
    "Contact sales", "Contact sales", "営業にお問い合わせください", "请联系销售部门", "Vertrieb kontaktieren", "Contactez le service commercial", "Contatta le vendite", "Contacte as vendas", "Contacte con ventas", "Свяжитесь с отделом продаж", "Skontaktuj się ze sprzedażą", "subscription_dialog_contact_sales"
  ],
  subscription_dialog_registered_devices: [
    "Registered Devices", "Registered Devices", "登録済みデバイス", "已注册设备", "Registrierte Geräte", "Appareils enregistrés", "Dispositivi registrati", "Dispositivos registados", "Dispositivos registrados", "Зарегистрированные устройства", "Zarejestrowane urządzenia", "subscription_dialog_registered_devices"
  ],
  subscription_dialog_plan_start: [
    "Plan Start", "Plan Start", "プラン開始", "计划开始", "Planbeginn", "Début du forfait", "Inizio piano", "Início do plano", "Inicio del plan", "Начало плана", "Początek planu", "subscription_dialog_plan_start"
  ],
  subscription_dialog_cancellation_date: [
    "Cancellation Date", "Cancellation Date", "キャンセル日", "取消日期", "Kündigungsdatum", "Date d'annulation", "Data di annullamento", "Data de cancelamento", "Fecha de cancelación", "Дата отмены", "Data anulowania", "subscription_dialog_cancellation_date"
  ],
  subscription_dialog_next_payment_date: [
    "Next Payment Date", "Next Payment Date", "次回支払日", "下次付款日期", "Nächstes Zahlungsdatum", "Prochaine date de paiement", "Prossima data di pagamento", "Próxima data de pagamento", "Próxima fecha de pago", "Следующая дата платежа", "Następna data płatności", "subscription_dialog_next_payment_date"
  ],
  subscription_dialog_included_benefits: [
    "Included Benefits", "Included Benefits", "含まれる特典", "包含的权益", "Enthaltene Vorteile", "Avantages inclus", "Vantaggi inclusi", "Benefícios incluídos", "Beneficios incluidos", "Включенные преимущества", "Zawarte korzyści", "subscription_dialog_included_benefits"
  ],
  subscription_dialog_all_basic_features: [
    "All Basic features and the following", "All Basic features and the following", "すべての Basic 機能と以下", "所有 Basic 功能和以下内容", "Alle Basic Funktionen und Folgendes", "Toutes les fonctions Basic et les suivantes", "Tutte le funzioni Basic e le seguenti", "Todas as funcionalidades Basic e as seguintes", "Todas las funciones Basic y las siguientes", "Все функции Basic и следующие", "Wszystkie funkcje Basic oraz poniższe", "subscription_dialog_all_basic_features"
  ],
  subscription_dialog_archiving: [
    "Archiving", "Archiving", "アーカイブ", "归档", "Archivierung", "Archivage", "Archiviazione", "Arquivamento", "Archivado", "Архивирование", "Archiwizacja", "subscription_dialog_archiving"
  ],
  subscription_dialog_geolocation_lock: [
    "Geolocation and Lock Unlock", "Geolocation and Lock Unlock", "位置情報とロック解除", "地理定位和锁定解锁", "Geolokalisierung und Sperren Entsperren", "Géolocalisation et verrouillage déverrouillage", "Geolocalizzazione e blocco sblocco", "Geolocalização e bloqueio desbloqueio", "Geolocalización y bloqueo desbloqueo", "Геолокация и блокировка разблокировка", "Geolokalizacja oraz blokowanie odblokowanie", "subscription_dialog_geolocation_lock"
  ],
  subscription_dialog_analytics_metrics: [
    "Analytics and Metrics", "Analytics and Metrics", "分析と指標", "分析和指标", "Analysen und Kennzahlen", "Analyses et indicateurs", "Analisi e metriche", "Análises e métricas", "Análisis y métricas", "Аналитика и метрики", "Analityka i metryki", "subscription_dialog_analytics_metrics"
  ],
  subscription_dialog_smart_flag_filter: [
    "Smart Flag Filter", "Smart Flag Filter", "スマートフラグフィルター", "智能标志筛选器", "Smart Flag Filter", "Filtre Smart Flag", "Filtro Smart Flag", "Filtro Smart Flag", "Filtro Smart Flag", "Фильтр Smart Flag", "Filtr Smart Flag", "subscription_dialog_smart_flag_filter"
  ],
  subscription_dialog_manage_subscription: [
    "Manage Subscription", "Manage Subscription", "サブスクリプションを管理", "管理订阅", "Abonnement verwalten", "Gérer l'abonnement", "Gestisci abbonamento", "Gerir subscrição", "Gestionar suscripción", "Управление подпиской", "Zarządzaj subskrypcją", "subscription_dialog_manage_subscription"
  ],

  /* Cloud Initiatives Phase 1 */
  metrics_date_from: ["From", "From", "開始", "开始", "Von", "Du", "Da", "De", "Desde", "С", "Od", "metrics_date_from"],
  metrics_date_to: ["To", "To", "終了", "结束", "Bis", "Au", "A", "Até", "Hasta", "До", "Do", "metrics_date_to"],
  metrics_start_date: ["Start date", "Start date", "開始日", "开始日期", "Startdatum", "Date de début", "Data di inizio", "Data de início", "Fecha de inicio", "Дата начала", "Data rozpoczęcia", "metrics_start_date"],
  metrics_pick_start_date: ["Pick start date", "Pick start date", "開始日を選択", "选择开始日期", "Startdatum auswählen", "Choisir la date de début", "Scegli data di inizio", "Selecionar data de início", "Elegir fecha de inicio", "Выбрать дату начала", "Wybierz datę rozpoczęcia", "metrics_pick_start_date"],
  metrics_end_date: ["End date", "End date", "終了日", "结束日期", "Enddatum", "Date de fin", "Data di fine", "Data de fim", "Fecha de finalización", "Дата окончания", "Data zakończenia", "metrics_end_date"],
  metrics_pick_end_date: ["Pick end date", "Pick end date", "終了日を選択", "选择结束日期", "Enddatum auswählen", "Choisir la date de fin", "Scegli data di fine", "Selecionar data de fim", "Elegir fecha de finalización", "Выбрать дату окончания", "Wybierz datę zakończenia", "metrics_pick_end_date"],
  metrics_loading_filters: ["Loading filters", "Loading filters", "フィルターを読み込み中", "正在加载筛选器", "Filter werden geladen", "Chargement des filtres", "Caricamento filtri", "A carregar filtros", "Cargando filtros", "Загрузка фильтров", "Ładowanie filtrów", "metrics_loading_filters"],
  metrics_generating: ["Generating metrics", "Generating metrics", "メトリクスを生成中", "正在生成指标", "Metriken werden erstellt", "Génération des indicateurs", "Generazione metriche", "A gerar métricas", "Generando métricas", "Создание показателей", "Generowanie metryk", "metrics_generating"],
  metrics_preparing: ["Preparing metrics", "Preparing metrics", "メトリクスを準備中", "正在准备指标", "Metriken werden vorbereitet", "Préparation des indicateurs", "Preparazione metriche", "A preparar métricas", "Preparando métricas", "Подготовка показателей", "Przygotowywanie metryk", "metrics_preparing"],
  metrics_stage_starting: ["Starting", "Starting", "開始しています", "正在启动", "Wird gestartet", "Démarrage", "Avvio in corso", "A iniciar", "Iniciando", "Запуск", "Uruchamianie", "metrics_stage_starting"],
  metrics_stage_reading_tests: ["Reading tests", "Reading tests", "テストを読み取り中", "正在读取测试", "Tests werden gelesen", "Lecture des tests", "Lettura dei test", "A ler testes", "Leyendo pruebas", "Чтение тестов", "Odczytywanie testów", "metrics_stage_reading_tests"],
  metrics_stage_loading_test_data: ["Loading test data", "Loading test data", "テストデータを読み込み中", "正在加载测试数据", "Testdaten werden geladen", "Chargement des données de test", "Caricamento dei dati dei test", "A carregar dados dos testes", "Cargando datos de pruebas", "Загрузка данных тестов", "Ładowanie danych testów", "metrics_stage_loading_test_data"],
  metrics_stage_finishing: ["Finishing", "Finishing", "完了処理中", "正在完成", "Wird abgeschlossen", "Finalisation", "Completamento in corso", "A concluir", "Finalizando", "Завершение", "Kończenie", "metrics_stage_finishing"],
  metrics_stage_completed: ["Completed", "Completed", "完了", "已完成", "Abgeschlossen", "Terminé", "Completato", "Concluído", "Completado", "Завершено", "Ukończono", "metrics_stage_completed"],
  metrics_stage_failed: ["Failed", "Failed", "失敗", "失败", "Fehlgeschlagen", "Échec", "Non riuscito", "Falhou", "Error", "Ошибка", "Niepowodzenie", "metrics_stage_failed"],
  metrics_preparing_result_set: ["Preparing result set", "Preparing result set", "結果セットを準備中", "正在准备结果集", "Ergebnismenge wird vorbereitet", "Préparation du jeu de résultats", "Preparazione risultati", "A preparar resultados", "Preparando resultados", "Подготовка результатов", "Przygotowywanie wyników", "metrics_preparing_result_set"],
  metrics_estimated_time_remaining: ["Estimated time remaining", "Estimated time remaining", "推定残り時間", "预计剩余时间", "Geschätzte Restzeit", "Temps restant estimé", "Tempo rimanente stimato", "Tempo restante estimado", "Tiempo restante estimado", "Расчетное оставшееся время", "Szacowany pozostały czas", "metrics_estimated_time_remaining"],
  metrics_seconds: ["sec", "sec", "秒", "秒", "Sek.", "s", "sec", "seg", "seg", "сек", "sek.", "metrics_seconds"],
  metrics_minutes: ["min", "min", "分", "分", "Min.", "min", "min", "min", "min", "мин", "min", "metrics_minutes"],
  metrics_first_test: ["First Test", "First Test", "最初のテスト", "首次测试", "Erster Test", "Premier test", "Primo test", "Primeiro teste", "Primera prueba", "Первый тест", "Pierwszy test", "metrics_first_test"],
  metrics_last_test: ["Last Test", "Last Test", "最後のテスト", "最后一次测试", "Letzter Test", "Dernier test", "Ultimo test", "Último teste", "Última prueba", "Последний тест", "Ostatni test", "metrics_last_test"],
  metrics_not_available: ["N/A", "N/A", "該当なし", "不适用", "Nicht verfügbar", "Non disponible", "Non disponibile", "Não disponível", "No disponible", "Недоступно", "Niedostępne", "metrics_not_available"],
  metrics_overview: ["Overview", "Overview", "概要", "概览", "Übersicht", "Vue d'ensemble", "Panoramica", "Visão geral", "Resumen", "Обзор", "Przegląd", "metrics_overview"],
  metrics_length: ["Length", "Length", "長さ", "长度", "Länge", "Longueur", "Lunghezza", "Comprimento", "Longitud", "Длина", "Długość", "metrics_length"],
  metrics_cable_type_summary: ["Cable Type Summary", "Cable Type Summary", "ケーブルタイプの概要", "电缆类型摘要", "Zusammenfassung der Kabeltypen", "Résumé des types de câble", "Riepilogo tipi di cavo", "Resumo por tipo de cabo", "Resumen por tipo de cable", "Сводка по типам кабелей", "Podsumowanie typów kabli", "metrics_cable_type_summary"],
  metrics_coax: ["Coax", "Coax", "同軸", "同轴", "Koax", "Coaxial", "Coassiale", "Coaxial", "Coaxial", "Коаксиальный", "Koncentryczny", "metrics_coax"],
  metrics_technicians: ["Technicians", "Technicians", "技術者", "技术人员", "Techniker", "Techniciens", "Tecnici", "Técnicos", "Técnicos", "Техники", "Technicy", "metrics_technicians"],
  metrics_min: ["Min", "Min", "最小", "最小", "Min.", "Min.", "Min", "Mín.", "Mín.", "Мин.", "Min.", "metrics_min"],
  metrics_max: ["Max", "Max", "最大", "最大", "Max.", "Max.", "Max", "Máx.", "Máx.", "Макс.", "Maks.", "metrics_max"],
  metrics_average_short: ["Avg", "Avg", "平均", "平均", "Durchschn.", "Moy.", "Media", "Média", "Prom.", "Сред.", "Śr.", "metrics_average_short"],
  metrics_chart_actual: ["Actual", "Actual", "実測値", "实际值", "Ist", "Réel", "Effettivo", "Real", "Real", "Фактическое", "Rzeczywista", "metrics_chart_actual"],
  metrics_vdv_summary: ["VDV II/PoE PRO Summary", "VDV II/PoE PRO Summary", "VDV II/PoE PRO の概要", "VDV II/PoE PRO 摘要", "VDV II/PoE PRO Übersicht", "Résumé VDV II/PoE PRO", "Riepilogo VDV II/PoE PRO", "Resumo VDV II/PoE PRO", "Resumen VDV II/PoE PRO", "Сводка VDV II/PoE PRO", "Podsumowanie VDV II/PoE PRO", "metrics_vdv_summary"],
  metrics_copper_summary: ["Copper Summary", "Copper Summary", "銅線の概要", "铜缆摘要", "Kupferübersicht", "Résumé cuivre", "Riepilogo rame", "Resumo cobre", "Resumen cobre", "Сводка по меди", "Podsumowanie miedzi", "metrics_copper_summary"],
  metrics_coax_summary: ["Coax Summary", "Coax Summary", "同軸の概要", "同轴摘要", "Koaxübersicht", "Résumé coaxial", "Riepilogo coassiale", "Resumo coaxial", "Resumen coaxial", "Сводка по коаксиалу", "Podsumowanie kabli koncentrycznych", "metrics_coax_summary"],
  metrics_fiber_summary: ["Fiber Summary", "Fiber Summary", "光ファイバーの概要", "光纤摘要", "Glasfaserübersicht", "Résumé fibre", "Riepilogo fibra", "Resumo fibra", "Resumen fibra", "Сводка по оптоволокну", "Podsumowanie światłowodu", "metrics_fiber_summary"],
  metrics_highest_insertion_loss: ["Highest Insertion Loss", "Highest Insertion Loss", "最大挿入損失", "最大插入损耗", "Höchste Einfügedämpfung", "Perte d'insertion la plus élevée", "Massima perdita di inserzione", "Maior perda de inserção", "Mayor pérdida de inserción", "Наибольшие вносимые потери", "Największe tłumienie wtrąceniowe", "metrics_highest_insertion_loss"],
  metrics_average_insertion_loss: ["Average Insertion Loss", "Average Insertion Loss", "平均挿入損失", "平均插入损耗", "Durchschnittliche Einfügedämpfung", "Perte d'insertion moyenne", "Perdita di inserzione media", "Perda de inserção média", "Pérdida de inserción media", "Средние вносимые потери", "Średnie tłumienie wtrąceniowe", "metrics_average_insertion_loss"],
  metrics_lowest_margin: ["Lowest Margin", "Lowest Margin", "最小マージン", "最低余量", "Niedrigste Reserve", "Marge la plus faible", "Margine più basso", "Margem mais baixa", "Margen más bajo", "Наименьший запас", "Najniższy margines", "metrics_lowest_margin"],
  metrics_average_margin: ["Average Margin", "Average Margin", "平均マージン", "平均余量", "Durchschnittliche Reserve", "Marge moyenne", "Margine medio", "Margem média", "Margen medio", "Средний запас", "Średni margines", "metrics_average_margin"],
  metrics_longest_cable: ["Longest Cable", "Longest Cable", "最長ケーブル", "最长电缆", "Längstes Kabel", "Câble le plus long", "Cavo più lungo", "Cabo mais longo", "Cable más largo", "Самый длинный кабель", "Najdłuższy kabel", "metrics_longest_cable"],
  metrics_average_cable_length: ["Average Cable Length", "Average Cable Length", "平均ケーブル長", "平均电缆长度", "Durchschnittliche Kabellänge", "Longueur moyenne de câble", "Lunghezza media del cavo", "Comprimento médio do cabo", "Longitud media del cable", "Средняя длина кабеля", "Średnia długość kabla", "metrics_average_cable_length"],
  metrics_insertion_loss: ["Insertion Loss", "Insertion Loss", "挿入損失", "插入损耗", "Einfügedämpfung", "Perte d'insertion", "Perdita di inserzione", "Perda de inserção", "Pérdida de inserción", "Вносимые потери", "Tłumienie wtrąceniowe", "metrics_insertion_loss"],
  metrics_margin: ["Margin", "Margin", "マージン", "余量", "Reserve", "Marge", "Margine", "Margem", "Margen", "Запас", "Margines", "metrics_margin"],
  metrics_cable_length: ["Cable Length", "Cable Length", "ケーブル長", "电缆长度", "Kabellänge", "Longueur de câble", "Lunghezza cavo", "Comprimento do cabo", "Longitud de cable", "Длина кабеля", "Długość kabla", "metrics_cable_length"],

  archive_notification_job_singular: ["There is ${count} job older than ${period} month ready to archive.", "There is ${count} job older than ${period} month ready to archive.", "${period} か月より古いジョブが ${count} 件あり、アーカイブできます。", "有 ${count} 个作业的时间超过 ${period} 个月，可以存档。", "${count} Auftrag ist älter als ${period} Monat und kann archiviert werden.", "${count} tâche datant de plus de ${period} mois peut être archivée.", "${count} lavoro più vecchio di ${period} mese è pronto per l'archiviazione.", "Há ${count} trabalho com mais de ${period} mês pronto para arquivar.", "Hay ${count} trabajo con más de ${period} mes listo para archivar.", "Есть ${count} задание старше ${period} месяца, готовое к архивации.", "Jest ${count} zlecenie starsze niż ${period} miesiąc, gotowe do archiwizacji.", "archive_notification_job_singular"],
  archive_notification_jobs_plural: ["There are ${count} jobs older than ${period} months ready to archive.", "There are ${count} jobs older than ${period} months ready to archive.", "${period} か月より古いジョブが ${count} 件あり、アーカイブできます。", "有 ${count} 个作业的时间超过 ${period} 个月，可以存档。", "${count} Aufträge sind älter als ${period} Monate und können archiviert werden.", "${count} tâches datant de plus de ${period} mois peuvent être archivées.", "${count} lavori più vecchi di ${period} mesi sono pronti per l'archiviazione.", "Há ${count} trabalhos com mais de ${period} meses prontos para arquivar.", "Hay ${count} trabajos con más de ${period} meses listos para archivar.", "Есть ${count} заданий старше ${period} месяцев, готовых к архивации.", "Jest ${count} zleceń starszych niż ${period} miesięcy, gotowych do archiwizacji.", "archive_notification_jobs_plural"],
  archive_notification_report_singular: ["There is ${count} report older than ${period} month ready to delete.", "There is ${count} report older than ${period} month ready to delete.", "${period} か月より古いレポートが ${count} 件あり、削除できます。", "有 ${count} 个报告的时间超过 ${period} 个月，可以删除。", "${count} Bericht ist älter als ${period} Monat und kann gelöscht werden.", "${count} rapport datant de plus de ${period} mois peut être supprimé.", "${count} report più vecchio di ${period} mese è pronto per l'eliminazione.", "Há ${count} relatório com mais de ${period} mês pronto para eliminar.", "Hay ${count} informe con más de ${period} mes listo para eliminar.", "Есть ${count} отчет старше ${period} месяца, готовый к удалению.", "Jest ${count} raport starszy niż ${period} miesiąc, gotowy do usunięcia.", "archive_notification_report_singular"],
  archive_notification_reports_plural: ["There are ${count} reports older than ${period} months ready to delete.", "There are ${count} reports older than ${period} months ready to delete.", "${period} か月より古いレポートが ${count} 件あり、削除できます。", "有 ${count} 个报告的时间超过 ${period} 个月，可以删除。", "${count} Berichte sind älter als ${period} Monate und können gelöscht werden.", "${count} rapports datant de plus de ${period} mois peuvent être supprimés.", "${count} report più vecchi di ${period} mesi sono pronti per l'eliminazione.", "Há ${count} relatórios com mais de ${period} meses prontos para eliminar.", "Hay ${count} informes con más de ${period} meses listos para eliminar.", "Есть ${count} отчетов старше ${period} месяцев, готовых к удалению.", "Jest ${count} raportów starszych niż ${period} miesięcy, gotowych do usunięcia.", "archive_notification_reports_plural"],
  archive_jobs_action: ["Archive Jobs", "Archive Jobs", "ジョブをアーカイブ", "归档作业", "Aufträge archivieren", "Archiver les tâches", "Archivia lavori", "Arquivar trabalhos", "Archivar trabajos", "Архивировать задания", "Archiwizuj zlecenia", "archive_jobs_action"],
  delete_reports_action: ["Delete Reports", "Delete Reports", "レポートを削除", "删除报告", "Berichte löschen", "Supprimer les rapports", "Elimina report", "Eliminar relatórios", "Eliminar informes", "Удалить отчеты", "Usuń raporty", "delete_reports_action"],
  confirm_archiving_jobs: ["Confirm Archiving Jobs", "Confirm Archiving Jobs", "ジョブのアーカイブを確認", "确认归档作业", "Archivierung von Aufträgen bestätigen", "Confirmer l'archivage des tâches", "Conferma archiviazione lavori", "Confirmar arquivamento de trabalhos", "Confirmar el archivado de trabajos", "Подтвердить архивацию заданий", "Potwierdź archiwizację zleceń", "confirm_archiving_jobs"],
  archive_jobs_confirmation: ["Are you sure you want to archive these jobs?", "Are you sure you want to archive these jobs?", "これらのジョブをアーカイブしてもよろしいですか？", "确定要归档这些作业吗？", "Möchten Sie diese Aufträge wirklich archivieren?", "Voulez-vous vraiment archiver ces tâches ?", "Vuoi archiviare questi lavori?", "Tem a certeza de que pretende arquivar estes trabalhos?", "¿Seguro que desea archivar estos trabajos?", "Вы уверены, что хотите архивировать эти задания?", "Czy na pewno chcesz zarchiwizować te zlecenia?", "archive_jobs_confirmation"],
  confirm_deleting_reports: ["Confirm Deleting Reports", "Confirm Deleting Reports", "レポートの削除を確認", "确认删除报告", "Löschen von Berichten bestätigen", "Confirmer la suppression des rapports", "Conferma eliminazione report", "Confirmar eliminação de relatórios", "Confirmar eliminación de informes", "Подтвердить удаление отчетов", "Potwierdź usunięcie raportów", "confirm_deleting_reports"],
  delete_reports_confirmation: ["Are you sure you want to permanently delete these reports?", "Are you sure you want to permanently delete these reports?", "これらのレポートを完全に削除してもよろしいですか？", "确定要永久删除这些报告吗？", "Möchten Sie diese Berichte wirklich endgültig löschen?", "Voulez-vous vraiment supprimer définitivement ces rapports ?", "Vuoi eliminare definitivamente questi report?", "Tem a certeza de que pretende eliminar permanentemente estes relatórios?", "¿Seguro que desea eliminar permanentemente estos informes?", "Вы уверены, что хотите навсегда удалить эти отчеты?", "Czy na pewno chcesz trwale usunąć te raporty?", "delete_reports_confirmation"],
  device_details_no_licenses: ["No device licenses found.", "No device licenses found.", "デバイスライセンスが見つかりません。", "未找到设备许可证。", "Keine Gerätelizenzen gefunden.", "Aucune licence d'appareil trouvée.", "Nessuna licenza del dispositivo trovata.", "Não foram encontradas licenças de dispositivo.", "No se encontraron licencias de dispositivo.", "Лицензии устройства не найдены.", "Nie znaleziono licencji urządzenia.", "device_details_no_licenses"],
  job_upload_choose_files: ["Choose file(s)", "Choose file(s)", "ファイルを選択", "选择文件", "Datei(en) auswählen", "Choisir un ou plusieurs fichiers", "Scegli file", "Escolher ficheiro(s)", "Elegir archivo(s)", "Выбрать файл(ы)", "Wybierz plik(i)", "job_upload_choose_files"],
  job_upload_no_files_chosen: ["No files chosen", "No files chosen", "ファイルが選択されていません", "未选择文件", "Keine Dateien ausgewählt", "Aucun fichier sélectionné", "Nessun file selezionato", "Nenhum ficheiro selecionado", "No se han seleccionado archivos", "Файлы не выбраны", "Nie wybrano plików", "job_upload_no_files_chosen"],

  view_by_customers: ["Customers", "Customers", "顧客", "客户", "Kunden", "Clients", "Clienti", "Clientes", "Clientes", "Клиенты", "Klienci", "view_by_customers"],
  view_by_device_types: ["Device Types", "Device Types", "デバイスの種類", "设备类型", "Gerätetypen", "Types d'appareil", "Tipi di dispositivo", "Tipos de dispositivo", "Tipos de dispositivo", "Типы устройств", "Typy urządzeń", "view_by_device_types"],
  view_by_buildings: ["Buildings", "Buildings", "建物", "建筑", "Gebäude", "Bâtiments", "Edifici", "Edifícios", "Edificios", "Здания", "Budynki", "view_by_buildings"],
  view_by_floors: ["Floors", "Floors", "階", "楼层", "Etagen", "Étages", "Piani", "Pisos", "Plantas", "Этажи", "Piętra", "view_by_floors"],
  view_by_rooms: ["Rooms", "Rooms", "部屋", "房间", "Räume", "Pièces", "Stanze", "Salas", "Habitaciones", "Помещения", "Pomieszczenia", "view_by_rooms"],
  view_by_racks: ["Racks", "Racks", "ラック", "机架", "Racks", "Baies", "Rack", "Bastidores", "Bastidores", "Стойки", "Szafy", "view_by_racks"],
  view_by_panels: ["Panels", "Panels", "パネル", "面板", "Panels", "Panneaux", "Pannelli", "Painéis", "Paneles", "Панели", "Panele", "view_by_panels"],

  location_tracking_acceptance_heading: ["User Acceptance Statement - Location Tracking", "User Acceptance Statement - Location Tracking", "利用者同意書 - 位置追跡", "用户接受声明 - 位置跟踪", "Nutzerakzeptanzerklärung - Standortverfolgung", "Déclaration d'acceptation - Suivi de localisation", "Dichiarazione di accettazione - Tracciamento posizione", "Declaração de aceitação - Rastreamento de localização", "Declaración de aceptación - Seguimiento de ubicación", "Заявление о согласии пользователя - Отслеживание местоположения", "Oświadczenie akceptacji użytkownika - Śledzenie lokalizacji", "location_tracking_acceptance_heading"],
  location_tracking_acceptance_intro: ["By enabling Location Tracking, you acknowledge and agree to the following:", "By enabling Location Tracking, you acknowledge and agree to the following:", "位置追跡を有効にすると、次の内容を承認し同意したことになります。", "启用位置跟踪即表示您确认并同意以下内容：", "Mit der Aktivierung der Standortverfolgung erkennen Sie Folgendes an und stimmen zu:", "En activant le suivi de localisation, vous reconnaissez et acceptez ce qui suit :", "Abilitando il tracciamento della posizione, riconosci e accetti quanto segue:", "Ao ativar o rastreamento de localização, reconhece e aceita o seguinte:", "Al activar el seguimiento de ubicación, reconoce y acepta lo siguiente:", "Включая отслеживание местоположения, вы подтверждаете и соглашаетесь со следующим:", "Włączając śledzenie lokalizacji, potwierdzasz i akceptujesz poniższe:", "location_tracking_acceptance_intro"],
  location_tracking_acceptance_data: ["Location data from all devices in your organisation will be collected, uploaded, and securely stored in the AnyWARE Cloud.", "Location data from all devices in your organisation will be collected, uploaded, and securely stored in the AnyWARE Cloud.", "組織内のすべてのデバイスの位置データが収集、アップロードされ、AnyWARE Cloud に安全に保存されます。", "您组织中所有设备的位置数据将被收集、上传并安全存储在 AnyWARE Cloud 中。", "Standortdaten aller Geräte Ihrer Organisation werden erfasst, hochgeladen und sicher in der AnyWARE Cloud gespeichert.", "Les données de localisation de tous les appareils de votre organisation seront collectées, téléchargées et stockées de manière sécurisée dans AnyWARE Cloud.", "I dati di posizione di tutti i dispositivi dell'organizzazione saranno raccolti, caricati e archiviati in modo sicuro in AnyWARE Cloud.", "Os dados de localização de todos os dispositivos da organização serão recolhidos, carregados e armazenados de forma segura na AnyWARE Cloud.", "Los datos de ubicación de todos los dispositivos de su organización se recopilarán, cargarán y almacenarán de forma segura en AnyWARE Cloud.", "Данные о местоположении всех устройств организации будут собираться, загружаться и безопасно храниться в AnyWARE Cloud.", "Dane lokalizacyjne wszystkich urządzeń w organizacji będą zbierane, przesyłane i bezpiecznie przechowywane w AnyWARE Cloud.", "location_tracking_acceptance_data"],
  location_tracking_acceptance_scope: ["This organisation-wide setting applies to all devices associated with your organisation without individual device consent.", "This organisation-wide setting applies to all devices associated with your organisation without individual device consent.", "この組織全体の設定は、個々のデバイスの同意なしに組織に関連するすべてのデバイスに適用されます。", "此组织范围的设置将应用于与您组织关联的所有设备，无需单独的设备同意。", "Diese organisationsweite Einstellung gilt ohne einzelne Geräteeinwilligung für alle Geräte Ihrer Organisation.", "Ce paramètre à l'échelle de l'organisation s'applique à tous les appareils associés sans consentement individuel de chaque appareil.", "Questa impostazione a livello di organizzazione si applica a tutti i dispositivi associati senza consenso per singolo dispositivo.", "Esta definição para toda a organização aplica-se a todos os dispositivos associados sem consentimento individual do dispositivo.", "Esta configuración de toda la organización se aplica a todos los dispositivos asociados sin consentimiento individual del dispositivo.", "Эта общая для организации настройка применяется ко всем связанным устройствам без отдельного согласия для каждого устройства.", "To ustawienie obejmujące całą organizację dotyczy wszystkich powiązanych urządzeń bez odrębnej zgody dla każdego z nich.", "location_tracking_acceptance_scope"],
  location_tracking_acceptance_authority: ["You confirm that you are authorised to enable this setting for your organisation and will notify relevant stakeholders as needed.", "You confirm that you are authorised to enable this setting for your organisation and will notify relevant stakeholders as needed.", "組織を代表してこの設定を有効にする権限があり、必要に応じて関係者に通知することを確認します。", "您确认有权为您的组织启用此设置，并将在需要时通知相关利益相关者。", "Sie bestätigen, dass Sie berechtigt sind, diese Einstellung für Ihre Organisation zu aktivieren und betroffene Personen bei Bedarf zu informieren.", "Vous confirmez être autorisé à activer ce paramètre pour votre organisation et à informer les parties concernées si nécessaire.", "Confermi di essere autorizzato ad abilitare questa impostazione per la tua organizzazione e di informare le parti interessate se necessario.", "Confirma que está autorizado a ativar esta definição para a organização e que notificará as partes interessadas quando necessário.", "Confirma que está autorizado a activar esta configuración para su organización y que avisará a las partes interesadas cuando sea necesario.", "Вы подтверждаете, что уполномочены включить эту настройку для организации и при необходимости уведомите заинтересованные стороны.", "Potwierdzasz, że masz uprawnienia do włączenia tego ustawienia dla organizacji i w razie potrzeby powiadomisz zainteresowane strony.", "location_tracking_acceptance_authority"],
  location_tracking_acceptance_privacy: ["You understand and accept the privacy and data-management implications under AnyWARE policies and applicable regulations.", "You understand and accept the privacy and data-management implications under AnyWARE policies and applicable regulations.", "AnyWARE のポリシーおよび適用法令に基づくプライバシーとデータ管理への影響を理解し、受け入れます。", "您理解并接受 AnyWARE 政策和适用法规下对隐私和数据管理的影响。", "Sie verstehen und akzeptieren die Auswirkungen auf Datenschutz und Datenverwaltung gemäß den AnyWARE-Richtlinien und geltenden Vorschriften.", "Vous comprenez et acceptez les conséquences relatives à la confidentialité et à la gestion des données conformément aux politiques AnyWARE et aux réglementations applicables.", "Comprendi e accetti le implicazioni per la privacy e la gestione dei dati secondo le politiche AnyWARE e le normative applicabili.", "Compreende e aceita as implicações de privacidade e gestão de dados ao abrigo das políticas da AnyWARE e da regulamentação aplicável.", "Comprende y acepta las implicaciones de privacidad y gestión de datos conforme a las políticas de AnyWARE y la normativa aplicable.", "Вы понимаете и принимаете последствия для конфиденциальности и управления данными в соответствии с политиками AnyWARE и применимыми нормами.", "Rozumiesz i akceptujesz konsekwencje dotyczące prywatności i zarządzania danymi zgodnie z politykami AnyWARE i obowiązującymi przepisami.", "location_tracking_acceptance_privacy"],
  location_tracking_acceptance_confirm: ["Please confirm your acceptance to proceed.", "Please confirm your acceptance to proceed.", "続行するには同意を確認してください。", "请确认您接受以继续。", "Bitte bestätigen Sie Ihre Zustimmung, um fortzufahren.", "Veuillez confirmer votre acceptation pour continuer.", "Conferma l'accettazione per procedere.", "Confirme a sua aceitação para continuar.", "Confirme su aceptación para continuar.", "Подтвердите согласие, чтобы продолжить.", "Potwierdź akceptację, aby kontynuować.", "location_tracking_acceptance_confirm"],
  location_tracking_accept: ["Accept", "Accept", "同意する", "接受", "Akzeptieren", "Accepter", "Accetta", "Aceitar", "Aceptar", "Принять", "Akceptuj", "location_tracking_accept"],
  location_tracking_acceptance_confirmed: ["The User Acceptance Statement for Location Tracking has been accepted by ${acceptedByName} on ${acceptedAt}.", "The User Acceptance Statement for Location Tracking has been accepted by ${acceptedByName} on ${acceptedAt}.", "位置追跡の利用者同意書は ${acceptedAt} に ${acceptedByName} により承認されました。", "位置跟踪用户接受声明已由 ${acceptedByName} 于 ${acceptedAt} 接受。", "Die Nutzerakzeptanzerklärung für die Standortverfolgung wurde am ${acceptedAt} von ${acceptedByName} akzeptiert.", "La déclaration d'acceptation du suivi de localisation a été acceptée par ${acceptedByName} le ${acceptedAt}.", "La dichiarazione di accettazione del tracciamento della posizione è stata accettata da ${acceptedByName} il ${acceptedAt}.", "A declaração de aceitação do rastreamento de localização foi aceite por ${acceptedByName} em ${acceptedAt}.", "La declaración de aceptación del seguimiento de ubicación fue aceptada por ${acceptedByName} el ${acceptedAt}.", "Заявление о согласии на отслеживание местоположения принято пользователем ${acceptedByName} ${acceptedAt}.", "Oświadczenie akceptacji śledzenia lokalizacji zostało zaakceptowane przez ${acceptedByName} dnia ${acceptedAt}.", "location_tracking_acceptance_confirmed"],
  location_tracking_cancellation_confirm: ["Click button below to cancel Location Tracking", "Click button below to cancel Location Tracking", "下のボタンをクリックして位置情報の追跡をキャンセルしてください", "点击下方按钮取消位置跟踪", "Klicken Sie auf die Schaltfläche unten, um die Standortverfolgung abzubrechen", "Cliquez sur le bouton ci-dessous pour annuler le suivi de localisation", "Fai clic sul pulsante qui sotto per annullare il tracciamento della posizione", "Clique no botão abaixo para cancelar o rastreio de localização", "Haga clic en el botón de abajo para cancelar el seguimiento de ubicación", "Нажмите кнопку ниже, чтобы отменить отслеживание местоположения", "Kliknij przycisk poniżej, aby anulować śledzenie lokalizacji", "location_tracking_cancellation_confirm"],

  smart_flag_profiles_title: ["Smart Flag Profiles", "Smart Flag Profiles", "Smart Flag プロファイル", "智能标记配置文件", "Smart-Flag-Profile", "Profils Smart Flag", "Profili Smart Flag", "Perfis Smart Flag", "Perfiles Smart Flag", "Профили Smart Flag", "Profile Smart Flag", "smart_flag_profiles_title"],
  smart_flag_add_profile: ["Add Profile", "Add Profile", "プロファイルを追加", "添加配置文件", "Profil hinzufügen", "Ajouter un profil", "Aggiungi profilo", "Adicionar perfil", "Añadir perfil", "Добавить профиль", "Dodaj profil", "smart_flag_add_profile"],
  smart_flag_profile_flags: ["Flags", "Flags", "フラグ", "标记", "Flags", "Indicateurs", "Flag", "Sinalizadores", "Indicadores", "Флаги", "Flagi", "smart_flag_profile_flags"],
  smart_flag_profiles_empty: ["No Smart Flag profiles found.", "No Smart Flag profiles found.", "Smart Flag プロファイルが見つかりません。", "未找到智能标记配置文件。", "Keine Smart-Flag-Profile gefunden.", "Aucun profil Smart Flag trouvé.", "Nessun profilo Smart Flag trovato.", "Nenhum perfil Smart Flag encontrado.", "No se encontraron perfiles Smart Flag.", "Профили Smart Flag не найдены.", "Nie znaleziono profili Smart Flag.", "smart_flag_profiles_empty"],
  smart_flag_create_profile: ["Create Profile", "Create Profile", "プロファイルを作成", "创建配置文件", "Profil erstellen", "Créer un profil", "Crea profilo", "Criar perfil", "Crear perfil", "Создать профиль", "Utwórz profil", "smart_flag_create_profile"],
  smart_flag_create: ["Create", "Create", "作成", "创建", "Erstellen", "Créer", "Crea", "Criar", "Crear", "Создать", "Utwórz", "smart_flag_create"],
  smart_flag_clone_profile: ["Clone Profile", "Clone Profile", "プロファイルを複製", "克隆配置文件", "Profil klonen", "Cloner le profil", "Clona profilo", "Clonar perfil", "Clonar perfil", "Клонировать профиль", "Klonuj profil", "smart_flag_clone_profile"],
  smart_flag_clone: ["Clone", "Clone", "複製", "克隆", "Klonen", "Cloner", "Clona", "Clonar", "Clonar", "Клонировать", "Klonuj", "smart_flag_clone"],
  smart_flag_cloning: ["Cloning...", "Cloning...", "複製中...", "正在克隆...", "Wird geklont...", "Clonage...", "Clonazione...", "A clonar...", "Clonando...", "Клонирование...", "Klonowanie...", "smart_flag_cloning"],
  smart_flag_new_profile_name: ["New Profile Name", "New Profile Name", "新しいプロファイル名", "新配置文件名称", "Neuer Profilname", "Nouveau nom de profil", "Nuovo nome profilo", "Novo nome do perfil", "Nuevo nombre de perfil", "Новое имя профиля", "Nowa nazwa profilu", "smart_flag_new_profile_name"],
  smart_flag_profile_copy: ["Copy", "Copy", "コピー", "副本", "Kopie", "Copie", "Copia", "Cópia", "Copia", "Копия", "Kopia", "smart_flag_profile_copy"],
  smart_flag_edit_profile: ["Edit Profile", "Edit Profile", "プロファイルを編集", "编辑配置文件", "Profil bearbeiten", "Modifier le profil", "Modifica profilo", "Editar perfil", "Editar perfil", "Изменить профиль", "Edytuj profil", "smart_flag_edit_profile"],
  smart_flag_profile_load_error: ["Unable to load this Smart Flag profile. Please return to the profile list and try again.", "Unable to load this Smart Flag profile. Please return to the profile list and try again.", "この Smart Flag プロファイルを読み込めません。プロファイル一覧に戻って再試行してください。", "无法加载此智能标记配置文件。请返回配置文件列表后重试。", "Dieses Smart-Flag-Profil kann nicht geladen werden. Kehren Sie zur Profilliste zurück und versuchen Sie es erneut.", "Impossible de charger ce profil Smart Flag. Revenez à la liste des profils et réessayez.", "Impossibile caricare questo profilo Smart Flag. Torna all'elenco dei profili e riprova.", "Não foi possível carregar este perfil Smart Flag. Volte à lista de perfis e tente novamente.", "No se puede cargar este perfil Smart Flag. Vuelva a la lista de perfiles e inténtelo de nuevo.", "Не удалось загрузить этот профиль Smart Flag. Вернитесь к списку профилей и попробуйте снова.", "Nie można załadować tego profilu Smart Flag. Wróć do listy profili i spróbuj ponownie.", "smart_flag_profile_load_error"],
  smart_flag_back_to_profiles: ["Back to profiles", "Back to profiles", "プロファイルに戻る", "返回配置文件", "Zurück zu Profilen", "Retour aux profils", "Torna ai profili", "Voltar aos perfis", "Volver a perfiles", "Назад к профилям", "Wróć do profili", "smart_flag_back_to_profiles"],
  smart_flag_profile_editor_intro: ["Smart Flag profiles scan job tests and flag results outside the parameters entered below.", "Smart Flag profiles scan job tests and flag results outside the parameters entered below.", "Smart Flag プロファイルはジョブのテストを確認し、以下のパラメーター範囲外の結果にフラグを付けます。", "智能标记配置文件会扫描作业测试，并标记超出以下参数范围的结果。", "Smart-Flag-Profile prüfen Auftragstests und markieren Ergebnisse außerhalb der unten eingegebenen Parameter.", "Les profils Smart Flag analysent les tests du travail et signalent les résultats hors des paramètres ci-dessous.", "I profili Smart Flag analizzano i test del lavoro e segnalano i risultati fuori dai parametri seguenti.", "Os perfis Smart Flag analisam os testes do trabalho e sinalizam resultados fora dos parâmetros abaixo.", "Los perfiles Smart Flag analizan las pruebas del trabajo y marcan resultados fuera de los parámetros indicados a continuación.", "Профили Smart Flag проверяют тесты задания и помечают результаты за пределами указанных ниже параметров.", "Profile Smart Flag analizują testy zadania i oznaczają wyniki poza parametrami podanymi poniżej.", "smart_flag_profile_editor_intro"],
  smart_flag_minimum_performance_description: ["Minimum Performance Check flags results when a margin is below the value entered for a parameter.", "Minimum Performance Check flags results when a margin is below the value entered for a parameter.", "最小パフォーマンスチェックは、マージンがパラメーターに入力した値未満の場合に結果へフラグを付けます。", "当余量低于为参数输入的值时，最低性能检查会标记结果。", "Die Mindestleistungsprüfung markiert Ergebnisse, wenn eine Reserve unter dem für einen Parameter eingegebenen Wert liegt.", "Le contrôle de performance minimale signale les résultats lorsqu'une marge est inférieure à la valeur saisie pour un paramètre.", "Il controllo delle prestazioni minime segnala i risultati quando un margine è inferiore al valore inserito per un parametro.", "A verificação de desempenho mínimo sinaliza resultados quando uma margem é inferior ao valor introduzido para um parâmetro.", "La comprobación de rendimiento mínimo marca resultados cuando un margen es inferior al valor introducido para un parámetro.", "Проверка минимальной производительности помечает результаты, когда запас ниже значения, введенного для параметра.", "Kontrola minimalnej wydajności oznacza wyniki, gdy margines jest niższy od wartości wprowadzonej dla parametru.", "smart_flag_minimum_performance_description"],
  smart_flag_copper_suspicious_check: ["Copper - Suspicious Test Check", "Copper - Suspicious Test Check", "銅線 - 疑わしいテストチェック", "铜缆 - 可疑测试检查", "Kupfer - Prüfung verdächtiger Tests", "Cuivre - Vérification des tests suspects", "Rame - Controllo test sospetti", "Cobre - Verificação de testes suspeitos", "Cobre - Comprobación de pruebas sospechosas", "Медь - Проверка подозрительных тестов", "Miedź - Kontrola podejrzanych testów", "smart_flag_copper_suspicious_check"],
  smart_flag_copper_minimum_performance_check: ["Copper - Minimum Performance Check", "Copper - Minimum Performance Check", "銅線 - 最小パフォーマンスチェック", "铜缆 - 最低性能检查", "Kupfer - Mindestleistungsprüfung", "Cuivre - Contrôle de performance minimale", "Rame - Controllo prestazioni minime", "Cobre - Verificação de desempenho mínimo", "Cobre - Comprobación de rendimiento mínimo", "Медь - Проверка минимальной производительности", "Miedź - Kontrola minimalnej wydajności", "smart_flag_copper_minimum_performance_check"],
  smart_flag_fiber_suspicious_check: ["Fiber - Suspicious Test Check", "Fiber - Suspicious Test Check", "光ファイバー - 疑わしいテストチェック", "光纤 - 可疑测试检查", "Glasfaser - Prüfung verdächtiger Tests", "Fibre - Vérification des tests suspects", "Fibra - Controllo test sospetti", "Fibra - Verificação de testes suspeitos", "Fibra - Comprobación de pruebas sospechosas", "Оптоволокно - Проверка подозрительных тестов", "Światłowód - Kontrola podejrzanych testów", "smart_flag_fiber_suspicious_check"],
  smart_flag_fiber_minimum_performance_check: ["Fiber - Minimum Performance Check", "Fiber - Minimum Performance Check", "光ファイバー - 最小パフォーマンスチェック", "光纤 - 最低性能检查", "Glasfaser - Mindestleistungsprüfung", "Fibre - Contrôle de performance minimale", "Fibra - Controllo prestazioni minime", "Fibra - Verificação de desempenho mínimo", "Fibra - Comprobación de rendimiento mínimo", "Оптоволокно - Проверка минимальной производительности", "Światłowód - Kontrola minimalnej wydajności", "smart_flag_fiber_minimum_performance_check"],
  smart_flag_saving: ["Saving...", "Saving...", "保存中...", "正在保存...", "Wird gespeichert...", "Enregistrement...", "Salvataggio...", "A guardar...", "Guardando...", "Сохранение...", "Zapisywanie...", "smart_flag_saving"],

  health_check_name_tip_wear: ["Tip Wear", "Tip Wear", "先端摩耗", "探头磨损", "Spitzenverschleiß", "Usure de la pointe", "Usura della punta", "Desgaste da ponta", "Desgaste de la punta", "Износ наконечника", "Zużycie końcówki", "health_check_name_tip_wear"],
  health_check_name_software_version: ["Software Version", "Software Version", "ソフトウェアバージョン", "软件版本", "Softwareversion", "Version du logiciel", "Versione software", "Versão do software", "Versión de software", "Версия ПО", "Wersja oprogramowania", "health_check_name_software_version"],
  health_check_name_calibration: ["Calibration", "Calibration", "校正", "校准", "Kalibrierung", "Étalonnage", "Calibrazione", "Calibração", "Calibración", "Калибровка", "Kalibracja", "health_check_name_calibration"],
  health_check_name_last_sync: ["Last Sync", "Last Sync", "最終同期", "上次同步", "Letzte Synchronisierung", "Dernière synchronisation", "Ultima sincronizzazione", "Última sincronização", "Última sincronización", "Последняя синхронизация", "Ostatnia synchronizacja", "health_check_name_last_sync"],
  health_check_name_last_activity: ["Last Activity", "Last Activity", "最終アクティビティ", "上次活动", "Letzte Aktivität", "Dernière activité", "Ultima attività", "Última atividade", "Última actividad", "Последняя активность", "Ostatnia aktywność", "health_check_name_last_activity"],
  adapter_health_no_activity: ["No activity recorded", "No activity recorded", "アクティビティの記録はありません", "没有活动记录", "Keine Aktivität aufgezeichnet", "Aucune activité enregistrée", "Nessuna attività registrata", "Nenhuma atividade registada", "No hay actividad registrada", "Нет записей об активности", "Brak zarejestrowanej aktywności", "adapter_health_no_activity"],
  adapter_health_last_activity_passed: ["Last activity ${currentValue} days ago", "Last activity ${currentValue} days ago", "最後のアクティビティは ${currentValue} 日前です", "最后活动时间为 ${currentValue} 天前", "Letzte Aktivität vor ${currentValue} Tagen", "Dernière activité il y a ${currentValue} jours", "Ultima attività ${currentValue} giorni fa", "Última atividade há ${currentValue} dias", "Última actividad hace ${currentValue} días", "Последняя активность ${currentValue} дней назад", "Ostatnia aktywność ${currentValue} dni temu", "adapter_health_last_activity_passed"],
  adapter_health_last_activity_failed: ["Last activity ${currentValue} days ago, exceeds ${expectedValue} day threshold", "Last activity ${currentValue} days ago, exceeds ${expectedValue} day threshold", "最後のアクティビティは ${currentValue} 日前で、${expectedValue} 日のしきい値を超えています", "最后活动时间为 ${currentValue} 天前，超过了 ${expectedValue} 天的阈值", "Letzte Aktivität vor ${currentValue} Tagen; der Schwellenwert von ${expectedValue} Tagen wurde überschritten", "Dernière activité il y a ${currentValue} jours, dépasse le seuil de ${expectedValue} jours", "Ultima attività ${currentValue} giorni fa; supera la soglia di ${expectedValue} giorni", "Última atividade há ${currentValue} dias; excede o limite de ${expectedValue} dias", "Última actividad hace ${currentValue} días; supera el umbral de ${expectedValue} días", "Последняя активность ${currentValue} дней назад, превышен порог в ${expectedValue} дней", "Ostatnia aktywność ${currentValue} dni temu; przekracza próg ${expectedValue} dni", "adapter_health_last_activity_failed"],

  adapter_assets_title: ["Adapters", "Adapters", "アダプター", "适配器", "Adapter", "Adaptateurs", "Adattatori", "Adaptadores", "Adaptadores", "Адаптеры", "Adaptery", "adapter_assets_title"],
  adapter_assets_loading: ["Loading adapter assets...", "Loading adapter assets...", "アダプター資産を読み込み中...", "正在加载适配器资产...", "Adapterressourcen werden geladen...", "Chargement des adaptateurs...", "Caricamento risorse adattatore...", "A carregar ativos de adaptadores...", "Cargando activos de adaptadores...", "Загрузка данных адаптеров...", "Ładowanie zasobów adapterów...", "adapter_assets_loading"],
  adapter_assets_no_data: ["No adapters found.", "No adapters found.", "アダプターが見つかりません。", "未找到适配器。", "Keine Adapter gefunden.", "Aucun adaptateur trouvé.", "Nessun adattatore trovato.", "Nenhum adaptador encontrado.", "No se encontraron adaptadores.", "Адаптеры не найдены.", "Nie znaleziono adapterów.", "adapter_assets_no_data"],
  adapter_linked_adapters: ["Linked Adapters", "Linked Adapters", "リンクされたアダプター", "关联适配器", "Verknüpfte Adapter", "Adaptateurs liés", "Adattatori collegati", "Adaptadores associados", "Adaptadores vinculados", "Связанные адаптеры", "Połączone adaptery", "adapter_linked_adapters"],
  adapter_linked_adapters_loading: ["Loading linked adapters...", "Loading linked adapters...", "リンクされたアダプターを読み込み中...", "正在加载关联适配器...", "Verknüpfte Adapter werden geladen...", "Chargement des adaptateurs liés...", "Caricamento adattatori collegati...", "A carregar adaptadores associados...", "Cargando adaptadores vinculados...", "Загрузка связанных адаптеров...", "Ładowanie połączonych adapterów...", "adapter_linked_adapters_loading"],
  adapter_no_linked_adapters: ["No linked adapters found.", "No linked adapters found.", "リンクされたアダプターが見つかりません。", "未找到关联适配器。", "Keine verknüpften Adapter gefunden.", "Aucun adaptateur lié trouvé.", "Nessun adattatore collegato trovato.", "Nenhum adaptador associado encontrado.", "No se encontraron adaptadores vinculados.", "Связанные адаптеры не найдены.", "Nie znaleziono połączonych adapterów.", "adapter_no_linked_adapters"],
  adapter_health: ["Health", "Health", "状態", "健康状况", "Zustand", "État", "Stato", "Estado", "Estado", "Состояние", "Stan", "adapter_health"],
  adapter_serial: ["Adapter Serial", "Adapter Serial", "アダプターのシリアル番号", "适配器序列号", "Adapter-Seriennummer", "N° de série de l'adaptateur", "Seriale adattatore", "Número de série do adaptador", "Serie del adaptador", "Серийный номер адаптера", "Numer seryjny adaptera", "adapter_serial"],
  adapter_module_type: ["Module Type", "Module Type", "モジュールタイプ", "模块类型", "Modultyp", "Type de module", "Tipo di modulo", "Tipo de módulo", "Tipo de módulo", "Тип модуля", "Typ modułu", "adapter_module_type"],
  adapter_type: ["Adapter Type", "Adapter Type", "アダプタータイプ", "适配器类型", "Adaptertyp", "Type d'adaptateur", "Tipo di adattatore", "Tipo de adaptador", "Tipo de adaptador", "Тип адаптера", "Typ adaptera", "adapter_type"],
  adapter_linked_device: ["Linked Device", "Linked Device", "リンクされたデバイス", "关联设备", "Verknüpftes Gerät", "Appareil lié", "Dispositivo collegato", "Dispositivo associado", "Dispositivo vinculado", "Связанное устройство", "Połączone urządzenie", "adapter_linked_device"],
  adapter_firmware: ["Firmware", "Firmware", "ファームウェア", "固件", "Firmware", "Micrologiciel", "Firmware", "Firmware", "Firmware", "Прошивка", "Oprogramowanie układowe", "adapter_firmware"],
  adapter_calibration_due: ["Calibration Due", "Calibration Due", "校正期限", "校准到期", "Kalibrierung fällig", "Étalonnage à effectuer", "Calibrazione in scadenza", "Calibração devida", "Calibración pendiente", "Срок калибровки", "Termin kalibracji", "adapter_calibration_due"],
  adapter_last_result: ["Last Result", "Last Result", "最後の結果", "上次结果", "Letztes Ergebnis", "Dernier résultat", "Ultimo risultato", "Último resultado", "Último resultado", "Последний результат", "Ostatni wynik", "adapter_last_result"],
  adapter_tip_wear_counter: ["Tip Wear Counter", "Tip Wear Counter", "先端摩耗カウンター", "探头磨损计数器", "Spitzenverschleißzähler", "Compteur d'usure de pointe", "Contatore usura punta", "Contador de desgaste da ponta", "Contador de desgaste de punta", "Счетчик износа наконечника", "Licznik zużycia końcówki", "adapter_tip_wear_counter"],
  adapter_management_title: ["Adapter Management", "Adapter Management", "アダプター管理", "适配器管理", "Adapterverwaltung", "Gestion des adaptateurs", "Gestione adattatori", "Gestão de adaptadores", "Gestión de adaptadores", "Управление адаптерами", "Zarządzanie adapterami", "adapter_management_title"],
  adapter_details_title: ["Adapter Details", "Adapter Details", "アダプターの詳細", "适配器详细信息", "Adapterdetails", "Détails de l'adaptateur", "Dettagli adattatore", "Detalhes do adaptador", "Detalles del adaptador", "Сведения об адаптере", "Szczegóły adaptera", "adapter_details_title"],
  adapter_details_loading: ["Loading adapter details...", "Loading adapter details...", "アダプターの詳細を読み込み中...", "正在加载适配器详细信息...", "Adapterdetails werden geladen...", "Chargement des détails de l'adaptateur...", "Caricamento dettagli adattatore...", "A carregar detalhes do adaptador...", "Cargando detalles del adaptador...", "Загрузка сведений об адаптере...", "Ładowanie szczegółów adaptera...", "adapter_details_loading"],
  adapter_details_unavailable: ["Adapter details are not available.", "Adapter details are not available.", "アダプターの詳細は利用できません。", "适配器详细信息不可用。", "Adapterdetails sind nicht verfügbar.", "Les détails de l'adaptateur ne sont pas disponibles.", "I dettagli dell'adattatore non sono disponibili.", "Os detalhes do adaptador não estão disponíveis.", "Los detalles del adaptador no están disponibles.", "Сведения об адаптере недоступны.", "Szczegóły adaptera są niedostępne.", "adapter_details_unavailable"],
  adapter_calibration_date: ["Calibration Date", "Calibration Date", "校正日", "校准日期", "Kalibrierungsdatum", "Date d'étalonnage", "Data di calibrazione", "Data de calibração", "Fecha de calibración", "Дата калибровки", "Data kalibracji", "adapter_calibration_date"],
  adapter_location: ["Location", "Location", "場所", "位置", "Standort", "Emplacement", "Posizione", "Localização", "Ubicación", "Местоположение", "Lokalizacja", "adapter_location"],
  adapter_delete_confirm_title: ["Delete Adapter", "Delete Adapter", "アダプターを削除", "删除适配器", "Adapter löschen", "Supprimer l'adaptateur", "Elimina adattatore", "Eliminar adaptador", "Eliminar adaptador", "Удалить адаптер", "Usuń adapter", "adapter_delete_confirm_title"],
  adapter_delete_confirm_text: ["Are you sure you want to delete adapter <b>${adaptername}</b>?", "Are you sure you want to delete adapter <b>${adaptername}</b>?", "アダプター「<b>${adaptername}</b>」を削除してもよろしいですか?", "确定要删除适配器 <b>${adaptername}</b> 吗？", "Möchten Sie den Adapter <b>${adaptername}</b> wirklich löschen?", "Êtes-vous sûr de vouloir supprimer l'adaptateur <b>${adaptername}</b> ?", "Eliminare l'adattatore <b>${adaptername}</b>?", "Tem a certeza de que pretende eliminar o adaptador <b>${adaptername}</b>?", "¿Seguro que desea eliminar el adaptador <b>${adaptername}</b>?", "Действительно удалить адаптер <b>${adaptername}</b>?", "Czy na pewno chcesz usunąć adapter <b>${adaptername}</b>?", "adapter_delete_confirm_text"],
  adapter_delete_successful_toast: ["Adapter deleted successfully", "Adapter deleted successfully", "アダプターが正常に削除されました", "适配器已成功删除", "Adapter erfolgreich gelöscht", "L'adaptateur a été supprimé", "Adattatore eliminato correttamente", "Adaptador eliminado com sucesso", "Adaptador eliminado correctamente", "Адаптер удален", "Adapter został usunięty", "adapter_delete_successful_toast"],
  adapter_delete_unsuccessful_toast: ["Failed to delete the adapter", "Failed to delete the adapter", "アダプターを削除できませんでした", "无法删除适配器", "Adapter konnte nicht gelöscht werden", "Impossible de supprimer l'adaptateur", "Impossibile eliminare l'adattatore", "Não foi possível eliminar o adaptador", "No se pudo eliminar el adaptador", "Не удалось удалить адаптер", "Nie udało się usunąć adaptera", "adapter_delete_unsuccessful_toast"],
  smart_flag_label_insertion_loss_margin: ["Insertion Loss Margin", "Insertion Loss Margin", "挿入損失マージン", "插入损耗余量", "Einfügedämpfungsreserve", "Marge de perte d'insertion", "Margine di perdita per inserzione", "Margem de perda de inserção", "Margen de atenuación", "Запас вносимых потерь", "Margines straty wtrąceniowej", "smart_flag_label_insertion_loss_margin"],
  smart_flag_label_acr_f_margin: ["ACR-F Margin", "ACR-F Margin", "ACR-Fマージン", "ACR-F 余量", "ACR-F-Reserve", "Marge ACR-F", "Margine ACR-F", "Margem ACR-F", "Margen ACR-F", "Запас ACR-F", "Margines ACR-F", "smart_flag_label_acr_f_margin"],
  smart_flag_label_multimode_fiber_type: ["Multimode Fiber Type", "Multimode Fiber Type", "マルチモード光ファイバーの種類", "多模光纤类型", "Multimode-Glasfasertyp", "Type de fibre multimode", "Tipo di fibra multimodale", "Tipo de fibra multimodo", "Tipo de fibra multimodo", "Тип многомодового волокна", "Typ światłowodu wielomodowego", "smart_flag_label_multimode_fiber_type"],
  smart_flag_label_singlemode_fiber_type: ["Single-mode Fiber Type", "Single-mode Fiber Type", "シングルモード光ファイバーの種類", "单模光纤类型", "Singlemode-Glasfasertyp", "Type de fibre monomode", "Tipo di fibra monomodale", "Tipo de fibra monomodo", "Tipo de fibra monomodo", "Тип одномодового волокна", "Typ światłowodu jednomodowego", "smart_flag_label_singlemode_fiber_type"],
  smart_flag_label_test_cord_reference: ["Test Cord Reference", "Test Cord Reference", "テストコードの基準", "测试跳线参考", "Testkabelreferenz", "Référence de cordon de test", "Riferimento del cavo di prova", "Referência do cabo de teste", "Referencia del cordón de prueba", "Эталонный тестовый шнур", "Referencja przewodu testowego", "smart_flag_label_test_cord_reference"],
  smart_flag_label_adapter_count: ["Adapter Count", "Adapter Count", "アダプター数", "适配器数量", "Adapteranzahl", "Nombre d'adaptateurs", "Numero di adattatori", "Número de adaptadores", "Número de adaptadores", "Количество адаптеров", "Liczba adapterów", "smart_flag_label_adapter_count"],
  smart_flag_label_splice_count: ["Splice Count", "Splice Count", "融着接続数", "熔接数量", "Spleißanzahl", "Nombre d'épissures", "Numero di giunzioni", "Número de emendas", "Número de empalmes", "Количество сварок", "Liczba spawów", "smart_flag_label_splice_count"],
  smart_flag_label_wavelength_count: ["Wavelength Count", "Wavelength Count", "波長数", "波长数量", "Wellenlängenanzahl", "Nombre de longueurs d'onde", "Numero di lunghezze d'onda", "Número de comprimentos de onda", "Número de longitudes de onda", "Количество длин волн", "Liczba długości fal", "smart_flag_label_wavelength_count"],
  subscription_feature_landing_page: ["AnyWARE Landing Page", "AnyWARE Landing Page", "AnyWARE ランディングページ", "AnyWARE 主页", "AnyWARE-Startseite", "Page d'accueil AnyWARE", "Pagina iniziale AnyWARE", "Página inicial do AnyWARE", "Página de inicio de AnyWARE", "Главная страница AnyWARE", "Strona główna AnyWARE", "subscription_feature_landing_page"],
  subscription_feature_book_services: ["Book services/repairs via AnyWARE", "Book services/repairs via AnyWARE", "AnyWARE でサービス/修理を予約", "通过 AnyWARE 预约服务/维修", "Service/Reparaturen über AnyWARE buchen", "Réserver des services/réparations via AnyWARE", "Prenota assistenza/riparazioni tramite AnyWARE", "Marcar serviços/reparações através do AnyWARE", "Reservar servicios/reparaciones mediante AnyWARE", "Заказ услуг/ремонта через AnyWARE", "Rezerwowanie usług/napraw przez AnyWARE", "subscription_feature_book_services"],
  subscription_feature_teamviewer_link: ["TeamViewer Link", "TeamViewer Link", "TeamViewer リンク", "TeamViewer 链接", "TeamViewer-Link", "Lien TeamViewer", "Link TeamViewer", "Ligação TeamViewer", "Enlace TeamViewer", "Ссылка TeamViewer", "Łącze TeamViewer", "subscription_feature_teamviewer_link"],
  subscription_feature_health_check_status: ["Health Check Status", "Health Check Status", "ヘルスチェックの状態", "运行状况检查状态", "Status der Zustandsprüfung", "État du contrôle de santé", "Stato del controllo integrità", "Estado da verificação de saúde", "Estado de la comprobación de estado", "Статус проверки состояния", "Stan kontroli kondycji", "subscription_feature_health_check_status"],
  subscription_feature_qr_code_label: ["Generate QR Code Label", "Generate QR Code Label", "QR コードラベルを生成", "生成二维码标签", "QR-Code-Etikett erstellen", "Générer une étiquette QR code", "Genera etichetta codice QR", "Gerar etiqueta de código QR", "Generar etiqueta de código QR", "Создать этикетку с QR-кодом", "Generuj etykietę z kodem QR", "subscription_feature_qr_code_label"],
  subscription_feature_poe_derating: ["PoE Derating via AnyWARE", "PoE Derating via AnyWARE", "AnyWARE による PoE ディレーティング", "通过 AnyWARE 进行 PoE 降额", "PoE-Derating über AnyWARE", "Déclassement PoE via AnyWARE", "Derating PoE tramite AnyWARE", "Redução de PoE via AnyWARE", "Reducción de PoE mediante AnyWARE", "Снижение мощности PoE через AnyWARE", "Obniżanie mocy PoE przez AnyWARE", "subscription_feature_poe_derating"],
  subscription_feature_fiber_loss_calculator: ["Fiber Loss Calculator", "Fiber Loss Calculator", "光ファイバー損失計算機", "光纤损耗计算器", "Glasfaser-Dämpfungsrechner", "Calculateur de perte de fibre", "Calcolatore della perdita in fibra", "Calculadora de perda de fibra", "Calculadora de pérdida de fibra", "Калькулятор потерь в оптоволокне", "Kalkulator strat światłowodowych", "subscription_feature_fiber_loss_calculator"],
  subscription_feature_link_budget_calculator: ["Link Budget Calculator", "Link Budget Calculator", "リンクバジェット計算機", "链路预算计算器", "Link-Budget-Rechner", "Calculateur de budget de liaison", "Calcolatore del budget del collegamento", "Calculadora de orçamento de enlace", "Calculadora de presupuesto de enlace", "Калькулятор бюджета линии", "Kalkulator budżetu łącza", "subscription_feature_link_budget_calculator"],
  subscription_feature_multimode_bandwidth_calculator: ["Multimode Bandwidth Calculator", "Multimode Bandwidth Calculator", "マルチモード帯域幅計算機", "多模带宽计算器", "Multimode-Bandbreitenrechner", "Calculateur de bande passante multimode", "Calcolatore di larghezza di banda multimodale", "Calculadora de largura de banda multimodo", "Calculadora de ancho de banda multimodo", "Калькулятор полосы пропускания многомодового волокна", "Kalkulator przepustowości wielomodowej", "subscription_feature_multimode_bandwidth_calculator"],
  subscription_upgrade_choose_subscription: [
    "Choose a Subscription", "Choose a Subscription", "サブスクリプションを選択", "选择订阅", "Abonnement auswählen", "Choisir un abonnement", "Scegli un abbonamento", "Escolher uma subscrição", "Elegir una suscripción", "Выберите подписку", "Wybierz subskrypcję", "subscription_upgrade_choose_subscription"
  ],
  subscription_upgrade_current_plan: [
    "Current Plan", "Current Plan", "現在のプラン", "当前方案", "Aktueller Tarif", "Forfait actuel", "Piano attuale", "Plano atual", "Plan actual", "Текущий план", "Obecny plan", "subscription_upgrade_current_plan"
  ],
  subscription_upgrade_upgrade: [
    "Upgrade", "Upgrade", "アップグレード", "升级", "Upgrade", "Passer à Plus", "Passa a Plus", "Atualizar", "Actualizar", "Улучшить план", "Przejdź na Plus", "subscription_upgrade_upgrade"
  ],
  subscription_upgrade_upgrade_now: [
    "Upgrade Now", "Upgrade Now", "今すぐアップグレード", "立即升级", "Jetzt upgraden", "Passer à Plus maintenant", "Passa a Plus ora", "Atualizar agora", "Actualizar ahora", "Перейти на Plus", "Przejdź na Plus teraz", "subscription_upgrade_upgrade_now"
  ],
  subscription_upgrade_view_only: [
    "View Only", "View Only", "閲覧のみ", "仅查看", "Nur ansehen", "Consultation uniquement", "Sola lettura", "Apenas consulta", "Solo lectura", "Только просмотр", "Tylko podgląd", "subscription_upgrade_view_only"
  ],
  subscription_upgrade_basic_description: [
    "Everything you need to manage, edit and share test results.", "Everything you need to manage, edit and share test results.", "テスト結果の管理、編集、共有に必要な機能をすべて備えています。", "提供管理、编辑和共享测试结果所需的全部功能。", "Alles, was Sie zum Verwalten, Bearbeiten und Teilen von Testergebnissen benötigen.", "Tout ce dont vous avez besoin pour gérer, modifier et partager les résultats de test.", "Tutto ciò che serve per gestire, modificare e condividere i risultati dei test.", "Tudo o que precisa para gerir, editar e partilhar resultados de testes.", "Todo lo que necesita para gestionar, editar y compartir resultados de pruebas.", "Всё необходимое для управления, редактирования и обмена результатами тестов.", "Wszystko, czego potrzebujesz do zarządzania, edycji i udostępniania wyników testów.", "subscription_upgrade_basic_description"
  ],
  subscription_upgrade_plus_description: [
    "AnyWARE Plus unlocks the full value of your test data with powerful new analytics and industry-first capabilities. It transforms data into actionable insight, giving you the visibility to make smarter, faster decisions.",
    "AnyWARE Plus unlocks the full value of your test data with powerful new analytics and industry-first capabilities. It transforms data into actionable insight, giving you the visibility to make smarter, faster decisions.",
    "AnyWARE Plus は、高度な分析と業界初の機能でテストデータの価値を最大限に引き出します。データを実用的な情報に変え、より的確で迅速な判断を支援します。",
    "AnyWARE Plus 通过强大的新分析功能和行业首创功能，充分释放测试数据的价值。它将数据转化为可用于行动的洞察，帮助您更明智、更迅速地做出决策。",
    "AnyWARE Plus erschließt den vollen Wert Ihrer Testdaten mit leistungsstarken Analysen und branchenweit neuen Funktionen. Es verwandelt Daten in verwertbare Erkenntnisse und hilft Ihnen, fundierter und schneller zu entscheiden.",
    "AnyWARE Plus révèle toute la valeur de vos données de test grâce à de puissantes analyses et à des fonctionnalités inédites dans le secteur. Il transforme les données en informations exploitables pour prendre des décisions plus éclairées et plus rapides.",
    "AnyWARE Plus valorizza i dati dei test con nuove potenti analisi e funzionalità innovative nel settore. Trasforma i dati in informazioni utilizzabili per prendere decisioni migliori e più rapide.",
    "O AnyWARE Plus revela todo o valor dos seus dados de teste com novas análises avançadas e funcionalidades pioneiras no setor. Transforma dados em informações úteis para tomar decisões mais informadas e rápidas.",
    "AnyWARE Plus aprovecha todo el valor de sus datos de pruebas con nuevos análisis avanzados y funciones pioneras en el sector. Convierte los datos en información útil para tomar decisiones más acertadas y rápidas.",
    "AnyWARE Plus раскрывает ценность данных тестирования благодаря мощной аналитике и новым для отрасли возможностям. Он превращает данные в полезную информацию для более обоснованных и быстрых решений.",
    "AnyWARE Plus pozwala w pełni wykorzystać dane testowe dzięki zaawansowanej analityce i nowatorskim funkcjom. Przekształca dane w przydatne informacje, pomagając podejmować trafniejsze i szybsze decyzje.",
    "subscription_upgrade_plus_description"
  ],
  subscription_upgrade_supported_devices: [
    "Only available for LanTEK IV and IV-S, SignalTEK QT and SignalTEK 10G devices", "Only available for LanTEK IV and IV-S, SignalTEK QT and SignalTEK 10G devices", "LanTEK IV、IV-S、SignalTEK QT、SignalTEK 10G デバイスのみ対応", "仅适用于 LanTEK IV、IV-S、SignalTEK QT 和 SignalTEK 10G 设备", "Nur für LanTEK IV und IV-S, SignalTEK QT und SignalTEK 10G verfügbar", "Disponible uniquement pour les appareils LanTEK IV et IV-S, SignalTEK QT et SignalTEK 10G", "Disponibile solo per i dispositivi LanTEK IV e IV-S, SignalTEK QT e SignalTEK 10G", "Disponível apenas para dispositivos LanTEK IV e IV-S, SignalTEK QT e SignalTEK 10G", "Disponible solo para dispositivos LanTEK IV y IV-S, SignalTEK QT y SignalTEK 10G", "Доступно только для устройств LanTEK IV и IV-S, SignalTEK QT и SignalTEK 10G", "Dostępne tylko dla urządzeń LanTEK IV i IV-S, SignalTEK QT oraz SignalTEK 10G", "subscription_upgrade_supported_devices"
  ],
  subscription_upgrade_monthly_per_device: [
    "${amount}/month per device registered", "${amount}/month per device registered", "登録デバイス 1 台あたり月額 ${amount}", "每台注册设备每月 ${amount}", "${amount}/Monat je registriertem Gerät", "${amount}/mois par appareil enregistré", "${amount}/mese per dispositivo registrato", "${amount}/mês por dispositivo registado", "${amount}/mes por dispositivo registrado", "${amount}/месяц за зарегистрированное устройство", "${amount}/miesiąc za zarejestrowane urządzenie", "subscription_upgrade_monthly_per_device"
  ],
  subscription_upgrade_starting_price: [
    "From ${amount}/month per device registered", "From ${amount}/month per device registered", "登録デバイス 1 台あたり月額 ${amount} から", "每台注册设备每月低至 ${amount}", "Ab ${amount}/Monat je registriertem Gerät", "À partir de ${amount}/mois par appareil enregistré", "Da ${amount}/mese per dispositivo registrato", "Desde ${amount}/mês por dispositivo registado", "Desde ${amount}/mes por dispositivo registrado", "От ${amount}/месяц за зарегистрированное устройство", "Od ${amount}/miesiąc za zarejestrowane urządzenie", "subscription_upgrade_starting_price"
  ],
  subscription_upgrade_per_device_pricing: [
    "Monthly pricing per registered device", "Monthly pricing per registered device", "登録デバイスごとの月額料金", "按注册设备计算月费", "Monatliche Preise je registriertem Gerät", "Tarif mensuel par appareil enregistré", "Prezzo mensile per dispositivo registrato", "Preço mensal por dispositivo registado", "Precio mensual por dispositivo registrado", "Ежемесячная оплата за зарегистрированное устройство", "Cena miesięczna za zarejestrowane urządzenie", "subscription_upgrade_per_device_pricing"
  ],
  subscription_upgrade_sync_data: ["Sync Data", "Sync Data", "データを同期", "同步数据", "Daten synchronisieren", "Synchroniser les données", "Sincronizza dati", "Sincronizar dados", "Sincronizar datos", "Синхронизация данных", "Synchronizacja danych", "subscription_upgrade_sync_data"],
  subscription_upgrade_manage_projects: ["Manage Projects", "Manage Projects", "プロジェクトを管理", "管理项目", "Projekte verwalten", "Gérer les projets", "Gestisci progetti", "Gerir projetos", "Gestionar proyectos", "Управление проектами", "Zarządzanie projektami", "subscription_upgrade_manage_projects"],
  subscription_upgrade_create_reports: ["Create Reports", "Create Reports", "レポートを作成", "创建报告", "Berichte erstellen", "Créer des rapports", "Crea rapporti", "Criar relatórios", "Crear informes", "Создание отчетов", "Tworzenie raportów", "subscription_upgrade_create_reports"],
  subscription_upgrade_preconfigure_projects: ["Pre-configure Projects", "Pre-configure Projects", "プロジェクトを事前設定", "预配置项目", "Projekte vorkonfigurieren", "Préconfigurer les projets", "Preconfigura progetti", "Pré-configurar projetos", "Preconfigurar proyectos", "Предварительная настройка проектов", "Wstępna konfiguracja projektów", "subscription_upgrade_preconfigure_projects"],
  subscription_upgrade_book_calibration_repair: ["Book a Calibration and Repair", "Book a Calibration and Repair", "校正と修理を予約", "预约校准和维修", "Kalibrierung und Reparatur buchen", "Réserver un étalonnage et une réparation", "Prenota calibrazione e riparazione", "Marcar calibração e reparação", "Reservar calibración y reparación", "Заказать калибровку и ремонт", "Rezerwacja kalibracji i naprawy", "subscription_upgrade_book_calibration_repair"],
  subscription_upgrade_tester_health_check: ["Tester Health Check", "Tester Health Check", "テスターの状態確認", "测试仪健康检查", "Tester-Zustandsprüfung", "Contrôle de l'état du testeur", "Controllo dello stato del tester", "Verificação do estado do equipamento", "Comprobación del estado del comprobador", "Проверка состояния тестера", "Kontrola stanu testera", "subscription_upgrade_tester_health_check"],
  subscription_upgrade_lantek_only: ["LanTEK IV only", "LanTEK IV only", "LanTEK IV のみ", "仅限 LanTEK IV", "Nur LanTEK IV", "LanTEK IV uniquement", "Solo LanTEK IV", "Apenas LanTEK IV", "Solo LanTEK IV", "Только LanTEK IV", "Tylko LanTEK IV", "subscription_upgrade_lantek_only"],
  subscription_upgrade_geolocation: ["Geolocation of Devices", "Geolocation of Devices", "デバイスの位置情報", "设备地理位置", "Geolokalisierung von Geräten", "Géolocalisation des appareils", "Geolocalizzazione dei dispositivi", "Geolocalização dos dispositivos", "Geolocalización de dispositivos", "Геолокация устройств", "Lokalizacja urządzeń", "subscription_upgrade_geolocation"],
  subscription_upgrade_geolocation_protect: [
    "Protect valuable test equipment by providing visibility of device locations and security controls.", "Protect valuable test equipment by providing visibility of device locations and security controls.", "デバイスの位置情報とセキュリティ管理で、大切なテスト機器を保護します。", "通过设备位置可视化和安全控制，保护贵重的测试设备。", "Schützen Sie wertvolle Testgeräte durch Standortübersicht und Sicherheitsfunktionen.", "Protégez vos équipements de test grâce à la visibilité de leur emplacement et aux contrôles de sécurité.", "Proteggi le apparecchiature di test grazie alla visibilità della posizione e ai controlli di sicurezza.", "Proteja os equipamentos de teste com visibilidade da localização e controlos de segurança.", "Proteja los equipos de prueba con visibilidad de su ubicación y controles de seguridad.", "Защитите ценное тестовое оборудование с помощью данных о местоположении и средств безопасности.", "Chroń cenny sprzęt testowy dzięki informacji o lokalizacji i funkcjom bezpieczeństwa.", "subscription_upgrade_geolocation_protect"
  ],
  subscription_upgrade_geolocation_track: [
    "Track device locations through the AnyWARE Cloud platform.", "Track device locations through the AnyWARE Cloud platform.", "AnyWARE Cloud でデバイスの位置を確認できます。", "通过 AnyWARE Cloud 平台跟踪设备位置。", "Verfolgen Sie Gerätestandorte über AnyWARE Cloud.", "Suivez l'emplacement des appareils via AnyWARE Cloud.", "Segui la posizione dei dispositivi tramite AnyWARE Cloud.", "Acompanhe a localização dos dispositivos através do AnyWARE Cloud.", "Siga la ubicación de los dispositivos a través de AnyWARE Cloud.", "Отслеживайте местоположение устройств через AnyWARE Cloud.", "Śledź lokalizację urządzeń na platformie AnyWARE Cloud.", "subscription_upgrade_geolocation_track"
  ],
  subscription_upgrade_geolocation_fleet: [
    "Maintain visibility of your tester fleet across multiple sites and users.", "Maintain visibility of your tester fleet across multiple sites and users.", "複数の現場やユーザーにわたるテスターの状況を把握できます。", "了解分布在多个站点和用户之间的测试仪情况。", "Behalten Sie Ihre Tester über mehrere Standorte und Nutzer hinweg im Blick.", "Gardez une vue d'ensemble de vos testeurs sur plusieurs sites et utilisateurs.", "Mantieni una visione dei tester distribuiti tra più sedi e utenti.", "Mantenha uma visão dos equipamentos em vários locais e utilizadores.", "Mantenga la visibilidad de sus comprobadores en varias ubicaciones y usuarios.", "Контролируйте парк тестеров на разных объектах и у разных пользователей.", "Monitoruj testery używane w różnych lokalizacjach i przez różnych użytkowników.", "subscription_upgrade_geolocation_fleet"
  ],
  subscription_upgrade_device_lock: ["Device Lock & Unlock", "Device Lock & Unlock", "デバイスのロックと解除", "设备锁定与解锁", "Geräte sperren und entsperren", "Verrouillage et déverrouillage des appareils", "Blocco e sblocco dei dispositivi", "Bloqueio e desbloqueio de dispositivos", "Bloqueo y desbloqueo de dispositivos", "Блокировка и разблокировка устройств", "Blokowanie i odblokowanie urządzeń", "subscription_upgrade_device_lock"],
  subscription_upgrade_coming_soon: ["Coming soon", "Coming soon", "近日公開", "即将推出", "Demnächst verfügbar", "Bientôt disponible", "Prossimamente", "Disponível em breve", "Próximamente", "Скоро", "Wkrótce", "subscription_upgrade_coming_soon"],
  subscription_upgrade_device_lock_protect: [
    "Protect assets from misuse with remote device locking.", "Protect assets from misuse with remote device locking.", "リモートロックで機器の不正使用を防ぎます。", "通过远程设备锁定，防止设备被滥用。", "Schützen Sie Geräte durch Fernsperrung vor Missbrauch.", "Protégez vos équipements contre les abus grâce au verrouillage à distance.", "Proteggi i dispositivi dall'uso improprio con il blocco da remoto.", "Proteja os equipamentos contra utilização indevida com bloqueio remoto.", "Proteja los equipos del uso indebido con el bloqueo remoto.", "Защитите оборудование от неправомерного использования с помощью удаленной блокировки.", "Chroń sprzęt przed niewłaściwym użyciem dzięki zdalnemu blokowaniu.", "subscription_upgrade_device_lock_protect"
  ],
  subscription_upgrade_device_lock_reduce_risk: [
    "Reduce the risk and impact of lost or stolen equipment.", "Reduce the risk and impact of lost or stolen equipment.", "機器の紛失や盗難のリスクと影響を軽減します。", "降低设备丢失或被盗的风险和影响。", "Verringern Sie Risiken und Folgen verlorener oder gestohlener Geräte.", "Réduisez les risques et les conséquences liés à la perte ou au vol d'équipements.", "Riduci il rischio e l'impatto dello smarrimento o del furto delle apparecchiature.", "Reduza o risco e o impacto da perda ou roubo de equipamentos.", "Reduzca el riesgo y el impacto de la pérdida o el robo de equipos.", "Снизьте риск и последствия потери или кражи оборудования.", "Ogranicz ryzyko i skutki zgubienia lub kradzieży sprzętu.", "subscription_upgrade_device_lock_reduce_risk"
  ],
  subscription_upgrade_preview_alt: ["AnyWARE Cloud device location map preview", "AnyWARE Cloud device location map preview", "AnyWARE Cloud のデバイス位置マップ", "AnyWARE Cloud 设备位置地图预览", "Vorschau der Gerätestandortkarte in AnyWARE Cloud", "Aperçu de la carte de localisation des appareils AnyWARE Cloud", "Anteprima della mappa di posizione dei dispositivi AnyWARE Cloud", "Pré-visualização do mapa de localização dos dispositivos AnyWARE Cloud", "Vista previa del mapa de ubicación de dispositivos de AnyWARE Cloud", "Предпросмотр карты местоположения устройств AnyWARE Cloud", "Podgląd mapy lokalizacji urządzeń AnyWARE Cloud", "subscription_upgrade_preview_alt"],
  subscription_upgrade_metrics: ["Organisation & Job Metrics", "Organization & Job Metrics", "組織とジョブの指標", "组织与任务指标", "Organisations- und Auftragskennzahlen", "Indicateurs d'organisation et de projets", "Metriche di organizzazione e lavori", "Métricas da organização e dos trabalhos", "Métricas de organización y trabajos", "Показатели организации и заданий", "Metryki organizacji i zadań", "subscription_upgrade_metrics"],
  subscription_upgrade_metrics_description: [
    "Turn AnyWARE Cloud data into actionable insights. Gain visibility across projects, customers, and teams to improve efficiency, reduce waste, and make smarter business decisions.",
    "Turn AnyWARE Cloud data into actionable insights. Gain visibility across projects, customers, and teams to improve efficiency, reduce waste, and make smarter business decisions.",
    "AnyWARE Cloud のデータを実用的な情報に変えます。プロジェクト、顧客、チーム全体の状況を把握し、効率化、無駄の削減、的確な判断に役立てます。",
    "将 AnyWARE Cloud 数据转化为可用于行动的洞察。了解项目、客户和团队的情况，提高效率、减少浪费并做出更明智的业务决策。",
    "Verwandeln Sie AnyWARE Cloud Daten in verwertbare Erkenntnisse. Überblicken Sie Projekte, Kunden und Teams, um effizienter zu arbeiten, Verschwendung zu reduzieren und bessere Entscheidungen zu treffen.",
    "Transformez les données AnyWARE Cloud en informations exploitables. Obtenez une vue sur les projets, clients et équipes pour améliorer l'efficacité, réduire le gaspillage et prendre de meilleures décisions.",
    "Trasforma i dati AnyWARE Cloud in informazioni utilizzabili. Ottieni visibilità su progetti, clienti e team per migliorare l'efficienza, ridurre gli sprechi e prendere decisioni migliori.",
    "Transforme os dados do AnyWARE Cloud em informações úteis. Ganhe visibilidade sobre projetos, clientes e equipas para melhorar a eficiência, reduzir desperdícios e tomar melhores decisões.",
    "Convierta los datos de AnyWARE Cloud en información útil. Obtenga visibilidad de proyectos, clientes y equipos para mejorar la eficiencia, reducir desperdicios y tomar mejores decisiones.",
    "Превращайте данные AnyWARE Cloud в полезную информацию. Анализируйте проекты, клиентов и команды, чтобы повысить эффективность, сократить потери и улучшить бизнес-решения.",
    "Przekształcaj dane AnyWARE Cloud w przydatne informacje. Analizuj projekty, klientów i zespoły, aby poprawiać efektywność, ograniczać straty i podejmować trafniejsze decyzje biznesowe.",
    "subscription_upgrade_metrics_description"
  ],
  subscription_upgrade_smart_flag: ["Smart Flag", "Smart Flag", "Smart Flag", "智能标志", "Smart Flag", "Smart Flag", "Smart Flag", "Smart Flag", "Smart Flag", "Smart Flag", "Smart Flag", "subscription_upgrade_smart_flag"],
  subscription_upgrade_smart_flag_description: [
    "Eliminate manual result checking with Smart Flags. Automated validation rules review thousands of test results against your project and customer requirements in seconds.",
    "Eliminate manual result checking with Smart Flags. Automated validation rules review thousands of test results against your project and customer requirements in seconds.",
    "Smart Flag で結果の手動確認を不要にします。自動検証ルールが数千件のテスト結果をプロジェクトや顧客の要件と照合し、数秒で確認します。",
    "使用智能标志，无需手动检查结果。自动验证规则可在几秒内根据项目和客户要求检查数千条测试结果。",
    "Ersetzen Sie manuelle Ergebnisprüfungen durch Smart Flags. Automatische Regeln prüfen in Sekunden Tausende Testergebnisse anhand Ihrer Projekt- und Kundenanforderungen.",
    "Éliminez la vérification manuelle des résultats avec Smart Flags. Des règles automatiques examinent des milliers de résultats selon les exigences du projet et du client en quelques secondes.",
    "Elimina il controllo manuale dei risultati con Smart Flags. Le regole automatiche verificano migliaia di risultati rispetto ai requisiti di progetto e del cliente in pochi secondi.",
    "Elimine a verificação manual de resultados com Smart Flags. Regras automáticas analisam milhares de resultados face aos requisitos do projeto e do cliente em segundos.",
    "Elimine la comprobación manual de resultados con Smart Flags. Las reglas automáticas revisan miles de resultados según los requisitos del proyecto y del cliente en segundos.",
    "Откажитесь от ручной проверки результатов со Smart Flags. Автоматические правила за секунды проверяют тысячи результатов на соответствие требованиям проекта и клиента.",
    "Wyeliminuj ręczne sprawdzanie wyników dzięki Smart Flags. Automatyczne reguły w kilka sekund sprawdzają tysiące wyników względem wymagań projektu i klienta.",
    "subscription_upgrade_smart_flag_description"
  ],
  subscription_upgrade_auto_archiving: ["Auto Archiving", "Auto Archiving", "自動アーカイブ", "自动归档", "Automatische Archivierung", "Archivage automatique", "Archiviazione automatica", "Arquivo automático", "Archivado automático", "Автоматическое архивирование", "Automatyczna archiwizacja", "subscription_upgrade_auto_archiving"],
  subscription_upgrade_auto_archiving_description: [
    "Keep your job list clean and focused by automatically moving inactive projects to an archive.", "Keep your job list clean and focused by automatically moving inactive projects to an archive.", "使用していないプロジェクトを自動でアーカイブし、ジョブ一覧を整理します。", "自动将非活动项目移至归档，保持任务列表整洁。", "Halten Sie Ihre Auftragsliste übersichtlich, indem inaktive Projekte automatisch archiviert werden.", "Gardez une liste de projets claire en archivant automatiquement les projets inactifs.", "Mantieni ordinato l'elenco dei lavori archiviando automaticamente i progetti inattivi.", "Mantenha a lista de trabalhos organizada, arquivando automaticamente projetos inativos.", "Mantenga ordenada la lista de trabajos archivando automáticamente los proyectos inactivos.", "Поддерживайте порядок в списке заданий, автоматически архивируя неактивные проекты.", "Utrzymuj porządek na liście zadań dzięki automatycznej archiwizacji nieaktywnych projektów.", "subscription_upgrade_auto_archiving_description"
  ],
};

export default subscriptionTranslations;
